import { useState, useContext, useCallback } from "react";
import { EmissaoContext } from "../contexts/EmissaoContext";
import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import { PainelNfeContext } from "../contexts/PainelNfeContext";

import { formatDate } from "../../../../utils/formatDate";

import { notify } from "../../../../utils/notify";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { customValidation, validNotNull } from "../../../../utils/validations";
import {
  createNota,
  financialType,
  findNotas,
  updateNota,
} from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import MaskService from "../../../../utils/mask/maskService";
import Swal from "sweetalert2";
import {
  findTributacoes,
  findTributacoesByIdProductOrNcms,
} from "../../../../repositories/qerpapi/erp/nf/v1/TributacaoRepository";
import { transmit } from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import useCalculosTributacao from "./RulesEmissaoCalculosTributacao";
import {
  findCliente,
  updateCliente,
} from "../../../../repositories/qerpapi/erp/prouser/v1/ClienteRepository";
import { findFornecedor } from "../../../../repository/ERP/prouser/FornecedorService";
import {
  findProdutos,
  findProdutosAlternativeFormatted,
  itensNfAutoMontagem,
} from "../../../../repositories/qerpapi/erp/estoque/v1/ProdutosRepository";
import { MinClienteContext } from "../contexts/MinClienteContext";
import useRulesEmissaoSubmit from "./RulesEmissaoSubmit";
import { GlobalVariables } from "../../../../GlobalVariables";
import { findByCEP } from "../../../../repository/services/BigDataService";
import { findAnpByCode } from "../../../../repositories/qerpapi/outros/CodigoAnpRepository";
import {
  findOperadoras,
  findOperadorasPorBandeira,
} from "../../../../repositories/qerpapi/erp/financeiro/OperadorasRepository";
import { find } from "../../../../repositories/qerpapi/erp/RouteRepository";

import { updateDiControle } from "../../../../repositories/qerpapi/erp/nf/v1/DiControleRepository";

import { Estados } from "../../../../repositories/qerpapi/erp/prouser/static/Estados";
import { getSeries } from "../../../../repositories/qerpapi/v3/serie/SerieRepository";
import { findVendas } from "../../../../repositories/qerpapi/erp/vendas/v1/VendasRepository";
import moment from "moment";

export default function useEmissaoController() {
  const { setCcDescription, setCcError } = useContext(PainelNfeContext);

  const { setGeneralIe, setGeneralIeIndication } =
    useContext(MinClienteContext);

  const {
    setVisualizationOnly,
    setForceProduction,
    forceProduction,
    nfeId,
    setNfeId,
    nfeListTypeNf,
    setNfeLotes,
    nfeListOperations,
    nfeListPresentOperations,
    nfeListFinnally,
    nfeListYesOrNo,
    nfeListPaymentMethod,
    nfeListPaymentIndicator,
    nfeListBandeiras,
    nfeListPaymentTypeIntegration,
    nfeListModalities,
    nfeListStockLocation,
    nfeMontageType,
    setNfeMontageType,
    nfeFinancialIssue,
    setNfeFinancialIssue,
    sender,
    setSender,
    senderIe,
    setSenderIe,
    setNfeError,
    nfeListCfop,
    setHeaderNfe,
    headerIssueType,
    setHeaderIssueType,
    headerSeries,
    setHeaderSeries,
    headerIssueDate,
    setHeaderIssueDate,
    setHeaderDemandNumber,
    setHeaderAccessKey,
    headerTypeNfe,
    setHeaderTypeNfe,
    headerCfop,
    setHeaderCfop,
    headerOperationNature,
    setHeaderOperationNature,
    headerPresentOperation,
    setHeaderPresentOperation,
    headerFinalCostumer,
    setHeaderFinalCostumer,
    headerOperation,
    setHeaderOperation,
    headerFinnally,
    setHeaderFinnally,
    headerIeTax,
    setHeaderIeTax,
    headerPurchaseOrder,
    setHeaderPurchaseOrder,
    headerPurchaseContract,
    setHeaderPurchaseContract,
    senderClifor,
    setSenderClifor,
    senderId,
    senderUfLabel,
    setSenderUfLabel,
    setSenderBillingComplement,
    senderDeliveryNumber,
    setSenderDeliveryNumber,
    setSenderId,
    senderCountryCode,
    setSenderCountryCode,
    senderCityCode,
    setSenderCityCode,
    senderName,
    setSenderName,
    senderCnpj,
    setSenderCnpj,
    senderAddress,
    setSenderAddres,
    senderComplement,
    setSenderComplement,
    setSenderNumber,
    senderDistrict,
    setSenderDistrict,
    senderCity,
    setSenderCity,
    setSenderUf,
    senderCep,
    setSenderCep,
    senderPhone,
    setSenderPhone,
    senderMail,
    setSenderMail,
    senderCheckBilling,
    setSenderCheckBilling,
    senderBillingAddress,
    setSenderBillingAddress,
    senderBillingNumber,
    setSenderBillingNumber,
    senderBillingDistrict,
    setSenderBillingDistrict,
    senderBillingCity,
    setSenderBillingCity,
    setSenderBillingUf,
    setSenderBillingCep,
    senderCheckDelivery,
    setSenderCheckDelivery,
    senderDeliveryList,
    setSenderDeliveryList,
    senderDeliveryAddress,
    setSenderDeliveryAddress,
    senderDeliveryDistrict,
    setSenderDeliveryDistrict,
    setSenderDeliveryCity,
    senderDeliveryUf,
    setSenderDeliveryUf,
    senderDeliveryCity,
    setSenderDeliveryCodeCity,
    senderDeliveryCep,
    setSenderDeliveryCep,
    setSenderDeliveryComplement,
    itensTable,
    setItensTable,
    itensTotalValueIcms,
    setItensTotalValueIcms,
    itensTotalBaseIcms,
    setItensTotalBaseIcms,
    setItensTotalIcmsFcp,
    setItensTotalIcmsDes,
    itensTotalValueSt,
    setItensTotalValueSt,
    itensTotalBaseSt,
    setItensTotalBaseSt,
    setItensTotalStFcp,
    setItensTotalStWithheld,
    itensTotalValueIpi,
    setItensTotalValueIpi,
    itensTotalIpiReturned,
    setItensTotalIpiReturned,
    itensTotalValuePis,
    setItensTotalValuePis,
    itensTotalValueCofins,
    setItensTotalValueCofins,
    setItensTotalValueCustoms,
    itensTotalValueII,
    setItensTotalValueII,
    itensTotalFreight,
    setItensTotalFreight,
    itensTotalSafe,
    setItensTotalSafe,
    itensTotalOthers,
    setItensTotalOthers,
    itensTotalDiscount,
    setItensTotalDiscount,
    chargeValue,
    setChargeValue,
    paymentValue,
    setPaymentValue,
    setItensTotal,
    itensTotalProductValue,
    setItensTotalProductValue,
    itensTotalNfe,
    setItensTotalNfe,
    pagtoTableCobranca,
    setPagtoTableCobranca,
    pagtoTableFormaPagto,
    setPagtoTableFormaPagto,
    setTransp,
    transpModality,
    setTranspModality,
    transpId,
    setTranspId,
    transpCnpj,
    setTranspCnpj,
    transpName,
    setTranspName,
    transpIe,
    setTranspIe,
    transpRntc,
    setTranspRntc,
    transpAddress,
    setTranspAddress,
    transpUf,
    setTranspUf,
    transpCity,
    setTranspCity,
    setTranspCityCode,
    transpBoardcar,
    setTranspBoardcar,
    transpBoardcarUf,
    setTranspBoardcarUf,
    transpTableSize,
    setTranspTableSize,
    setObsText,
    obsTextCreditRate,
    setObsTextCreditRate,
    obsTextCFOP,
    setObsTextCFOP,
    obsTextComplemento,
    setObsTextComplemento,
    docTable,
    setDocTable,
    setMainLoading,
    setNfeStatus,
    idsCrsMontage,
    setIdsCrsMontage,
    headerIntermedCnpj,
    setHeaderIntermedCnpj,
    headerIdentifierIntermed,
    setHeaderIdentifierIntermed,
    headerIndicatorIntermed,
    setHeaderIndicatorIntermed,
    nfeListIntermed,
    nfeSales,
    setNfeSales,
    headerTime,
    setHeaderTime,
    headerDateJL,
    setHeaderDateJL,
    headerIssueTime,
    setHeaderIssueTime,
    senderIndicationIe,
    setSenderIndicationIe,
    senderListIndicationIe,
    updateSender,
    nfeMontageSubtype,
    setNfeMontageSubtype,
    setNfeValidXml,
    enableEndereco,
    setEnableEndereco,
    enableBillingEdit,
    setEnableBillingEdit,
    enableDeliveryEdit,
    setEnableDeliveryEdit,
    listUf,
    listCounty,
    senderNumber,
    setTranspNumber,
    transpNumber,
    diImpWayOf,
    setDiImpWayOf,
    setDiDeclarationDate,
    setDiDeclarationUf,
    setDiDeclarationCity,
    setDiDeclarationDateDes,
    setDiDeclarationDrawback,
    setDiDeclarationDiNumber,
    diIntermediaryType,
    setDiIntermediaryType,
    setAcquirerUf,
    diAcquirerUf,
    setAcquirerDocument,
    diAcquirerDocument,
    setSaveBlocked,
    setObsBd,
    headerPurchasePublic,
    setHeaderPurchasePublic,
    setFirstSaveDiBlock,
    listViaTransporte,
    diIntermediaryTypeList,
    deleteItensTable,
    setDeleteItensTable,
    setNfeListOperadoras,
    diControle,
    setDiControle,
    exportShipmentLocation,
    setExportShipmentLocation,
    exportDispatchLocation,
    setExportDispatchLocation,
    ufExport,
    setUfExport,
    listCfopFuel,
    saleFinanceSwitch,
    setSaleFinanceSwitch,
    xmlAuthorizedList,
    setXmlAuthorizedList,
    listDocumentType,
    setCloneLoading,
    nfCloneId,
    setNfCloneId,
    setSelectedHeaderSeries,
    setHeaderSeriesOptions,
    setSenderRuralEstablishmentsList,
    setSenderRuralEstablishment,
    senderRuralEstablishment,
    setIsRuralProducerSender,
    taxNoteDefaultModels,
    taxNoteRuralProducerModels,
    setGetSeriesLoading,
    complementedAccessKey,
    setComplementedAccessKey,
    setSelectedSupplier,
    setSelectedPurchaseNf,
    setSelectedPurchaseItems,
    setPurchaseStartDate,
    setPurchaseFinalDate,
    setFirstSearch,
    headerModel,
    setHeaderModel,
    listModels,
    defaultListModels,
    setSalesOrderLoading,
    montageSelectedItemTaxation,
    setMontageSelectedItemTaxation,
    headerSeriesOptions,
    setOpenNfeLoading,
    additionalPaymentsInfo,
  } = useContext(EmissaoContext);

  const {
    setProductData,
    setProductDataId,
    productDataId,
    productDiTable,
    setProductDiTable,
    productDataIdStock,
    setProductDataIdStock,
    productDataStockCode,
    setProductDataStockCode,
    productDataCode,
    setProductDataCode,
    productDataDescription,
    setProductDataDescription,
    productDataNcm,
    setProductDataNcm,
    productDataCfop,
    setProductDataCfop,
    productDataUn,
    setProductDataUn,
    productDataQuantity,
    setProductDataQuantity,
    productDataUnityValue,
    setProductDataUnityValue,
    productDataTotalValue,
    setProductDataTotalValue,
    productOthersGtin,
    setProductOthersGtin,
    productOthersTaxGtin,
    setProductOthersTaxGtin,
    productOthersTipi,
    setProductOthersTipi,
    productOthersDeliveryUn,
    setProductOthersDeliveryUn,
    productOthersTaxUn,
    setProductOthersTaxUn,
    productOthersFreight,
    setProductOthersFreight,
    productOthersTaxQuantity,
    setProductOthersTaxQuantity,
    productOthersTaxValue,
    setProductOthersTaxValue,
    productOthersSafe,
    setProductOthersSafe,
    productOthersDiscount,
    setProductOthersDiscount,
    productOthersExpense,
    setProductOthersExpense,
    productOthersWeightUn,
    setProductOthersWeightUn,
    productOthersWeightIm,
    setProductOthersWeightIm,
    productOthersSiscomex,
    setProductOthersSiscomex,
    productOthersAdditional,
    setProductOthersAdditional,
    productOthersConversionFactorTax,
    setProductOthersConversionFactorTax,
    productIcmsSource,
    setProductIcmsSource,
    productIcmsSituation,
    setProductIcmsSituation,
    productIcmsModality,
    setProductIcmsModality,
    setProductIcmsAfrmm,
    productIcmsValueBc,
    setProductIcmsValueBc,
    productIcmsAliquot,
    setProductIcmsAliquot,
    productIcmsValue,
    setProductIcmsValue,
    productIcmsValueDes,
    setProductIcmsValueDes,
    productImcsMotivoDes,
    setProductImcsMotivoDes,
    productImcsListReasonExemption,
    productIcmsAliquotPoverty,
    setProductIcmsAliquotPoverty,
    productIcmsBcPoverty,
    setProductIcmsBcPoverty,
    productIcmsValuePoverty,
    setProductIcmsValuePoverty,
    productIcmsStModality,
    setProductIcmsStModality,
    productIcmsStPercentAdd,
    setProductIcmsStPercentAdd,
    productIcmsStPercentReductBc,
    setProductIcmsStPercentReductBc,
    productIcmsStValueBc,
    setProductIcmsStValueBc,
    productIcmsStAliquot,
    setProductIcmsStAliquot,
    productIcmsStValue,
    setProductIcmsStValue,
    productIcmsStAliquotPoverty,
    setProductIcmsStAliquotPoverty,
    productIcmsStBcPoverty,
    setProductIcmsStBcPoverty,
    productIcmsStValuePoverty,
    setProductIcmsStValuePoverty,
    productIpiSituation,
    setProductIpiSituation,
    productIpiBcValue,
    setProductIpiBcValue,
    productIpiAliquot,
    setProductIpiAliquot,
    productIpiValue,
    setProductIpiValue,
    productIpiReturnedAliquot,
    setProductIpiReturnedAliquot,
    productIpiReturnedValue,
    setProductIpiReturnedValue,
    productPisSituation,
    setProductPisSituation,
    productPisPercentAliquot,
    setProductPisPercentAliquot,
    productPisAliquot,
    setProductPisAliquot,
    productPisBcValue,
    setProductPisBcValue,
    productPisValue,
    setProductPisValue,
    productCofinsSituation,
    setProductCofinsSituation,
    productCofinsPercentAliquot,
    setProductCofinsPercentAliquot,
    productCofinsAliquot,
    setProductCofinsAliquot,
    productCofinsBcValue,
    setProductCofinsBcValue,
    productCofinsValue,
    setProductCofinsValue,
    productIIUnityValue,
    setProductIIUnityValue,
    productIIFob,
    setProductIIFob,
    productIIFreightIm,
    setProductIIFreightIm,
    productIIThc,
    setProductIIThc,
    productIICustomsValue,
    setProductIICustomsValue,
    productIIOthers,
    setProductIIOthers,
    productIIBcTax,
    setProductIIBcTax,
    productIIAliquot,
    setProductIIAliquot,
    productIIAliquotRed,
    setProductIIAliquotRed,
    productIITaxCustoms,
    setProductIITaxCustoms,
    productIIIof,
    setProductIIIof,
    productIITaxIm,
    setProductIITaxIm,
    productB2BNumber,
    setProductB2BNumber,
    productB2BItem,
    setProductB2BItem,
    setProductError,
    prodcuctIpiListSituation,
    prodcuctPisListSituation,
    productCofinsListSituation,
    productIcmsPercentReduct,
    setProductIcmsPercentReduct,
    productIcmsAliquotCredit,
    setProductIcmsAliquotCredit,
    productIcmsCreditAprove,
    setProductIcmsCreditAprove,
    productIcmsListNormalTaxationSituation,
    productIcmsListSimpleTaxationSituation,
    productIcmsListSource,
    productIcmsListModality,
    productIcmsStListModality,
    productIpiCenq,
    setProductIpiCenq,
    productIcmsStValueBcRet,
    setProductIcmsStValueBcRet,
    productIcmsStValueRet,
    setProductIcmsStValueRet,
    setProductIcmsAliquotSupCons,
    productIcmsAliquotSupCons,
    productIcmsOwnSubValue,
    setProductIcmsOwnSubValue,
    productIcmsStBcPovertyRet,
    setProductIcmsStBcPovertyRet,
    productIcmsStValuePovertyRet,
    setProductIcmsStValuePovertyRet,
    productIcmsStAliqPovertyRet,
    setProductIcmsStAliqPovertyRet,
    productDataCest,
    setProductDataCest,
    timerProductCode,
    setTimerProductCode,
    setProductDataStock,
    productDataStock,
    productIcmsAliquotInterstate,
    setProductIcmsAliquotInterstate,
    productIcmsAliquotInternal,
    setProductIcmsAliquotInternal,
    setProductTaxation,
    taxations,
    setTaxations,
    productCheckIcmsFreight,
    setProductCheckIcmsFreight,
    productCheckIcmsSafe,
    setProductCheckIcmsSafe,
    productCheckIcmsOthers,
    setProductCheckIcmsOthers,
    productCheckIcmsDiscount,
    setProductCheckIcmsDiscount,
    productCheckIpiFreight,
    setProductCheckIpiFreight,
    productCheckIpiSafe,
    setProductCheckIpiSafe,
    productCheckIpiOthers,
    setProductCheckIpiOthers,
    productCheckIpiDiscount,
    setProductCheckIpiDiscount,
    productCheckPisFreight,
    setProductCheckPisFreight,
    productCheckPisSafe,
    setProductCheckPisSafe,
    productCheckPisOthers,
    setProductCheckPisOthers,
    productCheckPisDiscount,
    setProductCheckPisDiscount,
    productCheckPisDescIcms,
    setProductCheckPisDescIcms,
    productCheckCofinsFreight,
    setProductCheckCofinsFreight,
    productCheckCofinsSafe,
    setProductCheckCofinsSafe,
    productCheckCofinsOthers,
    setProductCheckCofinsOthers,
    productCheckCofinsDiscount,
    setProductCheckCofinsDiscount,
    productCheckCofinsDescIcms,
    setProductCheckCofinsDescIcms,
    setProductIIAntidumping,
    setProductIIAFRMM,
    productIIAFRMM,
    productIIAntidumping,
    setProductIISafeIm,
    productCheckIcmsDifal,
    setProductCheckIcmsDifal,
    productCopyIcmsAliquotInterstate,
    productIcmsCbenef,
    setProductIcmsCbenef,
    productFuelCodeAnp,
    setProductFuelCodeAnp,
    productFuelDescAnp,
    setProductFuelDescAnp,
    productFuelUf,
    setProductFuelUf,
    productFuelGlpPetroleum,
    setProductFuelGlpPetroleum,
    productFuelNationalGas,
    setProductFuelNationalGas,
    productFuelImportedGas,
    setProductFuelImportedGas,
    productFuelValueWithoutICMS,
    setProductFuelValueWithoutICMS,
    setLoading,
    itemId,
    setItemId,
    productExportDrawbackNumber,
    setProductExportDrawbackNumber,
    productIsIndirectExportation,
    setProductIsIndirectExportation,
    productExportRegisterNumber,
    setProductExportRegisterNumber,
    productExportAccessKey,
    setProductExportAccessKey,
    productExportQuantity,
    setProductExportQuantity,
  } = useContext(ParametrosProdutoContext);

  const { queryParams, setTempQueryParams } = useContext(QueryParamsContext);

  const {
    getRulesPerCst,
    calcTotalsNfe,
    taxationFormat,
    productFormat,
    calcsIcmsTaxations,
    calcsIcmsStTaxations,
    calcsIpiTaxations,
    calcsPisTaxations,
    calcsCofinsTaxations,
    handleCreditIcms,
    apportionmentPercent,
    apportionmentProdcut,
    handleCalcPaymentCondition,
    handleCalcPaymentForm,
  } = useCalculosTributacao();

  const {
    validHeader,
    validReceiver,
    validTotals,
    validOthers,
    validPayment,
    validItens,
    validShippingCompany,
    validXmlAuthorized,
  } = useRulesEmissaoSubmit();

  const rulesPerCst = getRulesPerCst;

  //Auxiliares Params Produto (II DI)
  const [diNumber, setDiNumber] = useState("");
  const [diRegisterDate, setDiRegisterDate] = useState("");
  const [diClearanceUf, setDiClearanceUf] = useState(null);
  const [diClearancePlace, setDiClearancePlace] = useState("");
  const [diDateDes, setDiDateDes] = useState("");
  const [diDrawback, setDiDrawback] = useState("");
  const [diSequence, setDiSequence] = useState("");
  const [diAdd, setDiAdd] = useState("");

  //Auxiliar Cobranca
  const [chargeError, setChargeError] = useState({});
  const [chargeDueDate, setChargeDueDate] = useState(
    formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
  );
  const [chargeMaturities, setChargeMaturities] = useState("0");

  //Auxiliar Forma Pagto
  const [paymentError, setPaymentError] = useState({});
  const [paymentMethod, setPaymentMethod] = useState({
    value: "01",
    label: "Dinheiro",
  });
  const [paymentIndicator, setPaymentIndicator] = useState({
    value: "0",
    label: "Pagamento à Vista",
  });
  const [paymentTransshipment, setPaymentTransshipment] = useState("0,00");
  const [paymentTypeIntegration, setPaymentTypeIntegration] = useState(null);
  const [paymentFlag, setPaymentFlag] = useState(null);
  const [paymentCnpj, setPaymentCnpj] = useState("");
  const [paymentCodeCard, setPaymentCodeCard] = useState("");
  const [paymentOperator, setPaymentOperator] = useState(null);

  //Auxiliar Docs
  const [docError, setDocError] = useState({});
  const [docAccessKey, setDocAccessKey] = useState(null);
  const [docFreightModality, setDocFreightModality] = useState(null);
  const [refDocSerie, setRefDocSerie] = useState(null);
  const [refDocNumber, setRefDocNumber] = useState(null);
  const [refDocIssueDate, setRefDocIssueDate] = useState(null);

  //Auxiliar Transportadora (volumes)
  const [volError, setVolError] = useState({});
  const [volQuantity, setVolQuantity] = useState("");
  const [volEsp, setVolEsp] = useState("");
  const [volBrand, setVolBrand] = useState("");
  const [volNumber, setVolNumber] = useState("");
  const [volNetWeight, setVolNetWeight] = useState("0,000");
  const [volGrossWeight, setVolGrossWeight] = useState("0,000");

  //Autorizados Xml (documentos)
  const [modalXmlAuthorizedError, setModalXmlAuthorizedError] = useState({});
  const [autDocumentType, setAutDocumentType] = useState(null);
  const [autDocumentNumber, setAutDocumentNumber] = useState("");

  const [refreshOperatorCnpj, setRefreshOperatorCnpj] = useState(false);

  const situations = {
    "00": "Em Carteira",
    10: "Em Cobranca",
    20: "Em cartorio",
    30: "Protestado",
    40: "Liquidado Parcialmente",
    50: "Liquidado Totalmente",
    60: "Desconto de Título - Factoring",
    70: "Baixado",
    80: "Depto Juridico",
    90: "Cancelado",
    99: "Renegociado",
  };

  const optionsSetters = {
    billing: {
      setCep: setSenderBillingCep,
      setAddress: (value) =>
        setSenderBillingAddress((value || "").substring(0, 60)),
      setSenderBillingNumber: setSenderBillingNumber,
      setComplement: (value) =>
        setSenderBillingComplement(value.substring(0, 60)),
      setDistrict: (value) => setSenderBillingDistrict(value.substring(0, 60)),
      setUf: setSenderBillingUf,
      setCity: setSenderBillingCity,
    },
    delivery: {
      setCep: setSenderDeliveryCep,
      setAddress: (value) =>
        setSenderDeliveryAddress((value || "").substring(0, 60)),
      setNumber: setSenderDeliveryNumber,
      setComplement: (value) =>
        setSenderDeliveryComplement((value || "").substring(0, 60)),
      setCity: setSenderDeliveryCity,
      setUf: setSenderDeliveryUf,
      setDistrict: (value) =>
        setSenderDeliveryDistrict((value || "").substring(0, 60)),
    },
  };

  const removeMaskDecimal = (value = "", fixed = 2) => {
    return parseFloat(
      parseFloat(value.replace(/\./g, "").replace(",", ".")).toFixed(fixed)
    );
  };

  /* 
    Set com json padronizado. Dados já devem vir formatados. (Mask's, etc)
  */

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSetNfeData = (nfeData) => {
    /* Auxiliares */
    const notafiscal = nfeData.notafiscal;
    if (notafiscal) {
      setHeaderIssueType(notafiscal.headerIssueType);
      setNfeStatus(notafiscal.nfeStatus);
      setHeaderTime(notafiscal.headerTime || new Date());
      setHeaderDateJL(notafiscal.headerDateJL || new Date());
      setHeaderIssueTime(notafiscal.headerIssueTime || new Date());
      setNfeMontageSubtype(notafiscal.nfeMontageSubtype || "M");

      /* Cabeçalho */
      setHeaderNfe((current) => notafiscal.headerNfe || current);
      if (!notafiscal?.isClone)
        setHeaderSeries((current) => notafiscal.headerSeries || current);
      if (!notafiscal?.isClone) setSelectedHeaderSeries(null);
      setHeaderIssueDate((current) => notafiscal.headerIssueDate || current);
      setHeaderAccessKey((current) => notafiscal.headerAccessKey || current);
      setHeaderTypeNfe((current) => notafiscal.headerTypeNfe || current);
      setHeaderCfop((current) => notafiscal.headerCfop || current);
      setHeaderOperationNature(
        (current) => notafiscal.headerOperationNature || current
      );
      setHeaderPresentOperation(
        (current) => notafiscal.headerPresentOperation || current
      );
      setHeaderFinalCostumer(
        (current) => notafiscal.headerFinalCostumer || current
      );
      setHeaderOperation((current) => notafiscal.headerOperation || current);
      setHeaderFinnally((current) => notafiscal.headerFinnally || current);
      setHeaderIeTax((current) => notafiscal.headerIeTax || current);
      setHeaderPurchaseOrder(
        (current) => notafiscal.headerPurchaseOrder || current
      );
      setHeaderPurchaseContract(
        (current) => notafiscal.headerPurchaseContract || current
      );
      setHeaderPurchasePublic(
        (current) => notafiscal.headerPurchasePublic || current
      );

      /* Modalidade da Transportadora */
      setTranspModality((current) => notafiscal.transpModality || current);

      // Novo estado de desabilita inputs,
      // caso seja uma importação de DI.
      setVisualizationOnly(notafiscal.visualizationOnly || false);
      setSaveBlocked(notafiscal.saveBlocked || false);

      /* DI */
      if (
        notafiscal.headerOperation?.value ===
          GlobalVariables.nfe.operations.foreign &&
        notafiscal.headerTypeNfe?.value === GlobalVariables.nfe.types.entry &&
        nfeData.dadosDi
      ) {
        setDiDeclarationDate(
          (current) => nfeData.dadosDi.diDataRegistro || current
        );
        setDiDeclarationDrawback(
          (current) => nfeData.dadosDi.diDrawback || current
        );
        setDiDeclarationCity(
          (current) => nfeData.dadosDi.diLocalDes || current
        );
        setDiDeclarationUf((current) => nfeData.dadosDi.diUfDes || current);
        setDiDeclarationDateDes(
          (current) => nfeData.dadosDi.diDataDes || current
        );

        setDiImpWayOf((current) => nfeData.dadosDi.diImpWayOf || current);
        setDiIntermediaryType(
          (current) => nfeData.dadosDi.diIntermediaryType || current
        );
        setAcquirerUf((current) => nfeData.dadosDi.diAcquirerUf || current);
        setAcquirerDocument(
          (current) => nfeData.dadosDi.diAcquirerDocument || current
        );
        setDiDeclarationDiNumber(
          (current) => nfeData.dadosDi.diNumeroRegistro || current
        );

        setDiControle(nfeData.dadosDi.diControle);
      }

      //Dados de Exportação
      setExportShipmentLocation(
        (current) => notafiscal.exportShipmentLocation || current
      );
      setExportDispatchLocation(
        (current) => notafiscal.exportDispatchLocation || current
      );
      setUfExport((current) => notafiscal.ufExport || current);
      setXmlAuthorizedList(nfeData.autorizadoXml || []);
    }

    const observacoes = nfeData?.observacoes;

    if (observacoes) {
      setObsBd(observacoes.obsText);
      setObsTextCFOP(observacoes.obsTextCFOP);
      setObsTextCreditRate(observacoes.obsTextCreditRate);
      setObsTextComplemento(observacoes.obsTextComplemento);
    }

    /* Destinatário */
    const destinatario = nfeData.destinatario;

    setIsRuralProducerSender(!!destinatario?.sender?.produtor_rural);
    setSender(destinatario);
    setEnableEndereco(true);
    setSenderId(destinatario.senderId);
    setSenderClifor(destinatario.senderClifor);
    setSenderIe(destinatario.senderIe);
    setSenderCityCode(destinatario.senderCityCode);
    setSenderCountryCode(destinatario.senderCountryCode);
    setSenderName(destinatario.senderName);
    setSenderCnpj(destinatario.senderCnpj);
    setSenderAddres(destinatario.senderAddres);
    setSenderNumber(destinatario.senderNumber);
    setSenderDistrict(destinatario.senderDistrict);
    setSenderCity(destinatario.senderCity);
    setSenderCep(destinatario.senderCep);
    setSenderPhone(destinatario.senderPhone);
    setSenderMail(destinatario.senderMail);
    setSenderUf(destinatario.senderUf);
    setSenderUfLabel(destinatario.senderUfLabel || "");
    setSenderIndicationIe(destinatario.senderIndicationIe);
    setSenderDeliveryList(destinatario.senderDeliverLocations);

    if (destinatario.headerFinalCostumer) {
      setHeaderFinalCostumer(
        destinatario.headerFinalCostumer === "1"
          ? {
              label: "SIM",
              value: "S",
            }
          : {
              label: "NÃO",
              value: "N",
            }
      );
    }

    /* Update Destinatario */
    setGeneralIe(destinatario.senderIe);
    setGeneralIeIndication(destinatario.senderIndicationIe);

    /* Totalizadores */
    const totalizadores = nfeData.totalizadores;

    setItensTotalNfe(totalizadores?.totalNfe || "0,00");
    setItensTotalValueIcms(totalizadores?.totalValueIcms || "0,00");
    setItensTotalBaseIcms(totalizadores?.totalBaseIcms || "0,00");
    setItensTotalIcmsFcp(totalizadores?.totalIcmsFcp || "0,00");
    setItensTotalIcmsDes(totalizadores?.totalIcmsDes || "0,00");
    setItensTotalValueSt(totalizadores?.totalValueSt || "0,00");
    setItensTotalBaseSt(totalizadores?.totalBaseSt || "0,00");
    setItensTotalStFcp(totalizadores?.totalStFcp || "0,00");
    setItensTotalValueIpi(totalizadores?.totalValueIpi || "0,00");
    setItensTotalIpiReturned(totalizadores?.totalValueIpiReturned || "0,00");
    setItensTotalValuePis(totalizadores?.totalValuePis || "0,00");
    setItensTotalValueCofins(totalizadores?.totalValueCofins || "0,00");
    setItensTotalFreight(totalizadores?.totalFreight || "0,00");
    setItensTotalSafe(totalizadores?.totalSafe || "0,00");
    setItensTotalOthers(totalizadores?.totalOthers || "0,00");
    setItensTotalDiscount(totalizadores?.totalDiscount || "0,00");
    setItensTotalProductValue(totalizadores?.totalProductValue || "0,00");
    // setItensTotalValueCustoms(totalizadores.vl_outras); //VERIFICAR
    // setTotalStWithheld(totalizadores); //VERIFICAR

    /* Locais */
    if (
      nfeData.enderecoCobranca &&
      Object.keys(nfeData.enderecoCobranca).length
    ) {
      const enderecoCobranca = nfeData.enderecoCobranca;

      setEnableEndereco(true);
      setEnableBillingEdit(true);
      setSenderCheckBilling(true);
      setSenderBillingAddress(enderecoCobranca.senderBillingAddress);
      setSenderBillingNumber(enderecoCobranca.senderBillingNumber);
      setSenderBillingDistrict(enderecoCobranca.senderBillingDistrict);
      setSenderBillingCep(enderecoCobranca.senderBillingCep);
      setSenderBillingComplement(enderecoCobranca.senderBillingComplement);
      setSenderBillingCity(enderecoCobranca.senderBillingCity);
      setSenderBillingUf(enderecoCobranca.senderBillingUf);
    }

    if (
      nfeData.enderecoEntrega &&
      Object.keys(nfeData.enderecoEntrega).length
    ) {
      const enderecoEntrega = nfeData.enderecoEntrega;

      setEnableEndereco(true);
      setEnableDeliveryEdit(true);
      setSenderCheckDelivery(true);
      setSenderDeliveryAddress(enderecoEntrega.senderDeliveryAddress);
      setSenderDeliveryDistrict(enderecoEntrega.senderDeliveryDistrict);
      setSenderDeliveryCep(enderecoEntrega.senderDeliveryCep);
      setSenderDeliveryComplement(enderecoEntrega.senderDeliveryComplement);
      setSenderDeliveryNumber(enderecoEntrega.senderDeliveryNumber);
      setSenderDeliveryCodeCity(enderecoEntrega.senderDeliveryCodeCity);
      setSenderDeliveryCity(enderecoEntrega.senderDeliveryCity);
      setSenderDeliveryUf(enderecoEntrega.senderDeliveryUf);
    }

    /* Itens/Produtos */
    setItensTable(nfeData.itens);

    /* Contas a Receber / Cobranca */

    if (nfeMontageType === "A" && nfeFinancialIssue === "NOTA") {
      const charge = [];
      nfeData.cobranca.forEach((row) => {
        if (row.cobrancaSituacaoValue === "50") {
          charge.push(row);
        }
      });
      setPagtoTableCobranca(charge);
    }

    if (
      nfeMontageType === "M" ||
      (nfeMontageType === "A" && nfeFinancialIssue === "VENDA")
    ) {
      nfeData.cobranca.forEach((current) => {
        if (
          current.cobrancaSituacaoValue !==
          GlobalVariables.RecieveSituations.fullyLiquidated
        ) {
          current.cobrancaDestacaDanfe = true;
        }
      });
      const orderedCobranca = [...nfeData.cobranca];

      if (orderedCobranca.length > 0) {
        orderedCobranca.sort(
          (a, b) =>
            new Date(a.cobrancaDtVenctoValue) -
            new Date(b.cobrancaDtVenctoValue)
        );
        let numero = 1;
        orderedCobranca.forEach((obj) => {
          if (obj.cobrancaDestacaDanfe) {
            obj.cobrancaNro = numero.toString().padStart(3, "0");
            numero++;
          }
        });
        orderedCobranca.sort((a, b) => a.index - b.index);
      }

      setPagtoTableCobranca(orderedCobranca.length ? orderedCobranca : []);
    }

    /* Nota de Devolução */
    if (nfeData.finalidadeNota && nfeData.finalidadeNota[0]?.value === "4") {
      /* Forma de Pagamento */
      setPagtoTableFormaPagto(
        nfeData.formapagamento?.length
          ? nfeData.formapagamento
          : [
              {
                index: 0,
                pagtoFormaLabel: "Sem pagamento",
                pagtoFormaValue: "90",
                pagtoValor: "0,00",
                pagtoIndicadorLabel: "",
                pagtoIndicadorValue: "",
                pagtoCnpjCred: "",
                pagtoIntLabel: "",
                pagtoIntValue: "",
                pagtoBandeiraLabel: "",
                pagtoBandeiraValue: "",
                pagtoTroco: "0,00",
                pagtoCodigoCartao: "",
              },
            ]
      );
    } else {
      setPagtoTableFormaPagto(nfeData?.formapagamento);
    }

    if (!notafiscal) {
      /* Modalidade da Transportadora */
      setTranspModality(nfeData.transpModality);
    }
    /* Transportadora */
    if (nfeData.transportadora && Object.keys(nfeData.transportadora).length) {
      const transportadora = nfeData.transportadora;
      const arrAddressTransp = (transportadora.transpAddress || "").split(",");
      setTransp(transportadora.transp);
      setTranspAddress(arrAddressTransp[0] || "");
      setTranspNumber(arrAddressTransp[1] || transportadora.transpNumber || "");
      setTranspCity(
        listCounty.find(
          (element) =>
            element.municipio.toLowerCase() ===
            transportadora.transpCity?.toLowerCase()
        )
      );
      setTranspUf(
        listUf.find(
          (element) =>
            element.estado.toLowerCase() ===
            transportadora?.transpUf?.estado?.toLowerCase()
        )
      );
      setTranspName(transportadora.transpName);
      setTranspCnpj(transportadora.transpCnpj);
      setTranspIe(
        transportadora.transpIe
          ? transportadora.transpIe.replace(/[^0-9]+/g, "")
          : ""
      );
      setTranspRntc(transportadora.transpRntc);
      setTranspId(transportadora.transpId);
      setTranspCityCode(transportadora.transpCityCode);
      setTranspBoardcar(transportadora.transpBoardcar);
      setTranspBoardcarUf(transportadora.transpBoardcarUf);
    }

    setTranspTableSize(nfeData.volumes.length ? nfeData.volumes : []);

    if (nfeData.vendas) {
      setNfeSales(nfeData.vendas);
    }

    if (nfeData.nfsRefs && nfeData.nfsRefs.length) {
      setDocTable(nfeData.nfsRefs);
    }
    setComplementedAccessKey(notafiscal?.complementedAccessKey || "");
  };

  const handleOpenNfe = (nfeIdProp) => {
    (async () => {
      setOpenNfeLoading(true);

      try {
        const callbackNfe = await findNotas(
          queryParams.empresa_cnpj,
          nfeIdProp,
          "itens.di.adicoes,itens.di.estado,itens.declaracaoExportacaoItem,locais,transportes.transportadora.estado,transportesvolumes,cobrancas,contasreceber,contasreceber.recebimentos,vendas.contasreceber.recebimentos,formaspagamentos,nfsRefs,nfeslotes,nfelotenf,dicontrole,autorizadoXml,estabelecimentoRural,estabelecimentoRural.endereco,estabelecimentoRural.endereco.municipio,estabelecimentoRural.endereco.estado,estabelecimentoRural.contatos"
        );

        const callBackFinancialTypeNfe = await financialType(
          queryParams.empresa_cnpj,
          nfeIdProp
        );
        const financialTypeNfe = callBackFinancialTypeNfe.data;

        if (!callbackNfe.success || !callbackNfe.data) return;

        let callbackDestinatario = null;
        if (callbackNfe.data.clifor === "C") {
          callbackDestinatario = await findCliente({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: callbackNfe.data.idclifor,
            include:
              "estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado",
          });
        } else {
          callbackDestinatario = await findFornecedor(
            queryParams.empresa_cnpj,
            callbackNfe.data.idclifor,
            "estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
          );
        }

        if (!callbackDestinatario.success || !callbackNfe.data) return;

        setNfeId(callbackNfe.data.id);

        const destinatario = callbackDestinatario.data;

        const ruralEstablishmentNfe =
          callbackNfe?.data?.estabelecimento_rural || null;

        let isRuralProducer = destinatario?.produtor_rural;
        if (
          [
            GlobalVariables.nfe.status.canceled,
            GlobalVariables.nfe.status.transmitted,
          ].includes((callbackNfe.data.status || "").toUpperCase())
        ) {
          isRuralProducer = !!ruralEstablishmentNfe;
        }

        setIsRuralProducerSender(isRuralProducer);
        setSenderRuralEstablishment(
          isRuralProducer ? ruralEstablishmentNfe : null
        );
        setSenderRuralEstablishmentsList(destinatario?.estabelecimentos_rurais);

        const nfe = callbackNfe.data;
        const enderecoCobranca = {};
        const enderecoEntrega = {};
        let itens = [];
        const cobranca = [];
        const formapagamento = [];
        const transportadora = {};
        const volumes = [];
        const vendas = [];
        const nfsRefs = [];
        const autorizadoXml = [];

        setHeaderModel(
          defaultListModels.find((model) => model.value === nfe.modelo)
        );

        nfe.autorizado_xml?.forEach((infAutorizado, index) => {
          autorizadoXml.push({
            index,
            documento: infAutorizado.documento,
            tipo: infAutorizado.documento.length > 11 ? "CNPJ" : "CPF",
          });
        });

        nfe.nfs_refs.forEach((nfRef, key) => {
          nfsRefs.push({
            index: key,
            docChaveAcesso: nfRef.refnfe,
            docModeloLabel: "NFe",
            docModeloValue: nfRef.modelo,
            refDocSerie: nfRef.numero_serie,
            refDocNumber: nfRef.numero_nfe,
            refDocIssueDate: nfRef.data_emissao,
          });
        });

        if (nfe.indintermed !== null) {
          setHeaderIndicatorIntermed(
            nfeListIntermed.find(
              (intermedType) => parseInt(intermedType.value) === nfe.indintermed
            )
          );
        }

        // Bloco para recuperar a informação do switch de financeiro da venda
        setSaleFinanceSwitch(financialTypeNfe?.tipo === "Venda");
        const currentNfeFinancialIssue =
          financialTypeNfe?.tipo === "Venda" ? "VENDA" : "NOTA";
        setNfeFinancialIssue(currentNfeFinancialIssue);
        //

        setHeaderIntermedCnpj(nfe.intermed_cnpj);
        setHeaderIdentifierIntermed(nfe.intermed_identificador);

        setDiControle(nfe.dicontrole || []);
        setNfeLotes(nfe.nfeslotes || []);
        setNfeValidXml(
          !nfe.nfelotenf.length
            ? "NFe salva com sucesso, porém sem assinar. Empresa emitente não possui certificado válido cadastrado no sistema."
            : ""
        );

        nfe.locais.forEach((row) => {
          const city = listCounty.find(
            (county) => county.codigo === row.codigomunicipio
          );
          if (row.tipo === "E") {
            enderecoEntrega["senderDeliveryAddress"] = row.endlogradouro;
            enderecoEntrega["senderDeliveryNumber"] = row.endnumero;
            enderecoEntrega["senderDeliveryDistrict"] = row.endbairro;
            enderecoEntrega["senderDeliveryCep"] = row.cep;
            enderecoEntrega["senderDeliveryComplement"] = row.endcomplemento;
            enderecoEntrega["senderDeliveryCodeCity"] = row.codigomunicipio;
            enderecoEntrega["senderDeliveryCity"] = city;
            enderecoEntrega["senderDeliveryUf"] = listUf.find(
              (uf) =>
                uf.codibge.toString() === (city?.estado_codigo || "").toString()
            );
          } else {
            enderecoCobranca["senderBillingAddress"] = row.endlogradouro;
            enderecoCobranca["senderBillingNumber"] = row.endnumero;
            enderecoCobranca["senderBillingDistrict"] = row.endbairro;
            enderecoCobranca["senderBillingCep"] = row.cep;
            enderecoCobranca["senderBillingComplement"] = row.endcomplemento;
            enderecoCobranca["senderBillingCity"] = city;
            enderecoCobranca["senderBillingUf"] = listUf.find(
              (uf) =>
                uf.codibge.toString() === (city?.estado_codigo || "").toString()
            );
          }
        });

        nfe.transportes.forEach((row) => {
          const arrAddressTransp = (row.endereco || "").split(",");

          transportadora["transp"] = row.transportadora;
          transportadora["transpAddress"] =
            arrAddressTransp[0] || row.novoendereco || "";
          transportadora["transpNumber"] =
            arrAddressTransp[1] || row.numero || "";
          transportadora["transpName"] = row.nome;
          transportadora["transpCnpj"] = row.cpfcnpj;
          transportadora["transpIe"] = row.ie;
          transportadora["transpRntc"] = row.rntc;
          transportadora["transpId"] = row.idtransportadora;
          transportadora["transpCityCode"] = row.codigomunicipio;
          transportadora["transpBoardcar"] = row.placaveiculo;
          transportadora["transpBoardcarUf"] = row.placaveiculouf;
          if (row.transportadora) {
            transportadora["transpUf"] = row.transportadora.estado;
            transportadora["transpCity"] = row.transportadora.cidade;
          } else if (
            nfe.modalidadefrete ===
            GlobalVariables.trasportModalities.proprioRemetente.value
          ) {
            transportadora["transpCity"] = queryParams.cidade;
            transportadora["transpUf"] = listUf.find(
              (element) => element.id === queryParams.id_estado
            );
          } else if (
            nfe.modalidadefrete ===
            GlobalVariables.trasportModalities.proprioDestinatario.value
          ) {
            transportadora["transpUf"] = destinatario.estado;
            transportadora["transpCity"] = destinatario.cidade;
          }
        });

        nfe.transportesvolumes.forEach((row, index) => {
          volumes.push({
            index: index,
            volQuantidade: parseInt(row.quantidade || 0),
            volEsp: row.especie,
            volMarca: row.marca,
            volNumeracao: row.numeracao,
            volPesoLiq: MaskService.toMask(
              "decimal",
              row.pesoliquido
                ? parseFloat(row.pesoliquido).toFixed(3)
                : "0,000",
              3
            ),
            volPesoBruto: MaskService.toMask(
              "decimal",
              row.pesobruto ? parseFloat(row.pesobruto).toFixed(3) : "0,000",
              3
            ),
          });
        });

        nfe.formaspagamentos.forEach((row, index) => {
          const pagtoForma = nfeListPaymentMethod.find(
            (value) => row.codigo === value.value
          );

          const pagtoIndicador = nfeListPaymentIndicator.find(
            (value) => row.indpag === value.value
          );

          const pagtoInt = nfeListPaymentTypeIntegration.find(
            (value) => row.tpintegra === value.value
          );

          const pagtoBandeira = nfeListBandeiras.find(
            (value) => row.bandeira_cartao === value.id.toString()
          );

          formapagamento.push({
            index: index,
            pagtoFormaLabel: pagtoForma ? pagtoForma.label : "",
            pagtoFormaValue: pagtoForma ? pagtoForma.value : "",
            pagtoValor: MaskService.toMask(
              "decimal",
              parseFloat(row.valor).toFixed(2)
            ),
            pagtoIndicadorLabel: pagtoIndicador ? pagtoIndicador.label : "",
            pagtoIndicadorValue: pagtoIndicador ? pagtoIndicador.value : "",
            pagtoCnpjCred: row.cnpj_credenciadora_cartao,
            pagtoIntLabel: pagtoInt ? pagtoInt.label : "",
            pagtoIntValue: pagtoInt ? pagtoInt.value : "",
            pagtoTroco: MaskService.toMask(
              "decimal",
              parseFloat(row.vl_troco).toFixed(2)
            ),
            pagtoCodigoCartao: row.codigo_autorizacao_cartao,
            pagtoBandeiraLabel: pagtoBandeira?.sn_descricao || "",
            pagtoBandeiraValue: pagtoBandeira?.id || "",
          });
        });

        if (!nfe.hasOwnProperty("contasreceber")) {
          nfe.contasreceber = [];
        }

        nfe.vendas.forEach((element) => {
          if (element?.contasreceber?.length)
            element?.contasreceber?.forEach((conta) => {
              nfe.contasreceber.unshift(conta);
            });
        });

        if (currentNfeFinancialIssue === "NOTA") {
          let valorPago = 0;
          nfe?.contasreceber?.forEach((row, index) => {
            const recebimentos = row.recebimentos;

            if (recebimentos.length) {
              const payment = recebimentos.find(
                (recebimento) => row.id === recebimento.pivot.idcontasreceber
              );
              valorPago = payment ? payment.pivot.valor : 0;
            }
          });

          nfe.cobrancas.forEach((row, index) => {
            let situacaodocto = nfe?.contasreceber?.find(
              (contasReceber) => contasReceber.id === row.idcontasreceber
            )?.situacaodocto;

            cobranca.push({
              id: row.id,
              idCr: row.idcontasreceber,
              index: index,
              cobrancaNro: row.numero,
              cobrancaDtVenctoValue: row.datavencto,
              cobrancaDtVencto: row.datavencto.split("-").reverse().join("/"),
              cobrancaValor: MaskService.toMask(
                "decimal",
                parseFloat(row.valor).toFixed(2)
              ),
              cobrancaValorPago: MaskService.toMask(
                "decimal",
                parseFloat(valorPago).toFixed(2)
              ),

              cobrancaSituacao: situations[situacaodocto],
              cobrancaSituacaoValue: situacaodocto,

              cobrancaDestacaDanfe: row.destacar === "S",
            });
          });
        } else {
          nfe.contasreceber.forEach((row, index) => {
            let auxNro = (index + 1).toString();
            let pad = "000";

            const recebimentos = row.recebimentos;

            let valorPago = 0;
            if (recebimentos.length) {
              const payment = recebimentos.find(
                (recebimento) => row.id === recebimento.pivot.idcontasreceber
              );
              valorPago = payment ? payment.pivot.valor : 0;
            }

            const billingId = nfe.cobrancas?.find(
              (cobranca) => row.id === cobranca.idcontasreceber
            )?.id;

            cobranca.push({
              id: billingId ? billingId : row.id,
              idCr: row.id,
              index: index,
              cobrancaNro:
                pad.substring(0, pad.length - auxNro.length) + auxNro,
              cobrancaDtVenctoValue: row.datavencto,
              cobrancaDtVencto: row.datavencto.split("-").reverse().join("/"),
              cobrancaValor: MaskService.toMask(
                "decimal",
                parseFloat(row.valordoctooriginal).toFixed(2)
              ),
              cobrancaValorPago: MaskService.toMask(
                "decimal",
                parseFloat(valorPago).toFixed(2)
              ),
              cobrancaSituacao: situations[row.situacaodocto],
              cobrancaSituacaoValue: row.situacaodocto,
              cobrancaDestacaDanfe: row.destacar === "S",
            });
          });
        }

        const itensAtualizados = await Promise.all(
          nfe.itens.map(async (row) => {
            const product = await findProdutosAlternativeFormatted({
              empresa_cnpj: queryParams.empresa_cnpj,
              where: {
                active: "SIM",
                codeBar: row.codigo,
              },
            });

            const callbackTrib = await findTributacoes(
              queryParams.empresa_cnpj,
              {
                ncm: row.ncm,
                cfop: row.cfop,
              }
            );
            const tributacoes = callbackTrib.data[0];

            let idproduto = product.data[0]?.id;
            return { ...row, idproduto, tributacoes };
          })
        );

        nfe.itens = itensAtualizados;

        itens = returnBuiltNfeItems(nfe);

        const nfeData = {
          notafiscal: {
            /* Auxiliares */
            nfeId: nfe.id,
            headerIssueType: nfe.tipoemissao,
            nfeStatus: nfe.status,
            nfeMontageSubtype: nfe.tipo_montagem,
            saveBlocked: nfe.tipo_montagem === "DI",

            /* Cabeçalho */
            headerIssueTime: new Date(),
            headerTime: new Date(),
            headerDateJL:
              nfe.dataentsai ||
              formatDate({
                date: new Date(),
                separator: "-",
                format: "yyyy-mm-dd",
              }),
            headerNfe: nfe.numero,
            headerSeries: nfe.serie,
            headerIssueDate: nfe.dataemissao,
            headerAccessKey: nfe.chaveacesso,
            headerTypeNfe: nfeListTypeNf.find(
              (value) => nfe.tipo === value.value
            ),
            headerCfop: nfe.cfop || "",
            headerOperationNature: nfe.naturezaoperacao || "",
            headerPresentOperation: nfeListPresentOperations.find(
              (value) => nfe.indpres === value.value
            ),
            headerFinalCostumer: nfeListYesOrNo.find(
              (value) => nfe.indfinal === value.value
            ),
            headerOperation: nfeListOperations.find(
              (value) => nfe.iddest === value.value
            ),
            headerFinnally: nfeListFinnally.find(
              (value) => nfe.finalidade === value.value
            ),
            headerIeTax: nfe.iest || "",
            headerPurchaseOrder: nfe.b2b_pedidocompra || "",
            headerPurchaseContract: nfe.b2b_contratocompra || "",
            headerPurchasePublic: nfe.b2b_notaempenho || "",

            /*Modalidade da Transportadora */
            transpModality: nfeListModalities.find(
              (value) => nfe.modalidadefrete === value.value
            ),
            exportShipmentLocation: nfe.xlocexporta,
            exportDispatchLocation: nfe.xlocdespacho,
            ufExport: (nfe?.codigoufsaidapais || "").trim().length
              ? Estados.find((value) => value.estado === nfe.codigoufsaidapais)
              : {},
            complementedAccessKey: nfe.chave_nf_complementada,
          },

          dadosDi: nfe?.itens[0]?.di
            ? {
                diNumeroRegistro: nfe?.itens[0]?.di?.numerodi || "",
                diDataRegistro: (nfe?.itens[0]?.di?.dataregistro || "").slice(
                  0,
                  10
                ),
                diDrawback: nfe?.itens[0]?.di?.drawback || "",
                diLocalDes: nfe?.itens[0]?.di?.cidade || "",
                diUfDes: nfe?.itens[0]?.di?.id_estado
                  ? listUf.find(
                      (uf) => uf.id === nfe?.itens[0]?.di?.id_estado.toString()
                    )
                  : null,
                diDataDes: (nfe?.itens[0]?.di?.datadesembaraco || "").slice(
                  0,
                  10
                ),
                diImpWayOf: nfe.imp_via_tranporte
                  ? listViaTransporte.find(
                      (way) => way.value === Number(nfe.imp_via_tranporte)
                    )
                  : null,
                diIntermediaryType: nfe.imp_intermediacao
                  ? diIntermediaryTypeList.find(
                      (way) => way.value === Number(nfe.imp_intermediacao)
                    )
                  : null,
                diAcquirerUf: nfe.imp_idestado
                  ? listUf.find((uf) => uf.id === nfe.imp_idestado.toString())
                  : null,
                diAcquirerDocument: nfe.imp_cnpj_adquirente || "",
              }
            : {},

          observacoes:
            {
              obsText: nfe.dadosadicionais,
              obsTextCFOP: nfe.dadosadicionais_cfop,
              obsTextCreditRate: nfe.dadosadicionais_creditrate,
              obsTextComplemento: nfe.dadosadicionais_complemento,
            } || "",

          /* Cliente ou Fornecedor */
          destinatario: {
            sender: destinatario,
            senderId: nfe.idclifor,
            senderClifor: nfe.clifor,
            senderIe: nfe.ie,
            senderIndicationIe:
              senderListIndicationIe.find(
                (indication) => indication.codigo === nfe.indiedest
              ) || null,
            senderCityCode: nfe.codigomunicipio,
            senderCountryCode: nfe.codigopais,
            senderName: nfe.nome,
            senderCnpj: nfe.cpfcnpj,
            senderAddres:
              ruralEstablishmentNfe?.endereco?.logradouro ||
              nfe.endlogradouro ||
              "",
            senderNumber:
              ruralEstablishmentNfe?.endereco?.numero || nfe.endnumero || "",
            senderDistrict:
              ruralEstablishmentNfe?.endereco?.bairro || nfe.endbairro,
            senderCity:
              ruralEstablishmentNfe?.endereco?.municipio?.municipio ||
              destinatario.cidade,
            senderUfLabel:
              ruralEstablishmentNfe?.endereco?.estado?.estado ||
              destinatario?.estado?.estado,
            senderCep: ruralEstablishmentNfe?.endereco?.cep || nfe.cep,
            senderPhone: nfe.telefone,
            senderMail: nfe.email,
            senderUf: destinatario.id_estado,
          },

          /* Totalizadores dos Cálculos */
          totalizadores: {
            totalNfe: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_nf).toFixed(2)
            ),
            totalValueIcms: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms).toFixed(2)
            ),
            totalBaseIcms: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_bc_icms).toFixed(2)
            ),
            totalIcmsFcp: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms_fcp).toFixed(2)
            ),
            totalIcmsDes: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icmsdeson).toFixed(2)
            ),
            totalValueSt: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms_st).toFixed(2)
            ),
            totalBaseSt: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_bc_icms_st).toFixed(2)
            ),
            totalStFcp: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms_fcp_st).toFixed(2)
            ),
            totalValueIpi: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_ipi).toFixed(2)
            ),
            totalValueIpiReturned: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_ipi_devol).toFixed(2)
            ),
            totalValuePis: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_pis).toFixed(2)
            ),
            totalValueCofins: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_cofins).toFixed(2)
            ),
            totalFreight: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_frete).toFixed(2)
            ),
            totalSafe: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_seguro).toFixed(2)
            ),
            totalOthers: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_outras).toFixed(2)
            ),
            totalDiscount: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_desconto).toFixed(2)
            ),
            totalProductValue: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_produtos).toFixed(2)
            ),
            // totalValueCustoms: "", //VERIFICAR
            // ttWithheld: "", //VERIFICAR
          },

          itens: itens,
          enderecoCobranca: enderecoCobranca,
          enderecoEntrega: enderecoEntrega,
          cobranca: cobranca,
          formapagamento: formapagamento,
          transportadora: transportadora,
          volumes: volumes,
          vendas: vendas,
          nfsRefs: nfsRefs,
          autorizadoXml: autorizadoXml,
        };

        handleSetNfeData(nfeData);
      } catch (error) {
        console.error(error);
      } finally {
        setOpenNfeLoading(false);
      }
    })();
  };

  const chainObsText = () => {
    //Montagem da observação geral
    let obsChain = "";
    if (obsTextCFOP) {
      obsChain += obsTextCFOP;
    }
    if (obsTextCreditRate) {
      if (obsChain !== "") obsChain += ", ";
      obsChain += obsTextCreditRate;
    }
    if (obsTextComplemento) {
      if (obsChain !== "") obsChain += ", ";
      obsChain += obsTextComplemento;
    }

    setObsText(obsChain);
    return obsChain;
  };

  /* Cálculo sobre os valores ANP (Combustível) */
  const calcsTotalsAnp = () => {
    itensTable.forEach((item, index) => {
      if (item?.prodFuelCodeAnp) {
        const soma =
          parseFloat(item.prodFuelGlpPetroleum.replace(",", ".")) +
          parseFloat(item.prodFuelNationalGas.replace(",", ".")) +
          parseFloat(item.prodFuelImportedGas.replace(",", "."));

        if (soma !== 100) {
          notify(
            `Soma do Rateio Combustível referente ao produto ${
              item.prodDescricao
            } ${soma > 100 ? "maior" : "menor"} que 100%.`,
            true,
            "warning"
          );
          return true;
        }
      }
    });
  };

  const handleSaveNota = () => {
    const accordionsErrors = [];

    const validateHeader = validHeader();
    const validateSender = validReceiver();
    const validateItens = validTotals();
    const validateFooter = validOthers();
    const validateShipping = validShippingCompany();
    const validateCalcAnp = calcsTotalsAnp();

    if (
      !validateHeader ||
      !validateSender ||
      !validateItens ||
      !validateFooter ||
      !validateShipping ||
      validateCalcAnp
    )
      return;

    const validationXmlAuthorized = validXmlAuthorized();
    if (!validationXmlAuthorized.isValid)
      return notify(validationXmlAuthorized.message);

    if (validateHeader?.error) accordionsErrors.push("header");
    if (validateSender?.error) accordionsErrors.push("sender");
    if (validateItens?.error) accordionsErrors.push("itens");
    if (validateFooter?.error || validateShipping?.error)
      accordionsErrors.push("footer");

    setNfeError({
      ...validateHeader.errorsValidation,
      ...validateSender.errorsValidation,
      ...validateItens.errorsValidation,
      ...validateFooter.errorsValidation,
      accordions: accordionsErrors,
    });

    if (!validateHeader || !validateSender || !validateItens || !validateFooter)
      return;

    if (
      validateHeader.error ||
      validateSender.error ||
      validateItens.error ||
      validateFooter.error
    ) {
      return notify("Verifique se os campos foram preenchidos corretamente");
    }

    if (!validPayment() || !validItens() || !validShippingCompany()) return;

    const itens = [];
    const contasreceber = {
      idsCr: nfeFinancialIssue === "NOTA" ? [...idsCrsMontage] : [],
      optFinancialSale: nfeFinancialIssue === "VENDA",
      items: [],
    };
    const cobrancas = [];
    const locais = [];
    const formaspagamentos = [];
    const transportesvolumes = [];
    const nfsRefs = [];

    itensTable.forEach((row) => {
      const pIcms = [6, 2].includes(
        parseInt((productDataCfop?.cfop || "").toString().charAt(0))
      )
        ? row.prodIcmsAliquotaInterestadual
        : row.prodIcmsAliquota;

      const itemNota = {
        /* Principal*/
        id: row.idItem,
        idestoque: parseInt(row.prodIdEstoque),
        codigo: row.prodCodigo,
        descricao: row.prodDescricao,
        difal_entrega: row.prodDifal ? 1 : 0,
        ncm: row.prodNcm,
        cfop: row.prodCfop,
        unidade: row.prodUn,
        quantidade: removeMaskDecimal(row.prodQuantidade, 4),
        vl_unitario: removeMaskDecimal(row.prodValorUnitario, 5),
        vl_total: removeMaskDecimal(row.prodValorTotal),
        cest: row.prodCest,

        /* Outros */
        gtin: row.prodGtin ? parseInt(row.prodGtin) : null,
        gtin_tributavel: row.prodGtinTrib ? parseInt(row.prodGtinTrib) : null,
        extipi: row.prodTipi ? parseInt(row.prodTipi) : null,
        unidade_entrega: row.prodUnEntrega,
        unidade_tributavel: row.prodUnTrib,
        vl_frete: removeMaskDecimal(row.prodFrete),
        quantidade_tributavel: removeMaskDecimal(row.prodQuantTrib, 4),
        valor_tributavel: removeMaskDecimal(row.prodValorTrib, 2),
        vl_seguro: removeMaskDecimal(row.prodSeguro),
        vl_desconto: removeMaskDecimal(row.prodDesconto, 5),
        vl_outras: removeMaskDecimal(row.prodDespesas),
        peso_unitario: removeMaskDecimal(row.prodUnPeso, 3),
        imp_peso: removeMaskDecimal(row.prodPesoImp),
        imp_taxa_siscomex: removeMaskDecimal(row.prodSiscomex),
        dadosadicionais: row.prodAdicional,

        /* Icms */
        origem: row?.prodOrigem?.value,
        cst_icms: row?.prodIcmsSituacao?.value,
        mod_bc_icms: row.prodIcmsModalidade
          ? row.prodIcmsModalidade.value
          : null,
        vl_bc_icms: removeMaskDecimal(row.prodIcmsValorBc)
          ? removeMaskDecimal(row.prodIcmsValorBc)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vBC"]
          ? 0
          : null,
        p_icms: removeMaskDecimal(pIcms)
          ? removeMaskDecimal(pIcms)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["pICMS"]
          ? 0
          : null,
        vl_icms: removeMaskDecimal(row.prodIcmsValor)
          ? removeMaskDecimal(row.prodIcmsValor)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vICMS"]
          ? 0
          : null,
        p_red_bc_icms: removeMaskDecimal(row.prodIcmsPercentualReductBc, 4)
          ? removeMaskDecimal(row.prodIcmsPercentualReductBc, 4)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["pRedBC"]
          ? 0
          : null,
        p_cred_icms_sn: removeMaskDecimal(row.prodIcmsAliqAplicCred)
          ? removeMaskDecimal(row.prodIcmsAliqAplicCred)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["pCredSN"]
          ? 0
          : null,
        vl_cred_icms_sn: removeMaskDecimal(row.prodIcmsCredAprov)
          ? removeMaskDecimal(row.prodIcmsCredAprov)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vCredICMSSN"]
          ? 0
          : null,
        vl_icmsdeson: removeMaskDecimal(row.prodIcmsValorDes)
          ? removeMaskDecimal(row.prodIcmsValorDes)
          : null,
        motdesicms: row.prodIcmsMotivoDes?.value,
        p_icms_fcp: removeMaskDecimal(row.prodIcmsAliquotaPob)
          ? removeMaskDecimal(row.prodIcmsAliquotaPob)
          : null,
        vl_bc_icms_fcp: removeMaskDecimal(row.prodIcmsBcPob)
          ? removeMaskDecimal(row.prodIcmsBcPob)
          : null,
        vl_icms_fcp: removeMaskDecimal(row.prodIcmsValorPob)
          ? removeMaskDecimal(row.prodIcmsValorPob)
          : null,
        pst: removeMaskDecimal(row.prodIcmsAliquotaCons)
          ? removeMaskDecimal(row.prodIcmsAliquotaCons)
          : null,
        vl_icms_substituto: removeMaskDecimal(row.prodIcmsPropSubs)
          ? removeMaskDecimal(row.prodIcmsPropSubs)
          : null,
        /* Tag cBenef */
        c_benef: row.prodIcmsCbenef,

        /* Icms ST */
        mod_bc_icms_st: row.prodIcmsStModalidade
          ? row.prodIcmsStModalidade.value
          : null,
        p_mva_icms_st: removeMaskDecimal(row.prodIcmsStPercentualAdd)
          ? removeMaskDecimal(row.prodIcmsStPercentualAdd)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["pMVAST"]
          ? 0
          : null,
        p_red_bc_icms_st: removeMaskDecimal(row.prodIcmsStPercentualBc)
          ? removeMaskDecimal(row.prodIcmsStPercentualBc)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["pRedBCST"]
          ? 0
          : null,
        vl_bc_icms_st: removeMaskDecimal(row.prodIcmsStValorBc)
          ? removeMaskDecimal(row.prodIcmsStValorBc)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vBCST"]
          ? 0
          : null,
        p_icms_st: removeMaskDecimal(row.prodIcmsStAliquota)
          ? removeMaskDecimal(row.prodIcmsStAliquota)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["pICMSST"]
          ? 0
          : null,
        vl_icms_st: removeMaskDecimal(row.prodIcmsStValor)
          ? removeMaskDecimal(row.prodIcmsStValor)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vICMSST"]
          ? 0
          : null,
        p_icms_fcp_st: removeMaskDecimal(row.prodIcmsStAliquotaPob)
          ? removeMaskDecimal(row.prodIcmsStAliquotaPob)
          : null,
        vl_bc_icms_fcp_st: removeMaskDecimal(row.prodIcmsStBcPob)
          ? removeMaskDecimal(row.prodIcmsStBcPob)
          : null,
        vl_icms_fcp_st: removeMaskDecimal(row.prodIcmsStValorPob)
          ? removeMaskDecimal(row.prodIcmsStValorPob)
          : null,
        vl_bc_icms_st_ret: removeMaskDecimal(row.prodIcmsStBcRetido)
          ? removeMaskDecimal(row.prodIcmsStBcRetido)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vBCSTret"]
          ? 0
          : null,
        vl_icms_st_ret: removeMaskDecimal(row.prodIcmsStValorRetido)
          ? removeMaskDecimal(row.prodIcmsStValorRetido)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vICMSSTRet"]
          ? 0
          : null,
        vl_bc_icms_fcp_st_ret: removeMaskDecimal(row.prodIcmsStBcFcpRetido)
          ? removeMaskDecimal(row.prodIcmsStBcFcpRetido)
          : !rulesPerCst[row?.prodIcmsSituacao?.value]["OBG"] &&
            rulesPerCst[row?.prodIcmsSituacao?.value]["vBCSTFCPRet"]
          ? 0
          : null,
        vl_icms_fcp_st_ret: removeMaskDecimal(row.prodIcmsStValorFcpRetido)
          ? removeMaskDecimal(row.prodIcmsStValorFcpRetido)
          : null,
        p_icms_fcp_st_ret: removeMaskDecimal(row.prodIcmsStAliqFcpRetido)
          ? removeMaskDecimal(row.prodIcmsStAliqFcpRetido)
          : null,

        /* Ipi a*/
        cst_ipi: row.prodIpiSituacao ? row.prodIpiSituacao.value : null,
        p_ipi: removeMaskDecimal(row.prodIpiAliquota),
        vl_bc_ipi: removeMaskDecimal(row.prodIpiBcValor),
        vl_ipi: removeMaskDecimal(row.prodIpiValor),
        vl_ipi_devol: removeMaskDecimal(row.prodIpiDevolvidoValor),
        p_ipi_devol: removeMaskDecimal(row.prodIpiDevolvidoAliquota),
        cenq:
          row.prodIpiSituacao && row.prodIpiCenq
            ? parseInt(row.prodIpiCenq)
            : row.prodIpiSituacao
            ? 999
            : null,
        p_icms_interestadual: removeMaskDecimal(
          row.prodIcmsAliquotaInterestadual
        ),
        p_icms_interna_destino: removeMaskDecimal(
          row.prodIcmsAliquotaInternaDest
        ),

        /* Pis */
        cst_pis: row.prodPisSituacao.value,
        vl_bc_pis: removeMaskDecimal(row.prodPisValorBc),
        p_pis: removeMaskDecimal(row.prodPisPercentualAliquota),
        vl_pis: removeMaskDecimal(row.prodPisValor),
        vl_aliq_pis: removeMaskDecimal(row.prodPisAliquota),

        /* Cofins */
        cst_cofins: row.prodCofinsSituacao.value,
        vl_bc_cofins: removeMaskDecimal(row.prodCofinsValorBc),
        p_cofins: removeMaskDecimal(row.prodCofinsPercentualAliquota),
        vl_cofins: removeMaskDecimal(row.prodCofinsValor),
        vl_aliq_cofins: removeMaskDecimal(row.prodCofinsAliquota),

        /* II */
        vl_bc_ii: removeMaskDecimal(row.prodIICif || "0,00"),
        vl_desp_adu_ii: removeMaskDecimal(row.prodIIDespAdu || "0,00"),
        vl_ii: removeMaskDecimal(row.prodIIImpostoImportacao || "0,00"),
        vl_alq_ii: removeMaskDecimal(row.prodIIAliq || "0,00"),
        vl_iof_ii: 0,

        imp_thc_capatazia: removeMaskDecimal(row.prodIIThc || "0,00"),
        imp_afrmm: removeMaskDecimal(row.prodIIAfrmm || "0,00"),
        imp_fob: removeMaskDecimal(row.prodIIFob || "0,00"),
        imp_frete_ii: removeMaskDecimal(row.prodIIFrete || "0,00"),
        imp_seguro_ii: removeMaskDecimal(row.prodIISeguro || "0,00"),
        imp_aduaneiro_ii: removeMaskDecimal(
          row.prodIIImpostoImportacao || "0,00"
        ),
        imp_unitario_ii: removeMaskDecimal("0,00"),
        imp_outrasdespesas_ii: removeMaskDecimal(row.prodIIOutros || "0,00"),

        /* B2b */
        b2b_itempedidocompra: (row.prodB2BItem || "").toString() || null,
        b2b_numeropedidocompra: (row.prodB2BNumero || "").toString() || null,

        /* Combustível */
        cod_anp: row.prodFuelCodeAnp,
        uf_combust: row.prodFuelUf,
        desc_anp: row.prodFuelDescAnp,
        perc_glp_derivado_petroleo: removeMaskDecimal(
          row.prodFuelGlpPetroleum || "0,0000",
          4
        ),
        perc_gas_natural_nacional: removeMaskDecimal(
          row.prodFuelNationalGas || "0,0000",
          4
        ),
        perc_gas_natural_importado: removeMaskDecimal(
          row.prodFuelImportedGas || "0,0000",
          4
        ),
        valor_partida_sem_icms: removeMaskDecimal(
          row.prodFuelValueWithoutICMS || "0,0000",
          4
        ),
      };

      if (row.prodDadosDi?.[0]) {
        const prodDadosDi = row.prodDadosDi?.[0];
        itemNota.di = {
          id: prodDadosDi.idDi || null,
          numerodi: prodDadosDi.diNumeroRegistro || null,
          dataregistro: prodDadosDi.diDataRegistro || null,
          id_estado: prodDadosDi.diUfDes?.id || null,
          cidade: prodDadosDi.diLocalDes || null,
          datadesembaraco: prodDadosDi.diDataDes || null,
          drawback: prodDadosDi.diDrawback || null,
          adicoes: {
            id: prodDadosDi.idAdicao || null,
            num_adicao: parseInt(prodDadosDi.diAdd) || null,
            num_sequencia: parseInt(prodDadosDi.diSequencia) || null,
            desconto_adicao: 0,
          },
        };
      }

      if (
        headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
        headerTypeNfe?.value === GlobalVariables.nfe.types.exit
      ) {
        itemNota.declaracao_exportacao = {
          indireta: row.isIndirectExportation,
          nro_drawback: row.exportDrawbackNumber,
          nro_registro: row.exportRegisterNumber,
          chave: row.exportAccessKey,
          qtd: removeMaskDecimal(row.exportQuantity || "0,0000", 4),
        };
      }

      itens.push(itemNota);
    });

    if (senderCheckBilling) {
      locais.push({
        tipo: "R",
        cpfcnpj: senderCnpj.replace(/[^0-9]+/g, ""),
        endlogradouro: senderBillingAddress,
        endnumero: senderBillingNumber,
        endbairro: senderBillingDistrict,
        codigomunicipio: parseInt(senderBillingCity?.codigo),
        cep: senderDeliveryCep.replace(/[^0-9]+/g, ""),
      });
    }

    if (senderCheckDelivery) {
      locais.push({
        tipo: "E",
        cpfcnpj: senderCnpj.replace(/[^0-9]+/g, ""),
        endlogradouro: senderDeliveryAddress,
        endnumero: senderDeliveryNumber,
        endbairro: senderDeliveryDistrict,
        codigomunicipio: parseInt(senderDeliveryCity.codigo),
        cep: senderDeliveryCep.replace(/[^0-9]+/g, ""),
      });
    }

    pagtoTableFormaPagto.forEach((row, index) => {
      formaspagamentos.push({
        codigo: row.pagtoFormaValue,
        valor: removeMaskDecimal(row.pagtoValor),
        vl_troco: removeMaskDecimal(row.pagtoTroco),
        cnpj_credenciadora_cartao: row.pagtoCnpjCred ? row.pagtoCnpjCred : null,
        bandeira_cartao: (row?.pagtoBandeiraValue || "").toString()
          ? row.pagtoBandeiraValue.toString()
          : "",
        codigo_autorizacao_cartao: row.pagtoCodigoCartao
          ? row.pagtoCodigoCartao
          : null,
        indpag: row.pagtoIndicadorValue ? row.pagtoIndicadorValue : null,
        tpintegra: row.pagtoIntValue ? row.pagtoIntValue : null,
      });
    });

    let auxCharge = 0;
    let copyIdsCr = nfeFinancialIssue === "NOTA" ? [...idsCrsMontage] : [];
    pagtoTableCobranca.forEach((row, index) => {
      let cobrancaNro = "---";

      if (row.cobrancaDestacaDanfe) {
        let auxNro = (index + 1).toString();
        let pad = "000";
        cobrancaNro = pad.substring(0, pad.length - auxNro.length) + auxNro;
      }

      cobrancas.push({
        id: row.id,
        numero: cobrancaNro,
        datavencto: row.cobrancaDtVenctoValue,
        valor:
          removeMaskDecimal(row.cobrancaValor) -
          removeMaskDecimal(row.cobrancaValorPago),
        destacar: row.cobrancaDestacaDanfe ? "S" : "N",
      });

      let itemCr = {
        idempresa: parseInt(queryParams.id),
        dataemissao: headerIssueDate,
        datavencto: row.cobrancaDtVenctoValue,
        valordocto: removeMaskDecimal(row.cobrancaValor),
        valordoctooriginal: removeMaskDecimal(row.cobrancaValor),
        previstorealizado: "Realizado",
        situacaodocto: row.cobrancaSituacaoValue,
        origem: "NFe",
        idcliente: senderId,
      };

      /*
        Se for Financeiro da Venda ou Edição, o ID existirá, uma vez que a tabela pagtoTableCobranca
        fora populada na montagem automática. Assim, o itemCr possuirá id e será atualizado (Numero da Nota).
        Caso Haja Diferença no Total da Nota com o Total da Cobranca (Por causa de Tributação)
        A validação obrigará o usuário a criar uma nova cobrança com a diferença. Essa  cobrança 
        não possuirá id, portanto será criado uma nova.
        Se for edição e o ID não existir, ele cria um novo Contasreceber.
      */

      if (row.idCr) {
        itemCr["id"] = row.idCr;
      } else if (row.id) {
        itemCr["id"] = row.id;
        copyIdsCr = copyIdsCr.filter((el) => el !== row.id);
      }

      /* 
        Se for Montagem Automática e Financeiro da Nota,
        Ele pega e atualiza os CR's ja existentes (Com o ID, caso exista)
        Caso não tenha mais ID's, ele Cria um novo Contasreceber.
       */

      if (
        !nfeId &&
        nfeMontageType === "A" &&
        nfeFinancialIssue === "NOTA" &&
        copyIdsCr[auxCharge] &&
        !row.id
      ) {
        itemCr["id"] = copyIdsCr[auxCharge];
        auxCharge++;
      }

      contasreceber.items.push(itemCr);
    });

    const arrTransporte = [
      {
        idtransportadora: transpId || null,
        cpfcnpj: transpCnpj ? transpCnpj.replace(/[^0-9]+/g, "") : null,
        nome: (transpName || "").substring(0, 60),
        numero: transpNumber,
        novoendereco: transpAddress,
        endereco: `${transpAddress}, ${transpNumber}`,
        codigomunicipio: transpCity ? transpCity.codigo : null,
        uf: transpUf ? transpUf.id : null,
        rntc: transpRntc,
        placaveiculo: transpBoardcar ? transpBoardcar.toString() : null,
        placaveiculouf: transpBoardcarUf ? transpBoardcarUf.toString() : null,
        ie: transpIe || null,
      },
    ];

    transpTableSize.forEach((row, index) => {
      transportesvolumes.push({
        quantidade: parseInt(row.volQuantidade),
        especie: row.volEsp || "",
        marca: row.volMarca || "",
        numeracao: row.volNumeracao || "",
        pesoliquido: removeMaskDecimal(row.volPesoLiq, 3),
        pesobruto: removeMaskDecimal(row.volPesoBruto, 3),
      });
    });

    docTable.forEach((row) => {
      nfsRefs.push({
        refnfe: row.docChaveAcesso,
        numero_serie: row.refDocSerie,
        numero_nfe: row.refDocNumber,
        data_emissao: row.refDocIssueDate,
        modelo: row.docModeloValue,
      });
    });

    let obsFinal = chainObsText();

    let hasItensToDelete = deleteItensTable.length
      ? { itens_delete: deleteItensTable }
      : {};

    const body = {
      notafiscal: {
        forceproduct: forceProduction,
        horaemissao: `${headerIssueTime.getHours()}:${
          headerIssueTime.getMinutes().length === 1
            ? `0${headerIssueTime.getMinutes()}`
            : headerIssueTime.getMinutes()
        }`,
        dataentsai: headerDateJL,
        horaentsai: `${headerTime.getHours()}:${
          headerTime.getMinutes().length === 1
            ? `0${headerTime.getMinutes()}`
            : headerTime.getMinutes()
        }`,
        idempresa: parseInt(queryParams.id),
        indicadoremitente: "P",
        clifor: senderClifor,
        idclifor: senderId || null,
        ie: senderIe ? senderIe.replace(/[^0-9]+/g, "") : null,
        iest: headerIeTax ? parseInt(headerIeTax) : null,
        nome: senderName ? senderName.substring(0, 60) : null,
        cpfcnpj: senderCnpj ? senderCnpj.replace(/[^0-9]+/g, "") : null,
        endlogradouro: senderAddress,
        endcomplemento: senderComplement || null,
        endnumero: senderNumber,
        endbairro: senderDistrict ? senderDistrict : null,
        cep: senderCep ? senderCep.replace(/[^0-9]+/g, "") : null,
        telefone: senderPhone ? senderPhone : null,
        email: senderMail ? senderMail : null,
        b2b_notaempenho: headerPurchasePublic ? headerPurchasePublic : null,
        b2b_pedidocompra: headerPurchaseOrder ? headerPurchaseOrder : null,
        b2b_contratocompra: headerPurchaseContract
          ? headerPurchaseContract
          : null,
        modelo: headerModel?.value,
        dataemissao: headerIssueDate,
        tipoimpressao: headerModel?.value === "55" ? "R" : "C",
        tipo_montagem: nfeMontageSubtype,
        tipogerarfinanceiro: "N",
        tipoemissao: headerIssueType,
        codigopais: senderCountryCode || null,
        codigomunicipio: senderCityCode,
        indiedest: senderIndicationIe?.codigo,
        modalidadefrete: transpModality.value,
        formapagamento: "0",
        serie: parseInt(headerSeries),
        tipo: headerTypeNfe.value,
        cfop: parseInt(headerCfop),
        naturezaoperacao: headerOperationNature.substr(0, 60),
        indpres: headerPresentOperation.value,
        indfinal: headerFinalCostumer.value,
        iddest: headerOperation.value,
        finalidade: headerFinnally.value,
        dadosadicionais: obsFinal,
        dadosadicionais_cfop: obsTextCFOP,
        dadosadicionais_creditrate: obsTextCreditRate,
        dadosadicionais_complemento: obsTextComplemento,
        vl_bc_icms: removeMaskDecimal(itensTotalBaseIcms) || 0,
        vl_icms: removeMaskDecimal(itensTotalValueIcms) || 0,
        vl_bc_icms_st: removeMaskDecimal(itensTotalBaseSt) || 0,
        vl_icms_st: removeMaskDecimal(itensTotalValueSt) || 0,
        vl_produtos: removeMaskDecimal(itensTotalProductValue),
        vl_frete: removeMaskDecimal(itensTotalFreight) || 0,
        vl_seguro: removeMaskDecimal(itensTotalSafe) || 0,
        vl_desconto: removeMaskDecimal(itensTotalDiscount) || 0,
        vl_ii: removeMaskDecimal(itensTotalValueII) || 0,
        vl_ipi: removeMaskDecimal(itensTotalValueIpi) || 0,
        vl_ipi_devol: removeMaskDecimal(itensTotalIpiReturned) || 0,
        vl_pis: removeMaskDecimal(itensTotalValuePis) || 0,
        vl_cofins: removeMaskDecimal(itensTotalValueCofins) || 0,
        vl_outras: removeMaskDecimal(itensTotalOthers) || 0,
        vl_nf: removeMaskDecimal(itensTotalNfe),
        indintermed: headerIndicatorIntermed
          ? parseInt(headerIndicatorIntermed.value)
          : null,
        intermed_cnpj: headerIntermedCnpj
          ? headerIntermedCnpj.replace(/[^0-9]+/g, "")
          : null,
        intermed_identificador: headerIdentifierIntermed,
        itens: itens,
        formaspagamentos: formaspagamentos,
        locais: locais,
        transportes: arrTransporte[0].nome ? arrTransporte : [],
        transportesvolumes: transportesvolumes,
        nfsRefs: nfsRefs,

        imp_via_tranporte: diImpWayOf?.value || null,
        imp_intermediacao: diIntermediaryType?.value || null,
        imp_cnpj_adquirente: diAcquirerDocument
          ? diAcquirerDocument.replace(/[^0-9]+/g, "")
          : null,
        imp_idestado: diAcquirerUf?.id || null,
        ...hasItensToDelete,
        codigoufsaidapais: ufExport?.estado || "",
        xlocexporta: exportShipmentLocation,
        xlocdespacho: exportDispatchLocation,
        autorizadoXml: xmlAuthorizedList,
        chave_nf_complementada: complementedAccessKey
          ? complementedAccessKey
          : null,
        estabelecimento_rural_id: senderRuralEstablishment?.id || null,
      },
    };

    if (senderClifor !== "F") {
      body.notafiscal.cobrancas = cobrancas;
      body.notafiscal.contasreceber = contasreceber;
    }

    if (!nfeId) body["notafiscal"]["vendas"] = nfeSales;

    (async () => {
      try {
        setMainLoading(true);
        let callback = null;

        if (nfeId) {
          callback = await updateNota(
            queryParams.empresa_cnpj,
            nfeId,
            body,
            "itens,itens.declaracaoExportacaoItem",
            parseInt(queryParams.usuario_id)
          );
        } else {
          body["notafiscal"]["regime"] = queryParams.crt;
          if (nfCloneId) body["notafiscal"]["nfCloneId"] = nfCloneId;

          callback = await createNota(
            queryParams.empresa_cnpj,
            body,
            "",
            parseInt(queryParams.usuario_id)
          );
        }

        if (callback?.data?.invalidNcms) {
          callback?.data?.invalidNcms.forEach((ncm) =>
            notify(`NCM ${ncm} não cadastrado no sistema!`)
          );
        }

        if (callback?.data?.xmlCreate || callback?.data?.xmlSign) {
          setNfeValidXml(callback?.data?.xmlCreate || callback?.data?.xmlSign);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });

          if (!callback.success) {
            return notify(
              callback?.internalCode === 207 && callback?.message
                ? callback.message
                : "Não conformidade ao gerar xml da nota.",
              true,
              "warning"
            );
          }
        }

        if (!callback.success) {
          return notify("Erro ao salvar a nota");
        }

        setHeaderAccessKey(callback.data.chaveacesso);
        setHeaderNfe(callback.data.numero);
        setNfeId(callback.data.id);
        setNfeLotes([]);
        setNfeValidXml(
          callback?.data?.xmlCreate || callback?.data?.xmlSign || ""
        );

        if (updateSender && senderClifor === "C") {
          Swal.fire({
            icon: "question",
            text: "Deseja Atualizar os Dados do Cliente Inserido?",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
          }).then(async (result) => {
            if (result.isConfirmed) {
              handleUpdateClient(senderId, {
                cliente: {
                  indiedest: senderIndicationIe?.codigo,
                  ie: senderIe.replace(/[^0-9]+/g, ""),
                },
              });
              Swal.close();
            }
          });
        }

        if (nfeMontageSubtype === "DI") {
          setSaveBlocked(true);

          if (callback.data.id && diControle?.id) {
            const newDiControle = {
              ...diControle,
              cfop:
                typeof diControle.cfop === "object"
                  ? diControle.cfop.id
                  : diControle.cfop,
              nota_fiscal_id: callback.data.id,
              status_id: GlobalVariables.nfe.distatus.nfeInTyping, //NFe - Em Digitação
            };

            delete newDiControle.declaracaoimportacao;
            delete newDiControle.fornecedor;
            delete newDiControle.notafiscal;
            delete newDiControle.transportadora;

            const callBackDi = await updateDiControle(
              newDiControle.id,
              queryParams.empresa_cnpj,
              {
                dicontrole: newDiControle,
              }
            );

            if (!callBackDi.success) {
              return notify("Erro ao vincular DI na nota");
            } else {
              setDiControle(newDiControle);
            }
          }
        }

        if (nfeId) {
          let itens = returnBuiltNfeItems(callback?.data);

          setItensTable(itens);
        } else {
          handleOpenNfe(callback?.data.id);
        }

        setDeleteItensTable([]);
        return notify("Nota Salva com Sucesso!", true, "success");
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    })();
  };

  const handleTransmitNfe = async (nfeId) => {
    if (queryParams.empresa_cnpj?.endsWith("_democ")) {
      return notify("Operação não permitida para ambiente de demonstração.");
    }
    if (nfeId) {
      setMainLoading(true);
      try {
        const callback = await transmit(queryParams.empresa_cnpj, nfeId);

        if (!callback.success) {
          if (callback?.data?.xmlSign) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            setNfeValidXml(callback?.data?.xmlSign);
            return notify("Não conformidade ao transmitir a nota.");
          }
          return notify(callback.message);
        }

        if (diControle?.id) {
          const newDiControle = {
            ...diControle,
            cfop:
              typeof diControle.cfop === "object"
                ? diControle.cfop.id
                : diControle.cfop,
            status_id: GlobalVariables.nfe.distatus.nfeTransmitted, //NFe - Transmitida
          };

          delete newDiControle.declaracaoimportacao;
          delete newDiControle.fornecedor;
          delete newDiControle.notafiscal;
          delete newDiControle.transportadora;

          const callBackDi = await updateDiControle(
            newDiControle.id,
            queryParams.empresa_cnpj,
            {
              dicontrole: newDiControle,
            }
          );

          if (!callBackDi.success) {
            notify("Erro ao atualizar status de controle da DI.");
          } else {
            setDiControle(newDiControle);
          }
        }

        setNfeValidXml("");

        const callbackNfe = await findNotas(
          queryParams.empresa_cnpj,
          nfeId,
          "nfeslotes"
        );

        if (!callbackNfe.success) return;

        setNfeStatus(callbackNfe.data.status);

        if (
          callbackNfe.data.status !== "R" &&
          !callbackNfe.data.nfeslotes.length
        ) {
          return notify("Erro ao Transmitir a nota");
        }

        if (
          callbackNfe.data.nfeslotes.length &&
          callbackNfe.data.status !== "R"
        ) {
          setNfeLotes(callbackNfe.data.nfeslotes);
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          return notify("Nota Rejeitada!");
        }

        return notify(
          "Nota Transmitida e Autorizada com Sucesso!",
          true,
          "success"
        );
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    }
  };

  const handleCalcSizes = () => {
    if (!itensTable.length > 0) {
      return notify("A nota ainda não possui nenhum item adicionado.");
    }

    let totalHasItens = 0;
    let totalHasWeight = 0;
    transpTableSize.forEach((value, index) => {
      totalHasItens += parseInt(value.volQuantidade);
      totalHasWeight += removeMaskDecimal(value.volPesoLiq, 2);
    });

    let totalWeight = 0;
    let totalItens = 0;
    let un;

    for (const row of itensTable) {
      if (!removeMaskDecimal(row.prodUnPeso, 3)) {
        return notify("Um ou mais itens não contem pesagem.");
      }
      totalWeight +=
        removeMaskDecimal(row.prodUnPeso, 3) * parseInt(row.prodQuantidade);
      totalItens += parseInt(row.prodQuantidade);
      un = row.prodUn;
    }

    if (totalHasItens === totalItens) {
      return notify("Volumes já foram adicionados.");
    }

    const itemSize = {
      index: transpTableSize.length,
      volQuantidade: totalItens,
      volEsp: un,
      volMarca: "",
      volNumeracao: "",
      volPesoLiq: MaskService.toMask(
        "decimal",
        (totalWeight - totalHasWeight).toFixed(2)
      ),
      volPesoBruto: MaskService.toMask(
        "decimal",
        (totalWeight - totalHasWeight).toFixed(2)
      ),
    };

    setTranspTableSize((current) => [...current, itemSize]);
  };

  const handleAddSizes = (setModalVolumeOpen, indexSize = null) => {
    if (!itensTable.length > 0) {
      return notify("A nota ainda não possui nenhum item adicionado.");
    }

    const validateSizes = validNotNull([
      {
        key: "volQuantity",
        value: volQuantity,
      },
      {
        key: "volNetWeight",
        value: volNetWeight,
      },
    ]);

    if (!(volQuantity && parseInt(volQuantity))) {
      validateSizes.errorsValidation.volQuantity = "Valor inválido";
      validateSizes.error = true;
    }

    if (removeMaskDecimal(volNetWeight) === 0) {
      validateSizes.errorsValidation.volNetWeight = "Valor inválido";
      validateSizes.error = true;
    }

    setVolError(validateSizes.errorsValidation);

    if (validateSizes.error) {
      return notify("Verifique se os campos foram preenchidos corretamente");
    }

    const itemSize = {
      index: indexSize !== null ? indexSize : transpTableSize.length,
      volQuantidade:
        typeof volQuantity === "string"
          ? removeMaskDecimal(volQuantity)
          : volQuantity,
      volEsp: volEsp,
      volMarca: volBrand,
      volNumeracao: volNumber,
      volPesoLiq: volNetWeight,
      volPesoBruto: volGrossWeight,
    };

    if (indexSize !== null) {
      const copyTableSize = [...transpTableSize];
      copyTableSize[indexSize] = itemSize;
      setTranspTableSize(copyTableSize);
    } else {
      setTranspTableSize((current) => [...current, itemSize]);
    }

    setVolQuantity("");
    setVolEsp("");
    setVolBrand("");
    setVolNumber("");
    setVolNetWeight("0,000");
    setVolGrossWeight("0,000");
    setModalVolumeOpen(false);
  };

  const handleAddAccesKey = () => {
    const validationFields = [
      {
        key: "docFreightModality",
        condition: docFreightModality,
        helperText: "Campo obrigatório de 44 dígitos.",
      },
    ];

    if (taxNoteDefaultModels.includes(docFreightModality?.value)) {
      validationFields.push({
        key: "docAccessKey",
        condition: docAccessKey && docAccessKey.length <= 44,
        helperText: "Campo obrigatório de 44 dígitos.",
      });
    }

    if (taxNoteRuralProducerModels.includes(docFreightModality?.value)) {
      validationFields.push(
        {
          key: "refDocSerie",
          condition: refDocSerie && refDocSerie.length <= 3,
          helperText:
            "Campo obrigatório de 3 dígitos.\n Informe '0' caso o documento fiscal não tenha série.",
        },
        {
          key: "refDocNumber",
          condition: refDocNumber && refDocNumber.length <= 9,
          helperText: "Campo obrigatório de 9 dígitos.",
        },
        {
          key: "refDocIssueDate",
          condition: refDocIssueDate,
        }
      );
    }

    const validateAccesKey = customValidation(validationFields);
    setDocError(validateAccesKey.errorsValidation);

    if (validateAccesKey.error) {
      return notify("Verifique se os campos foram preenchidos corretamente");
    }

    const itemAccesKey = {
      docChaveAcesso: docAccessKey,
      refDocSerie: refDocSerie,
      refDocNumber: refDocNumber,
      refDocIssueDate: refDocIssueDate,
      docModeloLabel: docFreightModality.label,
      docModeloValue: docFreightModality.value,
    };

    const copyTable = [...docTable, itemAccesKey];
    setDocTable(
      copyTable.map((item, i) => {
        return { ...item, index: i };
      })
    );

    setDocAccessKey(null);
    setRefDocSerie(null);
    setRefDocNumber(null);
    setRefDocIssueDate(null);
    setDocFreightModality(null);
  };

  const handleAddPayment = (setModalFormaPagtoOpen, indexPayment = null) => {
    const validatePayment = validNotNull([
      {
        key: "paymentValue",
        value: paymentValue,
      },
      {
        key: "paymentMethod",
        value: paymentMethod,
      },
    ]);

    if (!removeMaskDecimal(paymentValue) && paymentMethod?.value !== "90") {
      validatePayment.errorsValidation.productDataQuantity =
        "Quantidade invalida.";
      validatePayment.error = true;
    }

    setPaymentError(validatePayment.errorsValidation);

    if (validatePayment.error) {
      return notify("Verifique se os campos foram preenchidos corretamente");
    }

    if (paymentMethod.value === "90" && pagtoTableFormaPagto.length) {
      return notify(
        "Exclua o(s) Pagamento(s) anterior(es) para inserir essa forma de pagamento."
      );
    }

    let valid = true;
    for (const row of pagtoTableFormaPagto) {
      if (row.pagtoFormaValue === "90") {
        valid = false;
        return notify(
          `Somente uma Forma de Pagamento Pode ser Informada caso a opção seja "Sem Pagamento" `
        );
      }
    }
    if (!valid) return;

    let totalPaymentValue = 0;
    pagtoTableFormaPagto.forEach((value, index) => {
      if (indexPayment !== index) {
        totalPaymentValue += removeMaskDecimal(value.pagtoValor);
      }
    });

    totalPaymentValue += removeMaskDecimal(paymentValue);

    if (
      parseFloat(totalPaymentValue.toFixed(2)) >
      removeMaskDecimal(itensTotalNfe)
    ) {
      return notify("Valor informado Excedeu o total da nota.");
    }

    const itemPayment = createPaymentItem(
      paymentValue,
      indexPayment !== null ? indexPayment : pagtoTableFormaPagto.length,
      paymentMethod.label,
      paymentMethod.value,
      (paymentIndicator && paymentIndicator.label) || "",
      (paymentIndicator && paymentIndicator.value) || "",
      paymentTransshipment,
      paymentCnpj,
      paymentCodeCard,
      (paymentTypeIntegration && paymentTypeIntegration.label) || "",
      (paymentTypeIntegration && paymentTypeIntegration.value) || "",
      (paymentFlag && paymentFlag.sn_descricao) || "",
      (paymentFlag && paymentFlag.id) || ""
    );

    //Edição
    if (indexPayment !== null) {
      const copyPayment = [...pagtoTableFormaPagto];
      copyPayment[indexPayment] = itemPayment;
      setPagtoTableFormaPagto(copyPayment);
    } else {
      setPagtoTableFormaPagto((current) => [...current, itemPayment]);
    }

    setModalFormaPagtoOpen(false);
    setPaymentMethod(null);
    setPaymentValue("0,00");
    setPaymentIndicator({ value: "0", label: "Pagamento à Vista" });
    setPaymentTransshipment("0,00");
    setPaymentTypeIntegration(null);
    setPaymentCodeCard("");
    setPaymentCnpj("");
    setPaymentFlag(null);
    setPaymentOperator(null);
  };

  const handleAddXmlAuthorized = (
    setModalXmlAuthorized,
    indexAuthorized = null
  ) => {
    const validateXmlAuthorized = validNotNull([
      {
        key: "autDocumentType",
        value: autDocumentType,
      },
      {
        key: "autDocumentNumber",
        value: autDocumentNumber,
      },
    ]);

    if (autDocumentType.documentLength !== autDocumentNumber.length) {
      validateXmlAuthorized.errorsValidation.autDocumentNumber =
        "Documento inválido.";
      validateXmlAuthorized.error = true;
    }

    const documentNumber = autDocumentNumber.replace(/\D/g, "");
    if (
      xmlAuthorizedList?.find(
        (xmlAuth) =>
          xmlAuth.documento === documentNumber &&
          xmlAuth.index !== indexAuthorized
      )
    ) {
      validateXmlAuthorized.errorsValidation.autDocumentNumber =
        "Este documento já foi cadastrado.";
      validateXmlAuthorized.error = true;
    }

    const validationXmlAuthorized = validXmlAuthorized();
    if (!validationXmlAuthorized.isValid) {
      validateXmlAuthorized.errorsValidation.autDocumentNumber =
        validationXmlAuthorized.message;
      validateXmlAuthorized.error = true;
    }

    setModalXmlAuthorizedError(validateXmlAuthorized.errorsValidation);
    if (validateXmlAuthorized.error) {
      return notify("Verifique se os campos foram preenchidos corretamente");
    }

    const authorizedItem = {
      index:
        indexAuthorized !== null ? indexAuthorized : xmlAuthorizedList.length,
      documento: documentNumber,
      tipo: autDocumentType.label,
    };

    if (indexAuthorized !== null) {
      const copyXmlAuthorizedList = [...xmlAuthorizedList];
      copyXmlAuthorizedList[indexAuthorized] = authorizedItem;
      setXmlAuthorizedList(copyXmlAuthorizedList);
    } else {
      setXmlAuthorizedList((current) => [...current, authorizedItem]);
    }

    setAutDocumentNumber("");
    setAutDocumentType(null);
    setModalXmlAuthorized(false);
  };

  const handleEditXmlAuthorized = (indexAuthorized) => {
    const authorized = xmlAuthorizedList[indexAuthorized];
    const documentType = authorized.tipo;

    setAutDocumentNumber(
      MaskService.toMask(documentType.toLowerCase(), authorized.documento)
    );
    setAutDocumentType(listDocumentType.find((e) => e.label === documentType));
  };

  const handleEditPayment = async (indexPayment) => {
    const itemPayment = pagtoTableFormaPagto[indexPayment];

    setPaymentMethod(
      itemPayment.pagtoFormaLabel
        ? {
            label: itemPayment.pagtoFormaLabel,
            value: itemPayment.pagtoFormaValue,
          }
        : null
    );
    setPaymentValue(itemPayment.pagtoValor);
    setPaymentIndicator(
      itemPayment.pagtoIndicadorLabel
        ? {
            label: itemPayment.pagtoIndicadorLabel,
            value: itemPayment.pagtoIndicadorValue,
          }
        : null
    );
    setPaymentTransshipment(itemPayment.pagtoTroco);
    setPaymentTypeIntegration(
      itemPayment.pagtoIntLabel
        ? { label: itemPayment.pagtoIntLabel, value: itemPayment.pagtoIntValue }
        : null
    );
    setPaymentCodeCard(itemPayment.pagtoCodigoCartao);
    setPaymentCnpj(itemPayment.pagtoCnpjCred);

    setPaymentFlag(
      nfeListBandeiras.find((l) => l.id === itemPayment.pagtoBandeiraValue) ||
        null
    );

    if (itemPayment.pagtoCnpjCred && !refreshOperatorCnpj) {
      const callbackOperators = await find({
        empresaCnpj: queryParams.empresa_cnpj,
        path: "financeiro/operadoras/v1",
        where: { sn_cnpj: itemPayment.pagtoCnpjCred },
        perPage: 1,
      });

      if (callbackOperators.data.length === 1) {
        setPaymentOperator(callbackOperators.data[0]);
        setRefreshOperatorCnpj(true);
      }
    }
  };

  const handleEditSize = (indexSize) => {
    const itemSize = transpTableSize[indexSize];

    setVolQuantity(itemSize.volQuantidade);
    setVolEsp(itemSize.volEsp);
    setVolBrand(itemSize.volMarca);
    setVolNumber(itemSize.volNumeracao);
    setVolNetWeight(itemSize.volPesoLiq);
    setVolGrossWeight(itemSize.volPesoBruto);
  };

  const handleEditAccessKey = (indexAccess) => {
    const itemAccess = docTable[indexAccess];

    setDocAccessKey(itemAccess.docChaveAcesso);
    setRefDocSerie(itemAccess.refDocSerie);
    setRefDocNumber(itemAccess.refDocNumber);
    setRefDocIssueDate(itemAccess.refDocIssueDate);
    setDocFreightModality({
      label: itemAccess.docModeloLabel,
      value: itemAccess.docModeloValue,
    });

    const copyTable = [...docTable];
    copyTable.splice(indexAccess, 1);
    setDocTable(copyTable);
  };

  const handleAddCharge = (
    setModalCobrancaOpen,
    setChargeError,
    indexCharge = null
  ) => {
    const validateCharge = validNotNull([
      {
        key: "chargeMaturities",
        value: chargeMaturities,
      },
      {
        key: "chargeValue",
        value: chargeValue,
      },
    ]);

    if (removeMaskDecimal(chargeValue) === 0) {
      validateCharge.errorsValidation.chargeValue = "Valor inválido";
      validateCharge.error = true;
    }

    setChargeError(validateCharge.errorsValidation);

    if (validateCharge.error) {
      return notify("Campos Obrigatórios não preenchidos.");
    }

    let valid = true;
    for (const row of pagtoTableFormaPagto) {
      if (row.pagtoFormaValue === "90") {
        valid = false;
        return notify(
          `Você não pode inserir uma cobrança para a forma de pagamento "Sem Pagamento" `
        );
      }
    }
    if (!valid) return;
    let chargeCopy = [...pagtoTableCobranca];
    //Nova Parcela
    if (indexCharge === null) {
      let totalChargeValue = 0;
      pagtoTableCobranca.forEach((value, index) => {
        if (indexCharge !== index && value.cobrancaSituacaoValue !== "50") {
          totalChargeValue += removeMaskDecimal(value.cobrancaValor);
        }
      });

      totalChargeValue += removeMaskDecimal(chargeValue);

      if (
        parseFloat(totalChargeValue.toFixed(2)) >
        removeMaskDecimal(itensTotalNfe)
      ) {
        return notify("Valor informado Excedeu o total da nota.");
      }

      const partions = chargeMaturities.split("/");
      const aux = Math.floor(
        (removeMaskDecimal(chargeValue) / partions.length) * 100
      );
      let chargeFinalValue = aux / 100;

      const rest =
        removeMaskDecimal(chargeValue) - chargeFinalValue * partions.length;

      partions.forEach((value, index) => {
        //Calculo de Data da Cobranca
        let dueDate = new Date();
        if (parseInt(value) !== 0) {
          let chargeDate = new Date();
          dueDate.setDate(chargeDate.getDate() + parseInt(value));
        }

        dueDate = formatDate({
          date: dueDate,
          separator: "-",
          format: "yyyy-mm-dd",
        });

        let dueDateLabel = dueDate.split("-").reverse().join("/");

        if (index === partions.length - 1) chargeFinalValue += rest;

        let auxNro = (chargeCopy.length + 1).toString();
        let pad = "000";

        chargeCopy.push(
          createChargeItem(
            chargeCopy.length,
            pad.substring(0, pad.length - auxNro.length) + auxNro,
            MaskService.toMask("decimal", chargeFinalValue.toFixed(2)),
            dueDate,
            dueDateLabel
          )
        );
      });

      if (chargeCopy.length > 0) {
        setPaymentIndicator({ value: "1", label: "Pagamento à Prazo" });
      }

      //Edição da Parcela => Recalcula
    } else {
      if (removeMaskDecimal(chargeValue) > removeMaskDecimal(itensTotalNfe)) {
        return notify("Valor informado Excedeu o total da nota.");
      }

      let restPartions =
        removeMaskDecimal(itensTotalNfe) - removeMaskDecimal(chargeValue);

      chargeCopy[indexCharge].cobrancaDtVencto = chargeDueDate
        .split("-")
        .reverse()
        .join("/");
      chargeCopy[indexCharge].cobrancaDtVenctoValue = chargeDueDate;
      chargeCopy[indexCharge].cobrancaDtVenctoLabel = chargeDueDate
        .split("-")
        .reverse()
        .join("/");
      chargeCopy[indexCharge].cobrancaValor = chargeValue;

      let chargeFinalValue = 0;
      let rest = 0;

      const aux = Math.floor((restPartions / (chargeCopy.length - 1)) * 100);
      chargeFinalValue = aux / 100;
      rest = restPartions - chargeFinalValue * (chargeCopy.length - 1);

      const auxChargeCopy = [...chargeCopy];
      auxChargeCopy.splice(indexCharge, 1);

      auxChargeCopy.forEach((value, index) => {
        if (index === auxChargeCopy.length - 1) chargeFinalValue += rest;
        auxChargeCopy[index].cobrancaValor = MaskService.toMask(
          "decimal",
          chargeFinalValue.toFixed(2)
        );
      });

      auxChargeCopy.splice(indexCharge, 0, chargeCopy[indexCharge]);
      chargeCopy = [...auxChargeCopy];
    }

    setPagtoTableCobranca(chargeCopy);
    setModalCobrancaOpen(false);
    setChargeMaturities("0");
  };

  const handleCalcChargeTable = useCallback(() => {
    let payd = 0;
    pagtoTableCobranca.forEach((value, index) => {
      payd += removeMaskDecimal(value.cobrancaValor);
    });

    let charge = removeMaskDecimal(itensTotalNfe) - payd;
    if (charge * -1 > 0) charge = 0;
    setChargeValue(MaskService.toMask("decimal", charge.toFixed(2)));
  }, [pagtoTableCobranca, itensTotalNfe, setChargeValue]);

  const handleCalcPaymentTable = useCallback(
    (indexPayment = null) => {
      if (indexPayment !== null) return;
      let payd = 0;
      pagtoTableFormaPagto.forEach((value, index) => {
        payd += removeMaskDecimal(value.pagtoValor);
      });

      let payment = removeMaskDecimal(itensTotalNfe) - payd;
      if (payment * -1 > 0) payment = 0;

      setPaymentValue(MaskService.toMask("decimal", payment.toFixed(2)));
    },
    [pagtoTableFormaPagto, itensTotalNfe, setPaymentValue]
  );

  const handlePaymentOperatorByFlag = useCallback(
    async ({
      paymentFlag = null,
      indexPayment = null,
      paymentMethod = null,
    }) => {
      var callbackOperatorsByFlag;
      if (paymentFlag) {
        callbackOperatorsByFlag = await findOperadorasPorBandeira(
          queryParams.empresa_cnpj,
          paymentFlag.id
        );
      } else {
        callbackOperatorsByFlag = await findOperadoras(
          queryParams.empresa_cnpj
        );
      }

      if (callbackOperatorsByFlag?.data?.length > 0) {
        setNfeListOperadoras(callbackOperatorsByFlag.data);
        if (callbackOperatorsByFlag?.data?.length === 1) {
          if (
            (paymentMethod?.value === "03" || paymentMethod?.value === "04") &&
            !indexPayment
          ) {
            setPaymentOperator(callbackOperatorsByFlag.data[0]);
          }
        }
      }
    },
    [queryParams.empresa_cnpj, setNfeListOperadoras]
  );

  const handleAddProduct = (setModalProdutosOpen, indexProduct) => {
    const tabErrors = [];
    const validateData = validNotNull([
      {
        key: "productDataCode",
        value: productDataCode,
      },
      {
        key: "productDataDescription",
        value: productDataDescription,
      },
      {
        key: "productDataQuantity",
        value: productDataQuantity,
      },
      {
        key: "productDataUn",
        value: productDataUn,
      },
      {
        key: "productDataUnityValue",
        value: productDataUnityValue,
      },
      {
        key: "productDataNcm",
        value: productDataNcm,
      },
      {
        key: "productDataCfop",
        value: productDataCfop,
      },
    ]);

    const validateIcms = validNotNull([
      {
        key: "productIcmsSituation",
        value: productIcmsSituation,
      },
    ]);

    const validatePis = validNotNull([
      {
        key: "productPisSituation",
        value: productPisSituation,
      },
    ]);

    const validateCofins = validNotNull([
      {
        key: "productCofinsSituation",
        value: productCofinsSituation,
      },
    ]);

    if (
      removeMaskDecimal(productDataQuantity, 4) === 0 &&
      headerFinnally.value !== GlobalVariables.nfe.purpose.additionalNfe
    ) {
      validateData.errorsValidation.productDataQuantity =
        "Quantidade invalida.";
      validateData.error = true;
    }

    if (
      removeMaskDecimal(productDataUnityValue, 5) === 0 &&
      headerFinnally.value !== GlobalVariables.nfe.purpose.additionalNfe
    ) {
      validateData.errorsValidation.productDataUnityValue =
        "Preço Unitário invalido.";
      validateData.error = true;
    }

    /* Validação de Campos por CST */
    if (productIcmsSituation) {
      const cst = productIcmsSituation.value;

      if (rulesPerCst[cst]["modBc"] && !productIcmsModality) {
        validateIcms.errorsValidation.productIcmsModality =
          "Campo Obrigatório para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["Cest"] &&
        !productDataCest
      ) {
        validateData.errorsValidation.productDataCest =
          "Campo Obrigatório para o CST indicado";
        validateData.error = true;
      }

      if (rulesPerCst[cst]["modBCST"] && !productIcmsStModality) {
        validateIcms.errorsValidation.productIcmsStModality =
          "Campo Obrigatório para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["pMVAST"] &&
        !removeMaskDecimal(productIcmsStPercentAdd) &&
        productIcmsSituation.value ===
          GlobalVariables.product.icms.situations.others
      ) {
        validateIcms.errorsValidation.productIcmsStPercentAdd =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["pRedBCST"] &&
        !removeMaskDecimal(productIcmsStPercentReductBc)
      ) {
        validateIcms.errorsValidation.productIcmsStPercentReductBc =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["vBCST"] &&
        !removeMaskDecimal(productIcmsStValueBc)
      ) {
        validateIcms.errorsValidation.productIcmsStValueBc =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["pICMSST"] &&
        !removeMaskDecimal(productIcmsStAliquot)
      ) {
        validateIcms.errorsValidation.productIcmsStAliquot =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["vICMS"] &&
        !removeMaskDecimal(productIcmsValue)
      ) {
        validateIcms.errorsValidation.productIcmsValue =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["vICMSST"] &&
        !removeMaskDecimal(productIcmsStValue)
      ) {
        validateIcms.errorsValidation.productIcmsStValue =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["vBCSTret"] &&
        !removeMaskDecimal(productIcmsStValueBcRet)
      ) {
        validateIcms.errorsValidation.productIcmsStValueBcRet =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["vICMSSTRet"] &&
        !removeMaskDecimal(productIcmsStValueRet)
      ) {
        validateIcms.errorsValidation.productIcmsStValueRet =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["pCredSN"] &&
        !removeMaskDecimal(productIcmsAliquotCredit)
      ) {
        validateIcms.errorsValidation.productIcmsAliquotCredit =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["OBG"] &&
        rulesPerCst[cst]["vCredICMSSN"] &&
        !removeMaskDecimal(productIcmsCreditAprove)
      ) {
        validateIcms.errorsValidation.productIcmsCreditAprove =
          "Valor deve ser calculado para o CST indicado";
        validateIcms.error = true;
      }

      if (
        rulesPerCst[cst]["motDesICMS"] &&
        !productImcsMotivoDes &&
        parseFloat((productIcmsValueDes || "0").replace(",", ".")) > 0
      ) {
        validateIcms.errorsValidation.productImcsListReasonExemption =
          "Campo obrigatório ao indicar Valor ICMS Desonerado";
        validateIcms.error = true;
      }
    }

    if (validateData.error) tabErrors.push("data");
    if (validateIcms.error) tabErrors.push("icms");
    if (validatePis.error) tabErrors.push("pis");
    if (validateCofins.error) tabErrors.push("cofins");

    let tempProductError = {
      ...validateData.errorsValidation,
      ...validateIcms.errorsValidation,
      ...validatePis.errorsValidation,
      ...validateCofins.errorsValidation,
      tabs: tabErrors,
    };

    if (
      headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
      headerTypeNfe?.value === GlobalVariables.nfe.types.exit
    ) {
      const validationFields = [
        {
          key: "productExportRegisterNumber",
          condition:
            !productIsIndirectExportation || productExportRegisterNumber,
        },
        {
          key: "productExportAccessKey",
          condition: !productIsIndirectExportation || productExportAccessKey,
        },
        {
          key: "productExportQuantity",
          condition:
            !productIsIndirectExportation ||
            removeMaskDecimal(productExportQuantity || "0,0000", 4) > 0,
        },
      ];

      const validateExportation = customValidation(validationFields);

      if (validateExportation.error) tabErrors.push("exportacao");

      tempProductError = {
        ...tempProductError,
        ...validateExportation.errorsValidation,
      };
    }

    setProductError(tempProductError);

    if (validateData.error || validateIcms.error) {
      return notify(
        "Verfique se os campos indicados foram preenchidos corretamente"
      );
    }

    if (
      headerOperation?.value === GlobalVariables.nfe.operations.foreign &&
      headerTypeNfe?.value === GlobalVariables.nfe.types.entry &&
      !productDiTable.length
    ) {
      return notify("Adicione os campos da tabela da DI na aba II");
    }

    const index = itensTable.length;
    const itemProduct = {
      index: indexProduct !== null ? indexProduct : index,
      /* Principal */
      idItem: itemId,
      prodProdutoId: productDataId,
      prodLocalEstoque: productDataStock,
      prodIdEstoque: productDataIdStock,
      prodCodigoBarrasEstoque: productDataStockCode,
      prodCodigo: productDataCode.toString(),
      prodDescricao: productDataDescription,
      prodDifal: productCheckIcmsDifal ? 1 : 0,
      prodNcm: productDataNcm,
      prodCfop: productDataCfop ? productDataCfop.cfop : "",
      prodCfopItemList: productDataCfop,
      prodUn: productDataUn,
      prodQuantidade: productDataQuantity,
      prodValorUnitario: productDataUnityValue,
      prodValorTotal: productDataTotalValue,
      prodCest: productDataCest,

      /* Outros */
      prodGtin: productOthersGtin,
      prodGtinTrib: productOthersTaxGtin,
      prodTipi: productOthersTipi,
      prodUnEntrega: productOthersDeliveryUn,
      prodUnTrib: productOthersTaxUn,
      prodFrete: productOthersFreight,
      prodQuantTrib: productOthersTaxQuantity,
      prodTaxConvertFactor: productOthersConversionFactorTax,
      prodValorTrib: productOthersTaxValue,
      prodSeguro: productOthersSafe,
      prodDesconto: productOthersDiscount,
      prodDespesas: productOthersExpense,
      prodUnPeso: productOthersWeightUn,
      prodPesoImp: productOthersWeightIm,
      prodSiscomex: productOthersSiscomex,
      prodAdicional: productOthersAdditional,

      /* Icms */
      prodOrigem: productIcmsSource,
      prodIcmsSituacao: productIcmsSituation,
      prodIcmsModalidade: productIcmsModality,
      prodIcmsValorBc:
        removeMaskDecimal(productIcmsValue) !== 0 ? productIcmsValueBc : "0,00",
      prodIcmsAliquota: productIcmsAliquot,
      prodIcmsValor: productIcmsValue,
      prodIcmsPercentualReductBc: productIcmsPercentReduct,
      prodIcmsAliqAplicCred: productIcmsAliquotCredit,
      prodIcmsCredAprov: productIcmsCreditAprove,
      prodIcmsValorDes: productIcmsValueDes,
      prodIcmsMotivoDes: productImcsMotivoDes,
      prodIcmsAliquotaPob: productIcmsAliquotPoverty,
      prodIcmsBcPob:
        removeMaskDecimal(productIcmsValuePoverty) !== 0
          ? productIcmsBcPoverty
          : "0,00",
      prodIcmsValorPob: productIcmsValuePoverty,
      prodIcmsAliquotaCons: productIcmsAliquotSupCons,
      prodIcmsPropSubs: productIcmsOwnSubValue,

      /*Tag cBenef*/
      prodIcmsCbenef: productIcmsCbenef,

      //TAG ICMSUFDest
      prodIcmsAliquotaInterestadual: productIcmsAliquotInterstate,
      prodIcmsAliquotaInternaDest: productIcmsAliquotInternal,

      /* Icms ST */
      prodIcmsStModalidade: productIcmsStModality,
      prodIcmsStPercentualAdd: productIcmsStPercentAdd,
      prodIcmsStPercentualBc: productIcmsStPercentReductBc,
      prodIcmsStValorBc:
        removeMaskDecimal(productIcmsStValue) !== 0
          ? productIcmsStValueBc
          : "0,00",
      prodIcmsStAliquota: productIcmsStAliquot,
      prodIcmsStValor: productIcmsStValue,
      prodIcmsStAliquotaPob: productIcmsStAliquotPoverty,
      prodIcmsStBcPob:
        removeMaskDecimal(productIcmsStValuePoverty) !== 0
          ? productIcmsStBcPoverty
          : "0,00",
      prodIcmsStValorPob: productIcmsStValuePoverty,
      prodIcmsStBcRetido: productIcmsStValueBcRet,
      prodIcmsStValorRetido: productIcmsStValueRet,
      prodIcmsStBcFcpRetido: productIcmsStBcPovertyRet,
      prodIcmsStValorFcpRetido: productIcmsStValuePovertyRet,
      prodIcmsStAliqFcpRetido: productIcmsStAliqPovertyRet,

      /* Ipi */
      prodIpiCenq: productIpiCenq,
      prodIpiSituacao: productIpiSituation,
      prodIpiBcValor:
        removeMaskDecimal(productIpiValue) !== 0 ? productIpiBcValue : "0,00",
      prodIpiAliquota: productIpiAliquot,
      prodIpiValor: productIpiValue,

      /* Ipi Devolvido */
      prodIpiDevolvidoValor: productIpiReturnedValue,
      prodIpiDevolvidoAliquota: productIpiReturnedAliquot,

      /* Pis */
      prodPisSituacao: productPisSituation,
      prodPisPercentualAliquota: productPisPercentAliquot,
      prodPisAliquota: productPisAliquot,
      prodPisValorBc:
        removeMaskDecimal(productPisValue) !== 0 ? productPisBcValue : "0,00",
      prodPisValor: productPisValue,

      /* Cofins */
      prodCofinsSituacao: productCofinsSituation,
      prodCofinsPercentualAliquota: productCofinsPercentAliquot,
      prodCofinsAliquota: productCofinsAliquot,
      prodCofinsValorBc:
        removeMaskDecimal(productCofinsValue) !== 0
          ? productCofinsBcValue
          : "0,00",
      prodCofinsValor: productCofinsValue,

      /* DI */
      prodDadosDi: productDiTable,
      prodIIValorUnitario: productIIUnityValue,
      prodIIFob: productIIFob,
      prodIIFrete: productIIFreightIm,
      prodIIThc: productIIThc,
      prodIIValorAduaneiro: productIICustomsValue,
      prodIIOutros: productIIOthers,
      prodIIBcImposto: productIIBcTax,
      prodIIAliquota: productIIAliquot,
      prodIIAliquotaRed: productIIAliquotRed,
      prodIIDespesasAdu: productIITaxCustoms,
      prodIIIof: productIIIof,
      prodIIValorImposto: productIITaxIm,
      prodIIAfrmm: productIIAFRMM,
      prodIIAntidumping: productIIAntidumping,

      /* B2b */
      prodB2BNumero: productB2BNumber,
      prodB2BItem: productB2BItem,

      /* Combustível */
      prodFuelCodeAnp: productFuelCodeAnp,
      prodFuelUf: productFuelUf,
      prodFuelDescAnp: productFuelDescAnp,
      prodFuelGlpPetroleum: productFuelGlpPetroleum,
      prodFuelNationalGas: productFuelNationalGas,
      prodFuelImportedGas: productFuelImportedGas,
      prodFuelValueWithoutICMS: productFuelValueWithoutICMS,

      /* Aplicaveis Base Calculo */
      //ICMS
      prodCheckIcmsFrete: productCheckIcmsFreight,
      prodCheckIcmsSeguro: productCheckIcmsSafe,
      prodCheckIcmsOutras: productCheckIcmsOthers,
      prodCheckIcmsDesconto: productCheckIcmsDiscount,

      //IPI
      prodCheckIpiFrete: productCheckIpiFreight,
      prodCheckIpiSeguro: productCheckIpiSafe,
      prodCheckIpiOutras: productCheckIpiOthers,
      prodCheckIpiDesconto: productCheckIpiDiscount,

      //PIS
      prodCheckPisFrete: productCheckPisFreight,
      prodCheckPisSeguro: productCheckPisSafe,
      prodCheckPisOutras: productCheckPisOthers,
      prodCheckPisDesconto: productCheckPisDiscount,
      prodCheckPisDescIcms: productCheckPisDescIcms,

      //COFINS
      prodCheckCofinsFrete: productCheckCofinsFreight,
      prodCheckCofinsSeguro: productCheckCofinsSafe,
      prodCheckCofinsOutras: productCheckCofinsOthers,
      prodCheckCofinsDesconto: productCheckCofinsDiscount,
      prodCheckCofinsDescIcms: productCheckCofinsDescIcms,

      //Exportacao
      exportDrawbackNumber: productExportDrawbackNumber,
      isIndirectExportation: productIsIndirectExportation,
      exportRegisterNumber: productExportRegisterNumber,
      exportAccessKey: productExportAccessKey,
      exportQuantity: productExportQuantity,
    };

    /* Validação se é edição ou inclusão de item */
    if (indexProduct !== null) {
      const itensCopy = [...itensTable];
      itensCopy[indexProduct] = itemProduct;
      setItensTable(itensCopy);
    } else {
      setItensTable((current) => [...current, itemProduct]);
    }

    clearProductItem();
    setModalProdutosOpen(false);
  };

  const clearProductItem = () => {
    /* Cfop Padrão */
    const cfopItem = nfeListCfop.find((value) => headerCfop === value.cfop);

    /* Principal */
    setItemId(null);
    setProductTaxation(null);
    setProductData(null);
    setProductDataCode("");
    setProductDataStockCode("");
    setProductDataDescription("");
    setProductDataNcm("");
    setProductDataCest("");
    setProductDataCfop(cfopItem);
    setProductDataUn("");
    setProductDataQuantity("1,0000");
    setProductDataUnityValue("0,00000");
    setProductDataTotalValue("0,00");
    /* Outras Informações */
    setProductOthersGtin("");
    setProductOthersTaxGtin("");
    setProductOthersTipi("");
    setProductOthersDeliveryUn("");
    setProductOthersTaxUn("");
    setProductOthersFreight("0,00");
    setProductOthersTaxQuantity("1,0000");
    setProductOthersConversionFactorTax(1.0);
    setProductOthersTaxValue("0,00");
    setProductOthersSafe("0,00");
    setProductOthersDiscount("0,00000");
    setProductOthersExpense("0,00");
    setProductOthersWeightUn("0,000");
    setProductOthersWeightIm("0,00");
    setProductOthersSiscomex("0,00");
    setProductOthersAdditional("");

    /* II */
    setProductIIUnityValue("0,00");
    setProductIIFob("0,00");
    setProductIIFreightIm("0,00");
    setProductIIThc("0,00");
    setProductIICustomsValue("0,00");
    setProductIIOthers("0,00");
    setProductIIBcTax("0,00");
    setProductIIAliquot("0,00");
    setProductIIAliquotRed("0,00");
    setProductIITaxCustoms("0,00");
    setProductIIIof("0,00");
    setProductIITaxIm("0,00");
    setProductIIAntidumping("0,00");
    setProductIIAFRMM("0,00");

    /* Gasolina */
    setProductFuelCodeAnp("");
    setProductFuelDescAnp("");
    setProductFuelUf("");
    setProductFuelGlpPetroleum("0,0000");
    setProductFuelNationalGas("0,0000");
    setProductFuelImportedGas("0,0000");
    setProductFuelValueWithoutICMS("0,0000");

    /* B2b */
    setProductB2BNumber("");
    setProductB2BItem("");

    /* Item DI ABA II */
    setProductDiTable([]);

    /* Exportacao */
    setProductExportDrawbackNumber(null);
    setProductIsIndirectExportation(false);
    setProductExportRegisterNumber(null);
    setProductExportAccessKey(null);
    setProductExportQuantity("0,0000");

    //Icms, Icms St, Ipi, Ipi devolvido, Pis, Cofins, Aplicaveis BC
    clearProductItemTaxation();
  };

  const clearProductItemTaxation = () => {
    /* Icms */
    setProductIcmsSource({
      label: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
      value: "0",
    });
    setProductIcmsSituation(null);
    setProductIcmsModality(null);
    setProductIcmsPercentReduct("0,0000");
    setProductIcmsAliquotCredit("0,00");
    setProductIcmsCreditAprove("0,00");
    setProductIcmsAfrmm("0,00");
    setProductIcmsValueBc("0,00");
    setProductIcmsAliquot("0,00");
    setProductIcmsValue("0,00");
    setProductIcmsValueDes("0,00");
    setProductImcsMotivoDes(null);
    setProductIcmsAliquotPoverty("0,00");
    setProductIcmsBcPoverty("0,00");
    setProductIcmsValuePoverty("0,00");
    setProductIcmsAliquotSupCons("0,00");
    setProductIcmsOwnSubValue("0,00");
    setProductIcmsAliquotInterstate("0,00");
    setProductIcmsAliquotInternal("0,00");
    setProductIcmsCbenef("");

    /* Icms St */
    setProductIcmsStModality(null);
    setProductIcmsStPercentAdd("0,00");
    setProductIcmsStValueRet("0,00");
    setProductIcmsStValueBcRet("0,00");
    setProductIcmsStPercentReductBc("0,00");
    setProductIcmsStValueBc("0,00");
    setProductIcmsStAliquot("0,00");
    setProductIcmsStValue("0,00");
    setProductIcmsStAliquotPoverty("0,00");
    setProductIcmsStBcPoverty("0,00");
    setProductIcmsStValuePoverty("0,00");
    setProductIcmsStBcPovertyRet("0,00");
    setProductIcmsStValuePovertyRet("0,00");
    setProductIcmsStAliqPovertyRet("0,00");

    /* Ipi */
    setProductIpiSituation(null);
    setProductIpiBcValue("0,00");
    setProductIpiAliquot("0,00");
    setProductIpiValue("0,00");
    setProductIpiCenq("");

    /* Ipi Devolvido */
    setProductIpiReturnedAliquot("0,00");
    setProductIpiReturnedValue("0,00");

    /* Pis */
    setProductPisSituation(null);
    setProductPisPercentAliquot("0,00");
    setProductPisAliquot("0,00");
    setProductPisBcValue("0,00");
    setProductPisValue("0,00");

    /* Cofins */
    setProductCofinsSituation(null);
    setProductCofinsPercentAliquot("0,00");
    setProductCofinsAliquot("0,00");
    setProductCofinsBcValue("0,00");
    setProductCofinsValue("0,00");

    /* Aplicaveis base calculo */
    setProductCheckIcmsFreight(true);
    setProductCheckIcmsSafe(true);
    setProductCheckIcmsOthers(true);
    setProductCheckIcmsDiscount(true);
    setProductCheckIpiFreight(true);
    setProductCheckIpiSafe(true);
    setProductCheckIpiOthers(true);
    setProductCheckIpiDiscount(true);
    setProductCheckPisFreight(true);
    setProductCheckPisSafe(true);
    setProductCheckPisOthers(true);
    setProductCheckPisDiscount(true);
    setProductCheckPisDescIcms(true);
    setProductCheckCofinsFreight(true);
    setProductCheckCofinsSafe(true);
    setProductCheckCofinsOthers(true);
    setProductCheckCofinsDiscount(true);
    setProductCheckCofinsDescIcms(true);
    setProductCheckIcmsDifal(true);
  };

  const handleAddItemDi = (setModalItemDi) => {
    const validateProductDiTable = validNotNull([
      {
        key: "productDiNumber",
        value: diNumber,
      },
      {
        key: "productDiRegisterDate",
        value: diRegisterDate,
      },
      {
        key: "productDiClearanceUf",
        value: diClearanceUf,
      },
      {
        key: "productDiClearancePlace",
        value: diClearancePlace,
      },
      {
        key: "productDiDateDes",
        value: diDateDes,
      },
      {
        key: "productDiSequence",
        value: diSequence,
      },
      {
        key: "productDiAdd",
        value: diAdd,
      },
    ]);

    setProductError({
      ...validateProductDiTable.errorsValidation,
    });

    if (validateProductDiTable.error) {
      return notify(
        "Verfique se os campos indicados foram preenchidos corretamente"
      );
    }

    setModalItemDi(false);
    const itemDi = {
      diNumeroRegistro: diNumber,
      diDataRegistro: diRegisterDate,
      diUfDes: diClearanceUf,
      diLocalDes: diClearancePlace,
      diDataDes: diDateDes,
      diDrawback: diDrawback,
      diSequencia: diSequence,
      diAdd: diAdd,
    };

    setProductDiTable([itemDi]);

    setDiDeclarationDiNumber(diNumber);
    setDiDeclarationDate(diRegisterDate);
    setDiDeclarationUf(diClearanceUf);
    setDiDeclarationCity(diClearancePlace);
    setDiDeclarationDateDes(diDateDes);
    setDiDeclarationDrawback(diDrawback);
    setDiSequence("");
    setDiAdd("");
  };

  const handleSelectClient = (setModalClient = () => {}, selectedClient) => {
    const arrAddress = (selectedClient[0].endereco || "").split(",");

    let address = arrAddress[0] || "";
    let phone = `${
      selectedClient[0].ddd1 ? `(${selectedClient[0].ddd1})` : ""
    }${selectedClient[0].telefone1 ? selectedClient[0].telefone1 : ""}`;
    let district = selectedClient[0].bairro || "";
    let city = selectedClient[0].cidade || "";
    let uf = selectedClient[0]?.municipio?.estado?.estado || "";
    let cep = selectedClient[0].cep || "";
    let mail = selectedClient[0].email || "";
    let ie = selectedClient[0].ie || "";
    let number = arrAddress[1] || "";
    let senderRuralEstablishment = null;

    const isRuralProducer = selectedClient[0].produtor_rural === 1;
    if (isRuralProducer) {
      const defaultEstablishment = (
        selectedClient[0].estabelecimentos_rurais || []
      ).find((establishment) => establishment.principal === 1);

      if (defaultEstablishment) {
        senderRuralEstablishment = defaultEstablishment;
        address = defaultEstablishment?.endereco?.logradouro || "";
        phone = Array.isArray(defaultEstablishment?.contatos)
          ? defaultEstablishment?.contatos[0]?.telefone
          : "";
        district = defaultEstablishment?.endereco?.bairro || "";
        city = defaultEstablishment?.endereco?.municipio?.municipio || "";
        uf = defaultEstablishment?.endereco?.estado?.estado || "";
        cep = defaultEstablishment?.endereco?.cep || "";
        mail = Array.isArray(defaultEstablishment?.contatos)
          ? defaultEstablishment?.contatos[0]?.email
          : "";
        ie = defaultEstablishment?.inscricao_estadual || "";
        number = defaultEstablishment?.endereco?.numero || "";
      }
    }

    setIsRuralProducerSender(isRuralProducer);
    setSenderRuralEstablishment(senderRuralEstablishment);

    setSenderAddres(address);
    setSenderPhone(phone);
    setSenderDistrict(district);
    setSenderCity(city);
    setSenderUfLabel(uf);
    setSenderCep(cep);
    setSenderMail(mail);
    setSenderIe(ie);
    setSenderNumber(number);
    setEnableEndereco(true);
    setSender(selectedClient[0]);
    setSenderId(selectedClient[0].id || "");
    setSenderName(selectedClient[0].razao || "");
    setSenderCountryCode(selectedClient[0].idpais || "");
    setSenderCnpj(selectedClient[0].cpfcnpj || "");
    setSenderComplement(selectedClient[0].complemento || "");
    setSenderCityCode(selectedClient[0].municipio_codigo || "");
    setSenderUf(selectedClient[0].id_estado || "");
    setSenderDeliveryList(selectedClient[0].clientesentregas);
    setHeaderFinalCostumer(
      selectedClient[0].consumidorfinal === "1"
        ? {
            label: "SIM",
            value: "S",
          }
        : {
            label: "NÃO",
            value: "N",
          }
    );
    setSenderIndicationIe(
      senderListIndicationIe.find(
        (indication) => indication.codigo === selectedClient[0].indiedest
      )
    );

    /* Transportadora Vinculada ao Cliente */
    if (selectedClient[0].transportadora) {
      handleSelectShippingCompany([selectedClient[0].transportadora]);
    }

    /*Update Client */
    setGeneralIe(selectedClient[0].ie || "");
    setGeneralIeIndication(
      senderListIndicationIe.find(
        (indication) => indication.codigo === selectedClient[0].indiedest
      )
    );

    setModalClient(false);
    const deliveryClient = selectedClient[0]?.clientesentregas
      ? selectedClient[0].clientesentregas.filter(
          (current) => current?.padrao === "S"
        )
      : [];
    if (deliveryClient.length > 0) {
      const arrAddress = (deliveryClient[0].endereco || "").split(",");

      setSenderDeliveryAddress(arrAddress[0] || "");
      setSenderDeliveryNumber(arrAddress[1] || "");
      setSenderDeliveryDistrict(deliveryClient[0].bairro);
      setSenderDeliveryCity(
        listCounty.find(
          (county) => county.codigo === deliveryClient[0].municipio_codigo
        )
      );
      setSenderDeliveryUf(
        listUf.find((uf) => uf.id === deliveryClient[0].idestado)
      );
      setSenderDeliveryCep(deliveryClient[0].cep);
      setSenderDeliveryComplement(deliveryClient[0].complemento);
      setSenderDeliveryCodeCity(deliveryClient[0].municipio_codigo);
    }

    setSenderRuralEstablishmentsList(
      selectedClient[0].estabelecimentos_rurais || []
    );
  };

  const handleSelectProvider = (
    setModalProvider = () => {},
    selectedProvider
  ) => {
    let address = selectedProvider[0].endereco || "";
    let phone = selectedProvider[0].telefone1 || "";
    let district = selectedProvider[0].bairro || "";
    let city = selectedProvider[0].cidade || "";
    let uf = selectedProvider[0]?.estado?.estado || "";
    let cep = selectedProvider[0].cep || "";
    let mail = selectedProvider[0].email || "";
    let ie = selectedProvider[0].ie || "";
    let number = selectedProvider[0].numero || "";
    let providerRuralEstablishment = null;

    const isRuralProducer = selectedProvider[0].produtor_rural === 1;
    if (isRuralProducer) {
      const defaultEstablishment = (
        selectedProvider[0].estabelecimentos_rurais || []
      ).find((establishment) => establishment.principal === 1);

      if (defaultEstablishment) {
        providerRuralEstablishment = defaultEstablishment;
        address = defaultEstablishment?.endereco?.logradouro || "";
        phone = Array.isArray(defaultEstablishment?.contatos)
          ? defaultEstablishment?.contatos[0]?.telefone
          : "";
        district = defaultEstablishment?.endereco?.bairro || "";
        city = defaultEstablishment?.endereco?.municipio?.municipio || "";
        uf = defaultEstablishment?.endereco?.estado?.estado || "";
        cep = defaultEstablishment?.endereco?.cep || "";
        mail = Array.isArray(defaultEstablishment?.contatos)
          ? defaultEstablishment?.contatos[0]?.email
          : "";
        ie = defaultEstablishment?.inscricao_estadual || "";
        number = defaultEstablishment?.endereco?.numero || "";
      }
    }

    setIsRuralProducerSender(isRuralProducer);
    setSenderRuralEstablishment(providerRuralEstablishment);

    setSenderAddres(address);
    setSenderPhone(phone);
    setSenderDistrict(district);
    setSenderCity(city);
    setSenderUfLabel(uf);
    setSenderCep(cep);
    setSenderMail(mail);
    setSenderIe(ie);
    setSenderNumber(number);
    //-------------------------------------------------
    setEnableEndereco(false);
    setSender(selectedProvider[0]);
    setSenderId(selectedProvider[0].id);
    setSenderName(selectedProvider[0].razao || "");
    setSenderCountryCode(selectedProvider[0].idpais);
    setSenderUf(selectedProvider[0].id_estado);
    setSenderCnpj(selectedProvider[0].cgc);
    setSenderCityCode(selectedProvider[0].municipio_codigo);
    setSenderIndicationIe(
      senderListIndicationIe.find(
        (indication) => indication.codigo === selectedProvider[0].indiedest
      ) || {
        label: "Não Contribuinte",
        value: 0,
        codigo: "9",
      }
    );
    setModalProvider(false);
    setSenderRuralEstablishmentsList(
      selectedProvider[0].estabelecimentos_rurais || []
    );
  };

  const handleSenderRuralEstablishmentSelection = (ruralEstablishment) => {
    if (!ruralEstablishment) return;
    setSenderRuralEstablishment(ruralEstablishment);
    setSenderAddres(ruralEstablishment?.endereco?.logradouro || "");
    setSenderNumber(ruralEstablishment?.endereco?.numero || "");
    setSenderDistrict(ruralEstablishment?.endereco?.bairro || "");
    setSenderCity(ruralEstablishment?.endereco?.municipio?.municipio || "");
    setSenderUfLabel(ruralEstablishment?.endereco?.estado?.estado || "");
    setSenderCep(ruralEstablishment?.endereco?.cep || "");
    setSenderPhone(
      Array.isArray(ruralEstablishment?.contatos)
        ? ruralEstablishment?.contatos[0]?.telefone
        : ""
    );
    setSenderMail(
      Array.isArray(ruralEstablishment?.contatos)
        ? ruralEstablishment?.contatos[0]?.email
        : ""
    );
    setSenderIe(ruralEstablishment?.inscricao_estadual || "");
  };

  const handleQuantityProduct = useCallback(() => {
    if (productDataQuantity) {
      const value =
        removeMaskDecimal(productDataUnityValue || "0", 5) *
        removeMaskDecimal(productDataQuantity.toString() || "0", 4);
      setProductDataTotalValue(MaskService.toMask("decimal", value.toFixed(2)));
    }
  }, [productDataQuantity, productDataUnityValue, setProductDataTotalValue]);

  const handleSetQuantityTrib = useCallback(
    ({ value }) => {
      if (!value) return;

      setProductOthersTaxQuantity(
        MaskService.toMask(
          "decimal",
          (
            productOthersConversionFactorTax *
            removeMaskDecimal(value || "0", 4)
          ).toFixed(4),
          4
        )
      );
    },
    [productOthersConversionFactorTax, setProductOthersTaxQuantity]
  );

  const handleCfop = useCallback(
    (e) => {
      setHeaderCfop(e.target.value);
      if (nfeListCfop.length) {
        const item = nfeListCfop.find((value) => e.target.value === value.cfop);
        setHeaderOperationNature(item ? item.descricao : "");
        setProductDataCfop(item ? item : null);
        if (item && item.tipo === "E") {
          handleTypeNfe({ label: "Entrada", value: "E" });
        } else {
          handleTypeNfe({ label: "Saida", value: "S" });
          if (parseInt(parseInt(e.target.value) / 1000) === 6) {
            setHeaderOperation({ label: "Operação interestadual", value: "2" });
          } else {
            setHeaderOperation({ label: "Operação interna", value: "1" });
          }
        }
      }
    },
    // eslint-disable-next-line
    [nfeListCfop, headerCfop]
  );

  const handleTypeNfe = (e, byReciever = false) => {
    if (!e) return;

    if (e.value === "E" || e.value === "F") {
      setSenderClifor("F");
    } else {
      setSenderClifor("C");
    }

    if (e.value === "F" && headerFinnally?.value !== "4") {
      Swal.fire({
        icon: "warning",
        text: "Ao selecionar 'Fornecedor', os campos de Forma de Pagamento e Condição de Pagamento serão desabilitadas automaticamente devido à impossibilidade de geração de cobrança para fornecedores.",
        showCancelButton: true,
        showConfirmButton: true,
      });

      const itemPayment = createPaymentItem("0,00", 0, "Sem Pagamento", "90");
      setPagtoTableFormaPagto((current) => [...current, itemPayment]);
    }

    if (!nfeListCfop || !headerCfop) return;

    const item = nfeListCfop.find(
      (value) => headerCfop.toString() === value.cfop
    );

    if (!byReciever) {
      setHeaderTypeNfe(e);
      if (!item) return;

      if (item.tipo !== e.value) {
        Swal.fire({
          icon: "warning",
          text: "Opção Invalida para o CFOP Informado",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: "Entendido",
        });
      }
    }

    if (e.value !== headerTypeNfe.value) {
      setSender(null);
      setSenderDeliveryList([]);
      setEnableEndereco(false);
      setSenderCheckBilling(false);
      setSenderCheckDelivery(false);
      setSenderId("");
      setSenderCountryCode("");
      setSenderName("");
      setSenderCnpj("");
      setSenderAddres("");
      setSenderDistrict("");
      setSenderCity("");
      setSenderUf("");
      setSenderUfLabel("");
      setSenderIndicationIe(null);
      setSenderIe("");
      setSenderCep("");
      setSenderPhone("");
      setSenderMail("");
      setSenderDeliveryAddress("");
      setSenderDeliveryDistrict("");
      setSenderDeliveryCity(null);
      setSenderDeliveryUf(null);
      setSenderDeliveryCep("");
      setSenderDeliveryNumber("");
      setSenderDeliveryComplement("");
      setSenderBillingAddress("");
      setSenderBillingNumber("");
      setSenderBillingDistrict("");
      setSenderBillingCity(null);
      setSenderBillingUf(null);
      setSenderBillingCep("");
    }
  };

  const handleSelectDeliveryAddress = (setModalEntrega, index) => {
    const arrAddress = (senderDeliveryList[index]?.endereco || "").split(",");
    setSenderDeliveryAddress(arrAddress[0] || "");
    setSenderDeliveryNumber(arrAddress[1] || "");
    setSenderDeliveryDistrict(senderDeliveryList[index].bairro);
    setSenderDeliveryCity(
      listCounty.find(
        (county) => county.codigo === senderDeliveryList[index].municipio_codigo
      )
    );
    setSenderDeliveryUf(
      listUf.find((uf) => uf.id === senderDeliveryList[index].idestado)
    );
    setSenderDeliveryCep(senderDeliveryList[index].cep);
    setSenderDeliveryComplement(senderDeliveryList[index].complemento);
    setSenderDeliveryCodeCity(senderDeliveryList[index].municipio_codigo);
    setModalEntrega(false);
  };

  const handleSelectShippingCompany = useCallback(
    (selectedShippingCompany) => {
      if (selectedShippingCompany.length) {
        const arrAddress = (selectedShippingCompany[0]?.endereco || "").split(
          ","
        );

        setTransp(selectedShippingCompany[0]);
        setTranspName(selectedShippingCompany[0]?.razao || "");
        setTranspAddress(
          arrAddress[0] || selectedShippingCompany[0]?.novoendereco || ""
        );
        setTranspNumber(
          arrAddress[1] || selectedShippingCompany[0]?.numero || ""
        );
        setTranspCity(
          listCounty.find(
            (element) =>
              element.municipio === selectedShippingCompany[0]?.cidade
          ) || ""
        );
        setTranspUf(selectedShippingCompany[0]?.estado || "");
        setTranspCnpj(selectedShippingCompany[0]?.cnpj_cpf || "");
        setTranspIe(
          selectedShippingCompany[0]?.inscricao_estadual
            ? selectedShippingCompany[0]?.inscricao_estadual.replace(
                /[^0-9]+/g,
                ""
              )
            : ""
        );
        setTranspRntc(selectedShippingCompany[0]?.rntc || "");
        setTranspId(selectedShippingCompany[0]?.id || "");
        setTranspCityCode(selectedShippingCompany[0]?.municipio_codigo || "");
      }
    },
    [
      listCounty,
      setTransp,
      setTranspName,
      setTranspAddress,
      setTranspNumber,
      setTranspCity,
      setTranspUf,
      setTranspCnpj,
      setTranspIe,
      setTranspRntc,
      setTranspId,
      setTranspCityCode,
    ]
  );

  const handleSearchSelectShippingCompany = (e) => {
    if (e) {
      handleSelectShippingCompany([e]);
    }
  };

  const handleDialogShippingCompany = (
    setOpenTransp = () => {},
    selectedShippingCompany
  ) => {
    handleSelectShippingCompany(selectedShippingCompany);
    setOpenTransp(false);
  };

  const handleSetTaxation = (taxation) => {
    if (taxation) {
      setProductCheckIcmsFreight(taxation?.frete_icms === "0");
      setProductCheckIcmsSafe(taxation?.seguro_icms === "0");
      setProductCheckIcmsOthers(taxation?.outras_icms === "0");
      setProductCheckIcmsDiscount(taxation?.desconto_icms === "0");
      setProductCheckIpiFreight(taxation?.frete_ipi === "0");
      setProductCheckIpiSafe(taxation?.seguro_ipi === "0");
      setProductCheckIpiOthers(taxation?.outras_ipi === "0");
      setProductCheckIpiDiscount(taxation?.desconto_ipi === "0");
      setProductCheckPisFreight(taxation?.frete_pis === "0");
      setProductCheckPisSafe(taxation?.seguro_pis === "0");
      setProductCheckPisOthers(taxation?.outras_pis === "0");
      setProductCheckPisDiscount(taxation?.desconto_pis === "0");
      setProductCheckPisDescIcms(taxation?.desc_icms_pis === 0);
      setProductCheckCofinsFreight(taxation?.frete_cofins === "0");
      setProductCheckCofinsSafe(taxation?.seguro_cofins === "0");
      setProductCheckCofinsOthers(taxation?.outras_cofins === "0");
      setProductCheckCofinsDiscount(taxation?.desconto_cofins === "0");
      setProductCheckCofinsDescIcms(taxation?.desc_icms_cofins === 0);

      /* CEST */
      setMainLoading(true);

      /* GERAL */
      setProductTaxation(taxation);

      /* ICMS */
      const icmsSituation =
        queryParams.crt === "1" || queryParams.crt === "4"
          ? productIcmsListSimpleTaxationSituation.find(
              (value) => taxation.cst_icms === value.value
            )
          : productIcmsListNormalTaxationSituation.find(
              (value) => taxation.cst_icms === value.value
            );

      setProductIcmsSituation(icmsSituation || null);

      setProductIcmsSource(
        productIcmsListSource.find(
          (source) => source.value === taxation.origem
        ) || null
      );

      const icmsModality = productIcmsListModality.find(
        (value) => taxation.mod_bc_icms === value.value
      );
      setProductIcmsModality(icmsModality || null);

      setProductIcmsPercentReduct(
        MaskService.toMask(
          "decimal",
          taxation.p_red_bc_icms
            ? parseFloat(taxation.p_red_bc_icms).toFixed(4)
            : "0,0000",
          4
        )
      );

      setProductIcmsAliquot(
        MaskService.toMask(
          "decimal",
          taxation.p_icms
            ? parseFloat(taxation.p_icms).toFixed(2)
            : productCopyIcmsAliquotInterstate || "0,00"
        )
      );

      setProductIcmsAliquotPoverty(
        MaskService.toMask(
          "decimal",
          parseFloat(taxation.p_icms_fcp).toFixed(2),
          2
        )
      );

      let aliquotCredit = taxation.p_cred_icms_sn
        ? MaskService.toMask(
            "decimal",
            parseFloat(taxation.p_cred_icms_sn).toFixed(2)
          )
        : "0,00";

      setProductIcmsAliquotCredit(aliquotCredit);

      handleCreditIcms(icmsSituation || null, aliquotCredit || null);

      /* Tag cBenef */
      setProductIcmsCbenef(taxation.c_benef || "");

      /* ICMS Interestadual com calculo Difal */
      if (taxation.tributacaointerestadual?.[0]?.p_icms_interestadual) {
        let tempIcms = MaskService.toMask(
          "decimal",
          parseFloat(
            taxation.tributacaointerestadual[0].p_icms_interestadual
          ).toFixed(2),
          2
        );
        setProductIcmsAliquot(tempIcms);
        setProductIcmsAliquotInterstate(tempIcms);
        setProductIcmsAliquotInternal(
          MaskService.toMask(
            "decimal",
            taxation.tributacaointerestadual[0]?.p_icms_interna_destino
              ? parseFloat(
                  taxation.tributacaointerestadual[0].p_icms_interna_destino
                ).toFixed(2)
              : "0,00",
            2
          )
        );
        setProductIcmsAliquotPoverty(
          MaskService.toMask(
            "decimal",
            taxation.tributacaointerestadual[0]?.p_icms_fcp
              ? parseFloat(
                  taxation.tributacaointerestadual[0].p_icms_fcp
                ).toFixed(2)
              : taxation.p_icms_fcp
              ? parseFloat(taxation.p_icms_fcp).toFixed(2)
              : "0,00",
            2
          )
        );
      }

      /* ICMS ST */
      const icmsStModality = productIcmsStListModality.find(
        (value) => taxation.mod_bc_icms_st === value.value
      );

      let ufDestino = !senderCheckDelivery
        ? senderUfLabel
        : senderDeliveryUf.estado;

      const stTaxation = taxation.tributacaost?.find(
        (value) => value.ufdestino === ufDestino
      );

      setProductIcmsStModality(icmsStModality || null);
      setProductIcmsStPercentAdd(
        MaskService.toMask(
          "decimal",
          stTaxation
            ? parseFloat(stTaxation.p_mva_icms_st).toFixed(2)
            : taxation?.p_mva_icms_st
            ? parseFloat(taxation.p_mva_icms_st).toFixed(2)
            : taxation?.sticms
            ? parseFloat(taxation.sticms).toFixed(2)
            : "0,00"
        )
      );
      setProductIcmsStPercentReductBc(
        MaskService.toMask(
          "decimal",
          taxation.p_red_bc_icms_st
            ? parseFloat(taxation.p_red_bc_icms_st).toFixed(2)
            : "0,00"
        )
      );

      setProductIcmsStAliquot(
        MaskService.toMask(
          "decimal",
          stTaxation?.p_icms_st
            ? parseFloat(stTaxation.p_icms_st).toFixed(2)
            : "0,00"
        )
      );

      /* IPI */
      setProductIpiCenq(taxation.cenq || "");

      const ipiSituation = prodcuctIpiListSituation.find(
        (value) => taxation.cst_ipi === value.value
      );
      setProductIpiSituation(ipiSituation || null);
      setProductIpiAliquot(
        MaskService.toMask(
          "decimal",
          taxation.p_ipi ? parseFloat(taxation.p_ipi).toFixed(2) : "0,00"
        )
      );

      /* IPI Devolvido */
      setProductIpiReturnedAliquot(
        MaskService.toMask(
          "decimal",
          taxation.p_ipi_devol
            ? parseFloat(taxation.p_ipi_devol).toFixed(2)
            : "0,00"
        )
      );
      setProductIpiReturnedValue(
        MaskService.toMask(
          "decimal",
          taxation.vl_ipi_devol
            ? parseFloat(taxation.vl_ipi_devol).toFixed(2)
            : "0,00"
        )
      );

      /* PIS */
      const pisModality = prodcuctPisListSituation.find(
        (value) => taxation.cst_pis === value.value
      );
      setProductPisSituation(pisModality || null);
      setProductPisPercentAliquot(
        MaskService.toMask(
          "decimal",
          taxation.p_pis ? parseFloat(taxation.p_pis).toFixed(2) : "0,00"
        )
      );

      /* COFINS */
      const cofinsModality = productCofinsListSituation.find(
        (value) => taxation.cst_cofins === value.value
      );
      setProductCofinsSituation(cofinsModality || null);
      setProductCofinsPercentAliquot(
        MaskService.toMask(
          "decimal",
          taxation.p_cofins ? parseFloat(taxation.p_cofins).toFixed(2) : "0,00"
        )
      );

      setMainLoading(false);
    }
  };

  const taxationByCompany = (element) =>
    element.empresa.some(
      (empresa) => empresa.id === Number(queryParams.empresa_id)
    );

  const filterByState = ({ data, state }) =>
    data.filter((element) => element.ufdestino === state);

  const taxationIsNotCf = (element) => element.tipo_documento !== "C";

  const handleNcm = async ({ ncm, productId, cfop, difalChecked }) => {
    if (ncm) {
      try {
        setMainLoading(true);

        //utilizando itensTable[0].prodProdutoId porque quando acionado esta função
        //na tabEmissaoICMS n contém id do produto vinculado direto ao state productDataId
        //(mas isso só se aplica quando for montagem automática)
        if (productId || itensTable[0]?.prodProdutoId) {
          let ufDestino = !senderCheckDelivery
            ? senderUfLabel
            : senderDeliveryUf.estado;

          let difal = false;
          //Tratativa sobre DIFAL
          if (
            [6].includes(parseInt(productDataCfop.cfop.toString().charAt(0))) &&
            senderIndicationIe?.codigo === "9"
          ) {
            const callbackDifal = await handleVerificationDifal({
              ncm,
              cfop,
              ufDestino,
              difalChecked,
            });
            ufDestino = callbackDifal?.difalUfDestino;
            difal = callbackDifal?.difalValue;
          }

          let tipoDocumento = `${GlobalVariables.taxation.documentType.all},${GlobalVariables.taxation.documentType.invoice}`;
          let tipoDestinatario = `${GlobalVariables.taxation.recipientType.all}`;

          if (sender) {
            tipoDestinatario +=
              sender.simples_nacional === "S"
                ? `,${GlobalVariables.taxation.recipientType.simpleNational}`
                : `,${GlobalVariables.taxation.recipientType.normalRegime}`;
          }

          const callbackByProduct = await findTributacoesByIdProductOrNcms(
            queryParams.empresa_cnpj,
            queryParams.id || "",
            productId || itensTable[0].prodProdutoId,
            ncm,
            cfop || productDataCfop.cfop,
            ufDestino,
            difal,
            tipoDocumento,
            tipoDestinatario
          );

          if (callbackByProduct?.data?.length > 0) {
            //Função responsável por preencher as tributações
            handleSetTaxation(callbackByProduct?.data[0]);
            return;
          }
        }

        const callbackByNcm = await findTributacoes(
          queryParams.empresa_cnpj,
          {
            ncm: ncm,
            cfop: cfop || productDataCfop.cfop,
          },
          {},
          "cfop,empresa,tributacaost"
        );

        if (callbackByNcm.data) {
          handleSetTaxation(callbackByNcm.data.filter(taxationByCompany)[0]);
        }

        clearProductItemTaxation();
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    }
  };

  const handleSearchProductByCode = (e) => {
    let typingTimer = null;
    setProductDataCode(e.target.value);
    clearTimeout(timerProductCode);
    typingTimer = setTimeout(async () => {
      try {
        if (e.target.value) {
          setMainLoading(true);
          const where = {
            active: "SIM",
            codeBar: e.target.value,
            ...(productDataStock && { idStockLocation: productDataStock.id }),
            travarnf: 0,
          };

          const product = await findProdutosAlternativeFormatted({
            empresa_cnpj: queryParams.empresa_cnpj,
            where: where,
          });
          if (product.success) {
            handleSelectProduct(() => {}, product.data);
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }
    }, 1200);
    setTimerProductCode(typingTimer);
  };

  const handleSelectProductBySelect = (e) => {
    setProductData(e);
    handleSelectProduct(() => {}, [e]);
  };

  const handleSelectProduct = (setModalProduct = () => {}, selectedProduct) => {
    //Principal
    if (!selectedProduct.length || !selectedProduct[0]) return;

    setProductDataId(selectedProduct[0].id);
    setProductDataIdStock(selectedProduct[0].estoques[0].id);
    setProductDataStockCode(selectedProduct[0].estoques[0].codigobarras);
    setProductDataCode(
      getCodeBarProduct(selectedProduct[0], "TabEmissaoDadosProduto")
    );
    setProductData(
      selectedProduct[0]
        ? {
            descricao_final:
              selectedProduct[0].descricao_final ||
              selectedProduct[0].descricao ||
              "",
          }
        : null
    );
    setProductDataDescription(
      getDescriptionProduct(selectedProduct[0], "TabEmissaoDadosProduto")
    );
    setProductDataNcm(selectedProduct[0].ncm || "");
    setProductDataCest(selectedProduct[0].cest || "");
    setProductDataUn(
      selectedProduct[0].unidade_venda || selectedProduct[0].unidade || ""
    );

    //Validação de Preco
    let discountProduct = selectedProduct[0]?.perc_desc_codigoalternativo ?? 0;
    let price = 0;
    let taxValue = 0;
    let precoUnico = "0,00";
    let valorTrib = "0,00";
    if (queryParams.paramprecoestoqueunico === "SIM") {
      price = selectedProduct[0].precovenda
        ? parseFloat(selectedProduct[0].precovenda).toFixed(5)
        : 0;

      taxValue = selectedProduct[0].valor_tributavel
        ? parseFloat(selectedProduct[0].valor_tributavel).toFixed(2)
        : 0;
    } else {
      price = selectedProduct[0].estoques[0].precovenda
        ? parseFloat(selectedProduct[0]?.estoques[0]?.precovenda).toFixed(5)
        : 0;

      taxValue = selectedProduct[0].estoques[0].valor_tributavel
        ? parseFloat(selectedProduct[0]?.estoques[0]?.valor_tributavel).toFixed(
            2
          )
        : 0;
    }

    precoUnico = MaskService.toMask("decimal", price, 5);
    valorTrib = MaskService.toMask("decimal", taxValue);

    setProductDataUnityValue(precoUnico);
    setProductOthersTaxValue(valorTrib);

    //Outros
    setProductOthersGtin(selectedProduct[0].gtin || "");
    setProductOthersTaxGtin(selectedProduct[0].gtin_tributavel || "");
    setProductOthersDeliveryUn(selectedProduct[0].unidade_entrega || "");
    setProductOthersTaxUn(selectedProduct[0].unidade_tributavel || "");
    setProductOthersFreight(
      MaskService.toMask("decimal", selectedProduct[0].frete || "0,00")
    );

    let othersTaxtQuantity = MaskService.toMask(
      "decimal",
      (
        parseFloat(selectedProduct[0].fator_conversao_tributavel) *
        parseFloat(selectedProduct[0].qtdvenda_codigoalternativo || 1.0)
      ).toFixed(4),
      4
    );

    setProductOthersConversionFactorTax(
      selectedProduct[0].fator_conversao_tributavel || 1.0
    );

    setProductOthersTaxQuantity(othersTaxtQuantity);

    setProductOthersSafe(
      MaskService.toMask("decimal", selectedProduct[0].seguro || "0,00")
    );
    if (discountProduct > 0) {
      setProductOthersDiscount(
        MaskService.toMask(
          "decimal",
          (price * (discountProduct / 100)).toFixed(5),
          5
        )
      );
    } else {
      setProductOthersDiscount(
        MaskService.toMask(
          "decimal",
          (parseFloat(selectedProduct[0].desconto || 0) || 0).toFixed(5),
          5
        )
      );
    }
    setProductDataQuantity(
      MaskService.toMask(
        "decimal",
        selectedProduct[0].qtdvenda_codigoalternativo
          ? parseFloat(selectedProduct[0]?.qtdvenda_codigoalternativo).toFixed(
              4
            )
          : "1,0000",
        4
      )
    );
    setProductOthersExpense(
      MaskService.toMask("decimal", selectedProduct[0].outrasdesp || "0,00")
    );
    setProductOthersWeightUn(
      MaskService.toMask(
        "decimal",
        parseFloat(selectedProduct[0].peso || 0).toFixed(3) || "0,000",
        3
      )
    );

    handleNcm({
      ncm: selectedProduct[0].ncm || "",
      productId: selectedProduct[0].id,
      cfop: productDataCfop?.cfop,
    });
    handleCreditIcms();

    handleSetFuels({ productId: selectedProduct[0].id });

    setModalProduct(false);
  };

  /* Set Combustível */
  const handleSetFuels = async ({ productId }) => {
    if (
      !listCfopFuel.find((e) => e.label === productDataCfop?.cfop?.substr(-3))
    )
      return;
    const myProducts = await findProdutos({
      empresa_cnpj: queryParams.empresa_cnpj,
      id: productId,
    });

    setProductFuelCodeAnp(myProducts?.data.cod_anp);
    setProductFuelDescAnp(myProducts?.data.desc_anp);
    setProductFuelUf(
      !senderCheckDelivery ? senderUfLabel : senderDeliveryUf.estado
    );

    setProductFuelGlpPetroleum(
      MaskService.toMask(
        "decimal",
        parseFloat(myProducts?.data.perc_glp_derivado_petroleo || 0).toFixed(4),
        4
      )
    );
    setProductFuelNationalGas(
      MaskService.toMask(
        "decimal",
        parseFloat(myProducts?.data.perc_gas_natural_nacional || 0).toFixed(4),
        4
      )
    );
    setProductFuelImportedGas(
      MaskService.toMask(
        "decimal",
        parseFloat(myProducts?.data.perc_gas_natural_importado || 0).toFixed(4),
        4
      )
    );
    setProductFuelValueWithoutICMS(
      MaskService.toMask(
        "decimal",
        parseFloat(myProducts?.data.valor_partida_sem_icms || 0).toFixed(4),
        4
      )
    );
  };

  const handleVerificationDifal = async ({
    ncm,
    cfop,
    ufDestino,
    difalChecked,
  }) => {
    let difalValue = difalChecked;

    if (typeof difalChecked === "undefined") {
      const callbackDifal = await findTributacoes(
        queryParams.empresa_cnpj,
        {
          ncm: ncm,
          cfop: cfop || headerCfop,
        },
        {},
        "cfop,empresa,tributacaost,tributacaointerestadual"
      );

      difalValue =
        callbackDifal?.data?.[0]?.tributacaointerestadual.filter(
          (tri) => tri.ufdestino === ufDestino
        )[0]?.difal_entrega === "1";

      if (!difalValue) {
        difalValue = false;
      }
    }

    if ((difalValue || difalChecked) && !senderCheckDelivery) {
      setProductCheckIcmsDifal(false);
      difalValue = false;

      const body = {
        difalValue: difalValue,
        difalUfDestino: ufDestino,
      };
      return body;
    } else {
      setProductCheckIcmsDifal(difalValue);
      ufDestino = !difalValue ? senderUfLabel : senderDeliveryUf.estado;
    }

    const body = {
      difalValue: difalValue,
      difalUfDestino: ufDestino,
    };

    return body;
  };

  const handleCheckCobranca = () => {
    setSenderCheckBilling((current) => !current);
    if (senderCheckBilling) return;

    const arrAddress = (sender.endereco_cobranca || "").split(",");

    setSenderBillingAddress(arrAddress[0] || "");
    setSenderBillingNumber(arrAddress[1] || "");
    setSenderBillingDistrict(sender.bairro_cobranca);
    setSenderBillingCity(
      listCounty.find(
        (county) => county.codigo === sender.municipio_codigo_cobranca || null
      )
    );
    setSenderBillingUf(
      listUf.find((uf) => uf.id === sender.id_estado_cobranca) || null
    );
    setSenderBillingCep(sender.cep_cobranca);
  };

  const handleEditItemProduct = (index) => {
    const editItem = itensTable[index];
    setItemId(editItem.idItem || null);
    /* Principal */
    setProductDataStock(
      (current) =>
        nfeListStockLocation.find(
          (stock) => stock.id === editItem.prodLocalEstoque?.id
        ) || current
    );
    setProductDataIdStock(editItem.prodIdEstoque);
    setProductDataCode(getCodeBarProduct(editItem, "AccordionEmissaoItens"));
    setProductData({ descricao_final: editItem.prodDescricao });
    setProductDataDescription(
      getDescriptionProduct(editItem, "AccordionEmissaoItens")
    );
    setProductDataNcm(editItem.prodNcm);
    setProductDataCest(editItem.prodCest);
    setProductDataCfop(editItem.prodCfopItemList);
    setProductDataUn(editItem.prodUn);
    setProductDataQuantity(editItem.prodQuantidade);
    setProductDataUnityValue(editItem.prodValorUnitario);
    setProductDataTotalValue(editItem.prodValorTotal);

    /* Outras Informações */
    setProductOthersGtin(editItem.prodGtin);
    setProductOthersTaxGtin(editItem.prodGtinTrib);
    setProductOthersTipi(editItem.prodTipi);
    setProductOthersDeliveryUn(editItem.prodUnEntrega);
    setProductOthersTaxUn(editItem.prodUnTrib);
    setProductOthersFreight(editItem.prodFrete);
    setProductOthersTaxQuantity(editItem.prodQuantTrib);
    setProductOthersConversionFactorTax(editItem.prodTaxConvertFactor || 1.0);
    setProductOthersTaxValue(editItem.prodValorTrib);
    setProductOthersSafe(editItem.prodSeguro);
    setProductOthersDiscount(editItem.prodDesconto);
    setProductOthersExpense(editItem.prodDespesas);
    setProductOthersWeightUn(editItem.prodUnPeso);
    setProductOthersWeightIm(editItem.prodPesoImp);
    setProductOthersSiscomex(editItem.prodSiscomex);
    setProductOthersAdditional(editItem.prodAdicional);

    /* Icms */
    setProductIcmsSource(editItem.prodOrigem);
    setProductIcmsSituation(editItem.prodIcmsSituacao);
    setProductIcmsModality(editItem.prodIcmsModalidade);
    setProductIcmsAliquotCredit(editItem.prodIcmsAliqAplicCred);
    setProductIcmsCreditAprove(editItem.prodIcmsCredAprov);
    setProductIcmsPercentReduct(editItem.prodIcmsPercentualReductBc);
    setProductIcmsAfrmm(editItem.prodIcmsAfrmm);
    setProductIcmsValueBc(editItem.prodIcmsValorBc);
    setProductIcmsAliquot(editItem.prodIcmsAliquota);
    setProductIcmsValue(editItem.prodIcmsValor);
    setProductIcmsValueDes(editItem.prodIcmsValorDes);
    setProductImcsMotivoDes(editItem.prodIcmsMotivoDes);
    setProductIcmsAliquotPoverty(editItem.prodIcmsAliquotaPob);
    setProductIcmsBcPoverty(editItem.prodIcmsBcPob);
    setProductIcmsValuePoverty(editItem.prodIcmsValorPob);
    setProductIcmsAliquotSupCons(editItem.prodIcmsAliquotaCons);
    setProductIcmsOwnSubValue(editItem.prodIcmsPropSubs);
    setProductIcmsAliquotInterstate(editItem.prodIcmsAliquotaInterestadual);
    setProductIcmsAliquotInternal(editItem.prodIcmsAliquotaInternaDest);
    setProductCheckIcmsDifal(editItem.prodDifal);
    setProductIcmsCbenef(editItem.prodIcmsCbenef);

    /* Icms ST */
    setProductIcmsStModality(editItem.prodIcmsStModalidade);
    setProductIcmsStPercentAdd(editItem.prodIcmsStPercentualAdd);
    setProductIcmsStValueBcRet(editItem.prodIcmsStBcRetido);
    setProductIcmsStValueRet(editItem.prodIcmsStValorRetido);
    setProductIcmsStPercentReductBc(editItem.prodIcmsStPercentualBc);
    setProductIcmsStValueBc(editItem.prodIcmsStValorBc);
    setProductIcmsStAliquot(editItem.prodIcmsStAliquota);
    setProductIcmsStValue(editItem.prodIcmsStValor);
    setProductIcmsStAliquotPoverty(editItem.prodIcmsStAliquotaPob);
    setProductIcmsStBcPoverty(editItem.prodIcmsStBcPob);
    setProductIcmsStValuePoverty(editItem.prodIcmsStValorPob);
    setProductIcmsStBcPovertyRet(editItem.prodIcmsStBcFcpRetido);
    setProductIcmsStValuePovertyRet(editItem.prodIcmsStValorFcpRetido);
    setProductIcmsStAliqPovertyRet(editItem.prodIcmsStAliqFcpRetido);

    /* Ipi */
    setProductIpiSituation(editItem.prodIpiSituacao);
    setProductIpiBcValue(editItem.prodIpiBcValor);
    setProductIpiAliquot(editItem.prodIpiAliquota);
    setProductIpiValue(editItem.prodIpiValor);
    setProductIpiCenq(editItem.prodIpiCenq);

    /* Ipi Devolvido */
    setProductIpiReturnedAliquot(editItem.prodIpiDevolvidoAliquota);
    setProductIpiReturnedValue(editItem.prodIpiDevolvidoValor);

    /* Pis */
    setProductPisSituation(editItem.prodPisSituacao);
    setProductPisPercentAliquot(editItem.prodPisPercentualAliquota);
    setProductPisAliquot(editItem.prodPisAliquota);
    setProductPisBcValue(editItem.prodPisValorBc);
    setProductPisValue(editItem.prodPisValor);

    /* Cofins */
    setProductCofinsSituation(editItem.prodCofinsSituacao);
    setProductCofinsPercentAliquot(editItem.prodCofinsPercentualAliquota);
    setProductCofinsAliquot(editItem.prodCofinsAliquota);
    setProductCofinsBcValue(editItem.prodCofinsValorBc);
    setProductCofinsValue(editItem.prodCofinsValor);

    /* DI */
    setProductDiTable(editItem.prodDadosDi);

    /* II */
    setProductIIFob(editItem.prodIIFob);
    setProductIIFreightIm(editItem.prodIIFrete);
    setProductIISafeIm(editItem.prodIISeguro);
    setProductIICustomsValue(editItem.prodIICif);
    setProductIITaxIm(editItem.prodIIImpostoImportacao);
    setProductIITaxCustoms(editItem.prodIIDespAdu);
    setProductIIThc(editItem.prodIIThc);
    setProductIIAntidumping(editItem.prodIIAntidumping);
    setProductIIAFRMM(editItem.prodIIAfrmm);
    setProductIIOthers(editItem.prodIIOutros);

    /* B2b */
    setProductB2BNumber(editItem.prodB2BNumero);
    setProductB2BItem(editItem.prodB2BItem);

    /* Combustível */
    setProductFuelCodeAnp(editItem.prodFuelCodeAnp);
    setProductFuelUf(editItem.prodFuelUf);
    setProductFuelDescAnp(editItem.prodFuelDescAnp);
    setProductFuelGlpPetroleum(editItem.prodFuelGlpPetroleum);
    setProductFuelNationalGas(editItem.prodFuelNationalGas);
    setProductFuelImportedGas(editItem.prodFuelImportedGas);
    setProductFuelValueWithoutICMS(editItem.prodFuelValueWithoutICMS);

    /* Exportação */
    setProductExportDrawbackNumber(editItem.exportDrawbackNumber);
    setProductIsIndirectExportation(editItem.isIndirectExportation);
    setProductExportRegisterNumber(editItem.exportRegisterNumber);
    setProductExportAccessKey(editItem.exportAccessKey);
    setProductExportQuantity(editItem.exportQuantity);

    setProductCheckIcmsFreight(
      typeof editItem.prodCheckIcmsFrete !== "undefined"
        ? editItem.prodCheckIcmsFrete
        : true
    );
    setProductCheckIcmsSafe(
      typeof editItem.prodCheckIcmsSeguro !== "undefined"
        ? editItem.prodCheckIcmsSeguro
        : true
    );
    setProductCheckIcmsOthers(
      typeof editItem.prodCheckIcmsOutras !== "undefined"
        ? editItem.prodCheckIcmsOutras
        : true
    );
    setProductCheckIcmsDiscount(
      typeof editItem.prodCheckIcmsDesconto !== "undefined"
        ? editItem.prodCheckIcmsDesconto
        : true
    );
    setProductCheckIpiFreight(
      typeof editItem.prodCheckIpiFrete !== "undefined"
        ? editItem.prodCheckIpiFrete
        : true
    );
    setProductCheckIpiSafe(
      typeof editItem.prodCheckIpiSeguro !== "undefined"
        ? editItem.prodCheckIpiSeguro
        : true
    );
    setProductCheckIpiOthers(
      typeof editItem.prodCheckIpiOutras !== "undefined"
        ? editItem.prodCheckIpiOutras
        : true
    );
    setProductCheckIpiDiscount(
      typeof editItem.prodCheckIpiDesconto !== "undefined"
        ? editItem.prodCheckIpiDesconto
        : true
    );
    setProductCheckPisFreight(
      typeof editItem.prodCheckPisFrete !== "undefined"
        ? editItem.prodCheckPisFrete
        : true
    );
    setProductCheckPisSafe(
      typeof editItem.prodCheckPisSeguro !== "undefined"
        ? editItem.prodCheckPisSeguro
        : true
    );
    setProductCheckPisOthers(
      typeof editItem.prodCheckPisOutras !== "undefined"
        ? editItem.prodCheckPisOutras
        : true
    );
    setProductCheckPisDiscount(
      typeof editItem.prodCheckPisDesconto !== "undefined"
        ? editItem.prodCheckPisDesconto
        : true
    );
    setProductCheckPisDescIcms(
      typeof editItem.prodCheckPisDescIcms !== "undefined"
        ? editItem.prodCheckPisDescIcms
        : true
    );
    setProductCheckCofinsFreight(
      typeof editItem.prodCheckCofinsFrete !== "undefined"
        ? editItem.prodCheckCofinsFrete
        : true
    );
    setProductCheckCofinsSafe(
      typeof editItem.prodCheckCofinsSeguro !== "undefined"
        ? editItem.prodCheckCofinsSeguro
        : true
    );
    setProductCheckCofinsOthers(
      typeof editItem.prodCheckCofinsOutras !== "undefined"
        ? editItem.prodCheckCofinsOutras
        : true
    );
    setProductCheckCofinsDiscount(
      typeof editItem.prodCheckCofinsDesconto !== "undefined"
        ? editItem.prodCheckCofinsDesconto
        : true
    );
    setProductCheckCofinsDescIcms(
      typeof editItem.prodCheckCofinsDescIcms !== "undefined"
        ? editItem.prodCheckCofinsDescIcms
        : true
    );
  };

  const searchTaxation = useCallback(
    async (index) => {
      const product = itensTable[index];

      if (
        !product ||
        (taxations || []).find(
          (tax) =>
            tax.ncm === product.prodNcm &&
            tax.cfop === product?.prodCfopItemList?.cfop
        )
      )
        return;

      const copyTaxations = [...taxations];

      try {
        setMainLoading(true);

        const callbackTaxation = await findTributacoes(
          queryParams.empresa_cnpj,
          {
            ncm: product.prodNcm,
            cfop: product?.prodCfopItemList?.cfop,
          },
          {},
          "empresa,tributacaost"
        );

        if (!callbackTaxation?.success || !callbackTaxation?.data[0])
          return notify("Tributação não encontrada", true, "warning");

        callbackTaxation.data.filter(taxationByCompany);
        handleSetFuels({ productId: product.id });
        copyTaxations.push(callbackTaxation?.data[0]);
        handleSetTaxation(callbackTaxation?.data[0]);
        setTaxations(copyTaxations);
      } catch (error) {
        console.error(error);
      } finally {
        setMainLoading(false);
      }

      return copyTaxations;
    },
    // eslint-disable-next-line
    [queryParams.empresa_cnpj, itensTable, setMainLoading]
  );

  const handleSelectNcm = (setModalNcm, selectedNcm) => {
    setProductDataNcm(selectedNcm[0].ncm);
    setProductDataCest(selectedNcm[0].cest || "");
    handleNcm({ ncm: selectedNcm[0].ncm });
    setModalNcm(false);
  };

  const handleConfirmActionItem = (index, listTable, setListTable) => {
    Swal.fire({
      icon: "question",
      text: "Tem certeza que deseja remover o item?",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Não",
      confirmButtonText: "Sim",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const copy = [...listTable];
        const itemToDelete = copy[index]?.idItem;

        if (itemToDelete) {
          setDeleteItensTable((old) => [...old, itemToDelete]);
        }

        copy.splice(index, 1);

        //Reordenação dos Indexs
        copy.forEach((value, newIndex) => {
          value.index = newIndex;

          //Validacao NRO Cobranca (ESPECIFICO)
          if (value.cobrancaNro) {
            let num = newIndex + 1;
            let auxNro = num.toString();
            let pad = "000";
            value.cobrancaNro =
              pad.substring(0, pad.length - auxNro.length) + auxNro;
          }
        });

        const precautionCopy = JSON.parse(JSON.stringify(copy));

        const liquidetTotal = precautionCopy.reduce((accumulator, payment) => {
          if (
            payment.cobrancaSituacaoValue ===
              GlobalVariables.RecieveSituations.fullyLiquidated ||
            payment.cobrancaSituacaoValue ===
              GlobalVariables.RecieveSituations.partiallyLiquidated
          ) {
            return (
              accumulator +
              MaskService.removeMaskDecimal(payment?.cobrancaValor)
            );
          }
          return accumulator + 0;
        }, 0);

        const totalValueNfe = removeMaskDecimal(itensTotalNfe);

        if (liquidetTotal < totalValueNfe) {
          let valueToEach =
            (totalValueNfe - liquidetTotal) / precautionCopy.length;

          valueToEach = valueToEach < 0.0 ? 0.0 : valueToEach;

          precautionCopy.map((payment, index) => {
            if (
              payment.cobrancaSituacaoValue !==
                GlobalVariables.RecieveSituations.fullyLiquidated &&
              payment.cobrancaSituacaoValue !==
                GlobalVariables.RecieveSituations.partiallyLiquidated
            ) {
              payment.cobrancaValor = MaskService.toMask(
                "decimal",
                valueToEach.toFixed(2),
                2
              );
            }
            return payment;
          });
        }
        setListTable(precautionCopy);
      }
    });
  };

  const handleCalcItensTable = useCallback(() => {
    const totals = calcTotalsNfe();
    /* Fim Calculo Total NF-e */
    setItensTotalNfe(
      MaskService.toMask("decimal", totals.totalValueNFE.toFixed(2))
    );

    setItensTotalValueIcms(
      MaskService.toMask("decimal", totals.totalValueIcms.toFixed(2))
    );
    setItensTotalBaseIcms(
      MaskService.toMask("decimal", totals.totalBaseIcms.toFixed(2))
    );
    setItensTotalIcmsFcp(
      MaskService.toMask("decimal", totals.totalIcmsFcp.toFixed(2))
    );
    setItensTotalIcmsDes(
      MaskService.toMask("decimal", totals.totalIcmsDes.toFixed(2))
    );
    setItensTotalValueSt(
      MaskService.toMask("decimal", totals.totalValueSt.toFixed(2))
    );
    setItensTotalBaseSt(
      MaskService.toMask("decimal", totals.totalBaseSt.toFixed(2))
    );
    setItensTotalStFcp(
      MaskService.toMask("decimal", totals.totalStFcp.toFixed(2))
    );
    setItensTotalValueIpi(
      MaskService.toMask("decimal", totals.totalValueIpi.toFixed(2))
    );
    setItensTotalIpiReturned(
      MaskService.toMask("decimal", totals.totalValueIpiReturned.toFixed(2))
    );
    setItensTotalValuePis(
      MaskService.toMask("decimal", totals.totalValuePis.toFixed(2))
    );
    setItensTotalValueCofins(
      MaskService.toMask("decimal", totals.totalValueCofins.toFixed(2))
    );
    setItensTotalValueCustoms(
      MaskService.toMask("decimal", totals.totalValueCustoms.toFixed(2))
    );
    setItensTotalFreight(
      MaskService.toMask("decimal", totals.totalFreight.toFixed(2))
    );
    setItensTotalSafe(
      MaskService.toMask("decimal", totals.totalSafe.toFixed(2))
    );
    setItensTotalOthers(
      MaskService.toMask("decimal", totals.totalOthers.toFixed(2))
    );
    setItensTotalDiscount(
      MaskService.toMask("decimal", totals.totalDiscount.toFixed(2))
    );

    setItensTotal(totals.total);
    setItensTotalProductValue(
      MaskService.toMask("decimal", totals.totalProductValue.toFixed(2))
    );

    setItensTotalValueCustoms(
      MaskService.toMask("decimal", totals.totalValueDespAdu.toFixed(2))
    );
    setItensTotalValueII(
      MaskService.toMask("decimal", totals.totalValueII.toFixed(2))
    );
  }, [
    calcTotalsNfe,
    setItensTotal,
    setItensTotalBaseIcms,
    setItensTotalBaseSt,
    setItensTotalDiscount,
    setItensTotalFreight,
    setItensTotalIcmsDes,
    setItensTotalIcmsFcp,
    setItensTotalNfe,
    setItensTotalOthers,
    setItensTotalProductValue,
    setItensTotalSafe,
    setItensTotalStFcp,
    setItensTotalValueCofins,
    setItensTotalValueCustoms,
    setItensTotalValueIcms,
    setItensTotalValueIpi,
    setItensTotalIpiReturned,
    setItensTotalValuePis,
    setItensTotalValueSt,
    setItensTotalValueII,
  ]);

  const handleEditCharge = (indexCharge) => {
    const itemEditCharge = pagtoTableCobranca[indexCharge];

    setChargeValue(itemEditCharge.cobrancaValor);
    setChargeDueDate(itemEditCharge.cobrancaDtVenctoValue);
  };

  const handleDetachDanfe = (index) => {
    const copyTableCharge = [...pagtoTableCobranca];
    copyTableCharge[index].cobrancaDestacaDanfe =
      !copyTableCharge[index].cobrancaDestacaDanfe;

    let num = 1;
    copyTableCharge.forEach((element) => {
      if (element.cobrancaDestacaDanfe) {
        let auxNro = num.toString();
        let pad = "000";
        copyTableCharge[element.index].cobrancaNro =
          pad.substring(0, pad.length - auxNro.length) + auxNro;
        num++;
      } else {
        copyTableCharge[element.index].cobrancaNro = "---";
      }
    });

    setPagtoTableCobranca(copyTableCharge);
  };

  const clearNfe = (montage = false) => {
    setFirstSearch(true);
    setVisualizationOnly(false);
    setForceProduction(false);
    setNfeValidXml("");
    setNfeId(null);
    setIdsCrsMontage([]);
    setTaxations([]);

    setNfeStatus("D");
    setNfeMontageType("M");
    setNfeMontageSubtype("M");
    setNfeFinancialIssue("NOTA");
    setMainLoading(false);
    setGetSeriesLoading(false);
    setSaleFinanceSwitch(false);

    // Montagem nota fiscal de compra
    setSelectedSupplier([]);
    setSelectedPurchaseNf([]);
    setSelectedPurchaseItems([]);
    setPurchaseStartDate("");
    setPurchaseFinalDate("");

    setNfeError({});
    setNfeLotes([]);

    setIsRuralProducerSender(false);
    setSenderRuralEstablishment(null);
    setSenderRuralEstablishmentsList([]);

    if (!montage) {
      setHeaderIssueType("");
      setHeaderNfe("");
      setHeaderSeries("");
      setSelectedHeaderSeries(null);
      setHeaderSeriesOptions([]);
      setHeaderIssueDate(
        formatDate({ date: new Date(), separator: "-", format: "yyyy-mm-dd" })
      );
      setHeaderDemandNumber("");
      setHeaderAccessKey("");

      setHeaderTypeNfe({
        label: "Saida",
        value: "S",
      });
      setHeaderCfop("");
      setHeaderOperationNature("");
      setHeaderPresentOperation({
        label: "Presencial",
        value: "1",
      });
      setHeaderFinalCostumer({
        label: "SIM",
        value: "S",
      });
      setHeaderOperation({
        label: "Operação interna",
        value: "1",
      });
      setHeaderFinnally({
        label: "NF-e Normal",
        value: "1",
      });
      setHeaderIeTax("");
      setHeaderPurchaseOrder("");
      setHeaderPurchaseContract("");
      setHeaderPurchasePublic("");
      setHeaderModel(null);
    }

    setSender(null);
    setSenderIndicationIe(null);
    setSenderClifor("C");
    setSenderId("");
    setSenderIe("");
    setSenderCountryCode("");
    setSenderName("");
    setSenderCnpj("");
    setSenderAddres("");
    setSenderNumber("");
    setSenderDistrict("");
    setSenderCity("");
    setSenderCityCode("");
    setSenderUf("");
    setSenderUfLabel("");
    setSenderCep("");
    setSenderPhone("");
    setSenderMail("");

    setSenderCheckBilling(false);
    setSenderBillingAddress("");
    setSenderBillingNumber("");
    setSenderBillingDistrict("");
    setSenderBillingCity(null);
    setSenderBillingUf(null);
    setSenderBillingCep("");
    setSenderBillingComplement("");
    setSenderCheckDelivery(false);
    setSenderDeliveryList([]);
    setSenderDeliveryAddress("");
    setSenderDeliveryNumber("");
    setSenderDeliveryDistrict("");
    setSenderDeliveryCity(null);
    setSenderDeliveryUf(null);
    setSenderDeliveryCep("");
    setSenderDeliveryCodeCity("");
    setSenderDeliveryComplement("");

    /* Itens/Produtos */
    setItensTable([]);
    setDeleteItensTable([]);
    setItensTotal("0");
    setItensTotalProductValue("0,00");
    setItensTotalNfe("0,00");
    setItensTotalValueIcms("0,00");
    setItensTotalBaseIcms("0,00");
    setItensTotalIcmsFcp("0,00");
    setItensTotalIcmsDes("0,00");
    setItensTotalValueSt("0,00");
    setItensTotalBaseSt("0,00");
    setItensTotalStFcp("0,00");
    setItensTotalStWithheld("0,00");
    setItensTotalValueIpi("0,00");
    setItensTotalIpiReturned("0,00");
    setItensTotalValuePis("0,00");
    setItensTotalValueCofins("0,00");
    setItensTotalValueCustoms("0,00");
    setItensTotalValueII("0,00");
    setItensTotalFreight("0,00");
    setItensTotalSafe("0,00");
    setItensTotalOthers("0,00");
    setItensTotalDiscount("0,00");
    setPagtoTableCobranca([]);
    setPagtoTableFormaPagto([]);

    //Transportadora
    setTranspId("");
    setTransp(null);
    setTranspModality({
      label: "Sem Ocorrência de Transporte",
      value: "9",
    });
    setTranspCnpj("");
    setTranspName("");
    setTranspIe("");
    setTranspRntc("");
    setTranspAddress("");
    setTranspUf("");
    setTranspCity("");
    setTranspCityCode("");
    setTranspBoardcar("");
    setTranspBoardcarUf("");
    setTranspTableSize([]);
    setTranspNumber("");

    //Observações
    setObsText("");
    setObsTextCreditRate("");
    setObsTextCFOP("");
    setObsTextComplemento("");

    //Documentos Referenciados
    setDocTable([]);

    //Carta
    setCcDescription("");
    setCcError({});

    setXmlAuthorizedList([]);

    setSaveBlocked(false);
    setNfCloneId(null);
    setComplementedAccessKey("");
  };

  const clearClient = () => {
    setSenderDeliveryList([]);
    setEnableEndereco(false);
    setSenderCheckBilling(false);
    setSenderCheckDelivery(false);
    setSenderId("");
    setSenderCountryCode("");
    setSenderName("");
    setSenderCnpj("");
    setSenderAddres("");
    setSenderDistrict("");
    setSenderCity("");
    setSenderUf("");
    setSenderUfLabel("");
    setSenderIndicationIe(null);
    setSenderIe("");
    setSenderCep("");
    setSenderPhone("");
    setSenderMail("");
    setSenderDeliveryAddress("");
    setSenderDeliveryDistrict("");
    setSenderDeliveryCity(null);
    setSenderDeliveryUf(null);
    setSenderDeliveryCep("");
    setSenderDeliveryNumber("");
    setSenderDeliveryComplement("");
    setSenderBillingAddress("");
    setSenderBillingNumber("");
    setSenderBillingDistrict("");
    setSenderBillingCity(null);
    setSenderBillingUf(null);
    setSenderBillingCep("");
    setIsRuralProducerSender(false);
    setSenderRuralEstablishment(null);
    setSenderNumber("");
    setSenderComplement("");
    setSenderCityCode("");
    setHeaderFinalCostumer({
      label: "SIM",
      value: "S",
    });
    setGeneralIe("");
    setGeneralIeIndication({
      label: "Não Contribuinte",
      value: 0,
      codigo: "9",
    });
    setSenderDeliveryCodeCity("");
    setSenderRuralEstablishmentsList([]);
  };

  const handleUpdateClient = async (id, body) => {
    try {
      setMainLoading(true);

      const callbackClient = await updateCliente(
        id,
        queryParams.empresa_cnpj,
        body
      );

      if (!callbackClient?.success)
        return notify("Erro ao atualizar dados do cliente.");

      notify("Dados do Cliente atualizados com sucesso", true, "success");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const handleFinallyNfe = (finallyValue) => {
    if (finallyValue?.value === "4") {
      setPagtoTableFormaPagto([
        {
          index: 0,
          pagtoFormaLabel: "Sem pagamento",
          pagtoFormaValue: "90",
          pagtoValor: "0,00",
          pagtoIndicadorLabel: "",
          pagtoIndicadorValue: "",
          pagtoCnpjCred: "",
          pagtoIntLabel: "",
          pagtoIntValue: "",
          pagtoBandeiraLabel: "",
          pagtoBandeiraValue: "",
          pagtoTroco: "0,00",
          pagtoCodigoCartao: "",
        },
      ]);
    } else {
      setPagtoTableFormaPagto([]);
    }
  };

  const handleTotalsRecalculation = () => {
    if (!itensTable.length) return;

    const totalFreightNfe = removeMaskDecimal(itensTotalFreight);

    const copyItensTable = [...itensTable];

    const totalNfe = copyItensTable
      .reduce(
        (acc, current) =>
          acc +
          removeMaskDecimal(current.prodValorUnitario, 5) *
            removeMaskDecimal(current.prodQuantidade, 4),
        0
      )
      .toFixed(2);

    const freightApportionmentPercent = apportionmentPercent(
      removeMaskDecimal(itensTotalFreight),
      totalNfe
    );

    const safeApportionmentPercent = apportionmentPercent(
      removeMaskDecimal(itensTotalSafe),
      totalNfe
    );

    const expenseApportionmentPercent = apportionmentPercent(
      removeMaskDecimal(itensTotalOthers),
      totalNfe
    );

    const discountApportionmentPercent = apportionmentPercent(
      removeMaskDecimal(itensTotalDiscount),
      totalNfe
    );

    const updateItens = [];

    let itemSummedFreight = 0;

    copyItensTable.forEach((item, index) => {
      let copyItem = { ...item };

      let totalProductValue =
        removeMaskDecimal(copyItem.prodValorUnitario, 5) *
        removeMaskDecimal(copyItem.prodQuantidade, 4);

      let totalFreight = apportionmentProdcut(
        totalProductValue,
        freightApportionmentPercent
      );

      let totalSafe = apportionmentProdcut(
        totalProductValue,
        safeApportionmentPercent
      );

      let totalExpense = apportionmentProdcut(
        totalProductValue,
        expenseApportionmentPercent
      );

      let totalDiscount = apportionmentProdcut(
        totalProductValue,
        discountApportionmentPercent
      );

      copyItem.prodValorTotal = MaskService.toMask(
        "decimal",
        totalProductValue.toFixed(2)
      );

      if (copyItensTable.length - 1 === index) {
        copyItem.prodFrete = MaskService.toMask(
          "decimal",
          (totalFreightNfe - itemSummedFreight).toFixed(2)
        );
      } else {
        itemSummedFreight += parseFloat(totalFreight.toFixed(2));
        copyItem.prodFrete = MaskService.toMask(
          "decimal",
          totalFreight.toFixed(2)
        );
      }

      copyItem.prodSeguro = MaskService.toMask("decimal", totalSafe.toFixed(2));
      copyItem.prodDespesas = MaskService.toMask(
        "decimal",
        totalExpense.toFixed(2)
      );
      copyItem.prodDesconto = MaskService.toMask(
        "decimal",
        totalDiscount.toFixed(5),
        5
      );

      const itemTaxation = taxationFormat(copyItem);
      const product = productFormat(copyItem);

      const cfopItemList = nfeListCfop.find(
        (value) => copyItem.prodCfop === value.cfop
      );

      const stockLocationItemList = nfeListStockLocation.find(
        (value) => copyItem.prodLocalEstoque?.id === value.id
      );

      const geralTaxation = {
        taxIcms: calcsIcmsTaxations(itemTaxation, product),
        taxIcmsSt: calcsIcmsStTaxations(itemTaxation, product),
        taxIpi: calcsIpiTaxations(itemTaxation, product),
        taxPis: calcsPisTaxations(itemTaxation, product),
        taxCofins: calcsCofinsTaxations(itemTaxation, product),
        others: {
          prodCfopItemList: cfopItemList,
          prodLocalEstoque: stockLocationItemList,
        },
      };
      updateItens.push(createProductItem(index, geralTaxation, product));
    });

    if (!updateItens.length) return;

    const totals = calcTotalsNfe(updateItens);

    const paymentConditionCopy = JSON.parse(JSON.stringify(pagtoTableCobranca));
    const filteredPaymentCondition = paymentConditionCopy.filter(
      (payment) =>
        payment.cobrancaSituacaoValue !==
          GlobalVariables.RecieveSituations.fullyLiquidated &&
        payment.cobrancaSituacaoValue !==
          GlobalVariables.RecieveSituations.partiallyLiquidated
    );
    const paymentsConditionNumber = filteredPaymentCondition.length;

    const paymentFormCopy = JSON.parse(JSON.stringify(pagtoTableFormaPagto));
    const paymentsFormNumber = paymentFormCopy.length;

    // Se o Switch financeiro da venda estiver desabilitado
    if (!saleFinanceSwitch) {
      const newValueNfe = parseFloat(totals.totalValueNFE.toFixed(2));
      const oldValueNfe = removeMaskDecimal(itensTotalNfe);

      // Se o campo "Condição de Pagamento" estiver preenchido,
      // o sistema deve ratear o valor total da nota fiscal, proporcional ao número de parcelas.
      if (paymentsConditionNumber) {
        handleCalcPaymentCondition({
          newValueNfe,
          paymentConditionCopy,
          paymentsConditionNumber,
        });
      }

      // Se o campo "Forma de Pagamento" estiver preenchido e essa for diferente de "Sem Pagamento"
      if (paymentsFormNumber) {
        handleCalcPaymentForm({
          newValueNfe,
          oldValueNfe,

          paymentFormCopy,
          paymentsFormNumber,
        });
      }

      setPagtoTableCobranca(paymentConditionCopy);
      setPagtoTableFormaPagto(paymentFormCopy);
    }

    setItensTable(updateItens);
  };

  let dueDateCharge = new Date();
  dueDateCharge = formatDate({
    date: dueDateCharge,
    separator: "-",
    format: "yyyy-mm-dd",
  });
  let dueDateChargeLabel = dueDateCharge.split("-").reverse().join("/");
  const createChargeItem = (
    index = 0,
    cobrancaNro = "001",
    cobrancaValor = "0,00",
    cobrancaDtVenctoValue = dueDateCharge,
    cobrancaDtVencto = dueDateChargeLabel,
    cobrancaValorPago = "0,00",
    cobrancaSituacao = "Em Carteira",
    cobrancaSituacaoValue = "00",
    cobrancaDestacaDanfe = true,
    id = null,
    itemCr = null
  ) => {
    return {
      index: index,
      cobrancaNro: cobrancaNro,
      cobrancaValor: cobrancaValor,
      cobrancaDtVenctoValue: cobrancaDtVenctoValue,
      cobrancaDtVencto: cobrancaDtVencto,
      cobrancaValorPago: cobrancaValorPago,
      cobrancaSituacao: cobrancaSituacao,
      cobrancaSituacaoValue: cobrancaSituacaoValue,
      cobrancaDestacaDanfe: cobrancaDestacaDanfe,
      id: id,
      itemCr: itemCr,
    };
  };

  const createPaymentItem = (
    pagtoValor = "0,00",
    index = 0,
    pagtoFormaLabel = "Outros",
    pagtoFormaValue = "99",
    pagtoIndicadorLabel = "Pagamento à Vista",
    pagtoIndicadorValue = "0",
    pagtoTroco = "0,00",
    pagtoCnpjCred = "",
    pagtoCodigoCartao = "",
    pagtoIntLabel = null,
    pagtoIntValue = null,
    pagtoBandeiraLabel = null,
    pagtoBandeiraValue = null
  ) => {
    return {
      pagtoValor: pagtoValor,
      index: index,
      pagtoFormaLabel: pagtoFormaLabel,
      pagtoFormaValue: pagtoFormaValue,
      pagtoIndicadorLabel: pagtoIndicadorLabel,
      pagtoIndicadorValue: pagtoIndicadorValue,
      pagtoTroco: pagtoTroco,
      pagtoCnpjCred: pagtoCnpjCred,
      pagtoCodigoCartao: pagtoCodigoCartao,
      pagtoIntLabel: pagtoIntLabel,
      pagtoIntValue: pagtoIntValue,
      pagtoBandeiraLabel: pagtoBandeiraLabel,
      pagtoBandeiraValue: pagtoBandeiraValue,
    };
  };

  const createProductDi = (key, product, DI, taxation) => {
    const cfopItemList = nfeListCfop.find(
      (value) => product.cfop === value.cfop
    );

    return {
      index: key,
      prodCodigo: product.codigo,
      prodDescricao: product.descricaomercadoria || "",
      prodNcm: product.ncm || "",
      prodCfop: product.cfop || headerCfop || "",
      prodCfopItemList: cfopItemList,
      prodQuantidade: MaskService.toMask(
        "decimal",
        product.quantidade
          ? parseFloat(product.quantidade).toFixed(4)
          : "0,0000",
        4
      ),
      prodValorUnitario: MaskService.toMask(
        "decimal",
        product.valorunitario
          ? parseFloat(product.valorunitario).toFixed(5)
          : "0,00000",
        5
      ),
      prodValorTotal: MaskService.toMask(
        "decimal",
        parseFloat(product.vl_total).toFixed(2)
      ),
      prodCest: "", // Verificar

      /* Outros */
      prodGtin: "",
      prodGtinTrib: "",
      prodUn: product.unidademedida || "",
      prodUnEntrega: product.unidademedida || "",
      prodUnTrib: "",
      prodFrete: MaskService.toMask(
        "decimal",
        product.vl_frete ? parseFloat(product.vl_frete).toFixed(2) : "0,00"
      ),
      prodQuantTrib: "0,0000",
      prodTaxConvertFactor: 1.0,
      prodValorTrib: "0,00",
      prodSeguro: MaskService.toMask(
        "decimal",
        product.vl_seguro ? parseFloat(product.vl_seguro).toFixed(2) : "0,00"
      ),
      prodDesconto: MaskService.toMask("decimal", "0,00000", 5),
      prodDespesas: MaskService.toMask(
        "decimal",
        product.vl_outras_desp
          ? parseFloat(product.vl_outras_desp).toFixed(2)
          : "0,00"
      ),
      prodUnPeso: "0,000",
      prodPesoImp: "0,00",
      prodSiscomex: "0,00",
      prodAdicional: product.complemento_item || "",

      /* Icms */
      prodOrigem: product.origem || null, // objeto
      prodIcmsSituacao: product.cst_icms || null, // objeto
      prodIcmsModalidade: { label: "Valor da Operação", value: "3" },
      prodIcmsValorBc: MaskService.toMask(
        "decimal",
        parseFloat(product.vl_bc_icms).toFixed(2)
      ),
      prodIcmsAliquota: MaskService.toMask(
        "decimal",
        product.p_icms ? parseFloat(product.p_icms).toFixed(2) : "0.00"
      ),
      prodIcmsValor: MaskService.toMask(
        "decimal",
        product.vl_icms ? parseFloat(product.vl_icms).toFixed(2) : "0.00"
      ),
      // "prodIcmsPercentualReductBc": Rose falou
      // na possibilidade de adicionarem esse campo
      // futuramente, mas por agora deixar zerado.
      // no caso dos outros campos, todos zerados.
      prodIcmsPercentualReductBc: "0,0000",
      prodIcmsAliqAplicCred: "0,00",
      prodIcmsCredAprov: "0,00",
      prodIcmsValorDes: "0,00",
      prodIcmsMotivoDes: null,
      prodIcmsAliquotaPob: MaskService.toMask(
        "decimal",
        product.p_icms_fcp ? parseFloat(product.p_icms_fcp).toFixed(2) : "0.00"
      ),
      prodIcmsBcPob: "0,00",
      prodIcmsValorPob: "0,00",
      prodIcmsAliquotaCons: "0,00",
      prodIcmsPropSubs: "0,00",
      //ICMSUFDest
      prodIcmsAliquotaInterestadual: "0,00",
      prodIcmsAliquotaInternaDest: "0,00",

      /* Icms ST */
      // Nota: ICMS ST não será preenchido
      prodIcmsStModalidade: {},
      prodIcmsStPercentualAdd: "0,00",
      prodIcmsStPercentualBc: MaskService.toMask(
        "decimal",
        product.p_red_bc_icms
          ? parseFloat(product.p_red_bc_icms).toFixed(4)
          : "0.0000",
        4
      ),
      prodIcmsStValorBc: "0,00",
      prodIcmsStAliquota: "0,00",
      prodIcmsStValor: "0,00",
      prodIcmsStAliquotaPob: "0,00",
      prodIcmsStBcPob: "0,00",
      prodIcmsStValorPob: "0,00",
      prodIcmsStBcRetido: "0,00",
      prodIcmsStValorRetido: "0,00",
      prodIcmsStBcFcpRetido: "0,00",
      prodIcmsStValorFcpRetido: "0,00",
      prodIcmsStAliqFcpRetido: "0,00",

      /* Ipi */
      prodIpiCenq: product.cenq?.toString() || "", // string
      prodIpiSituacao: product.cst_ipi || null, // objeto
      prodIpiBcValor: MaskService.toMask(
        "decimal",
        parseFloat(product.vl_bc_ipi).toFixed(2)
      ),
      prodIpiAliquota: MaskService.toMask(
        "decimal",
        parseFloat(product.p_ipi).toFixed(2)
      ),
      prodIpiValor: MaskService.toMask(
        "decimal",
        parseFloat(product.vl_ipi).toFixed(2)
      ),

      /* Ipi Devolvido */
      prodIpiDevolvidoValor: product.vl_ipi_devol
        ? MaskService.toMask(
            "decimal",
            parseFloat(product.vl_ipi_devol).toFixed(2)
          )
        : "0,00",
      prodIpiDevolvidoAliquota: product.p_ipi_devol
        ? MaskService.toMask(
            "decimal",
            parseFloat(product.p_ipi_devol).toFixed(2)
          )
        : "0,00",

      /* Pis */
      prodPisSituacao: product.cst_pis || null, // objeto
      prodPisPercentualAliquota: MaskService.toMask(
        "decimal",
        product.p_pis ? parseFloat(product.p_pis).toFixed(2) : "0,00"
      ),
      prodPisAliquota: "0,00", // zerado
      prodPisValorBc: MaskService.toMask(
        "decimal",
        product.vl_bc_pis ? parseFloat(product.vl_bc_pis).toFixed(2) : "0,00"
      ),
      prodPisValor: MaskService.toMask(
        "decimal",
        product.vl_pis ? parseFloat(product.vl_pis).toFixed(2) : "0,00"
      ),

      /* Cofins */
      prodCofinsSituacao: product.cst_cofins || null,
      prodCofinsPercentualAliquota: MaskService.toMask(
        "decimal",
        product.p_cofins ? parseFloat(product.p_cofins).toFixed(2) : "0,00"
      ),
      prodCofinsAliquota: "0,00", // zerado
      prodCofinsValorBc: MaskService.toMask(
        "decimal",
        product.vl_bc_cofins
          ? parseFloat(product.vl_bc_cofins).toFixed(2)
          : "0,00"
      ),
      prodCofinsValor: MaskService.toMask(
        "decimal",
        product.vl_cofins ? parseFloat(product.vl_cofins).toFixed(2) : "0,00"
      ),
      /* DI */
      prodDadosDi: [
        {
          diNumeroRegistro: DI.numerodi || "",
          diDataRegistro: DI.dataregistro || "",
          diUfDes: DI.urf_despacho_estado_id
            ? listUf.find(
                (uf) => uf.id === DI.urf_despacho_estado_id.toString()
              )
            : null,
          diLocalDes: DI.urfdespachonome || "",
          diDataDes: DI.datadesembaraco || "",
          diDrawback: DI.nro_drawback || "",
          diSequencia: product.numerosequencialitem || "",
          diAdd: product.adicao || "",
        },
      ],
      prodIIFob: MaskService.toMask(
        "decimal",
        (
          parseFloat(product.vl_frete || "0.00") +
          parseFloat(product.vl_seguro || "0.00") +
          parseFloat(product.vl_total || "0.00")
        ).toFixed(2)
      ),
      prodIIFrete: MaskService.toMask(
        "decimal",
        product.vl_frete ? parseFloat(product.vl_frete).toFixed(2) : "0,00"
      ),
      prodIISeguro: MaskService.toMask(
        "decimal",
        product.vl_seguro ? parseFloat(product.vl_seguro).toFixed(2) : "0,00"
      ),
      prodIICif: MaskService.toMask(
        "decimal",
        product.vl_bc_ii ? parseFloat(product.vl_bc_ii).toFixed(2) : "0,00"
      ),
      prodIIImpostoImportacao: MaskService.toMask(
        "decimal",
        product.vl_ii ? parseFloat(product.vl_ii).toFixed(2) : "0,00"
      ),
      prodIIDespAdu: MaskService.toMask(
        "decimal",
        product.vl_desp_adu_ii
          ? parseFloat(product.vl_desp_adu_ii).toFixed(2)
          : "0,00"
      ),
      prodIIThc: MaskService.toMask(
        "decimal",
        product.vl_capatazia
          ? parseFloat(product.vl_capatazia).toFixed(2)
          : "0,00"
      ),
      prodIIAntidumping: MaskService.toMask(
        "decimal",
        product.vl_antidumping
          ? parseFloat(product.vl_antidumping).toFixed(2)
          : "0,00"
      ),
      prodIIAfrmm: MaskService.toMask(
        "decimal",
        product.vl_taxa_afrmm
          ? parseFloat(product.vl_taxa_afrmm).toFixed(2)
          : "0,00"
      ),
      prodIIOutros: MaskService.toMask(
        "decimal",
        (
          parseFloat(product.vl_outras_desp || "0.00") +
          parseFloat(product.vl_multa || "0.00") +
          parseFloat(product.vl_antidumping || "0.00")
        ).toFixed(2)
      ),
      // Estado a seguir é usado apenas para ser inserido no banco
      prodIIAliq: MaskService.toMask(
        "decimal",
        parseFloat(product.p_ii || "0.00").toFixed(2)
      ),

      /* B2b */
      prodB2BNumero: "",
      prodB2BItem: "",
    };
  };

  /* Utilizado para Montagem automática */
  const createProductItem = (key, taxation, product) => {
    let cBenef =
      product?.tributacoes?.filter((tri) => tri.cfop === product?.cfop)[0]
        ?.c_benef || "";

    const additionalInfo =
      product.observacao && product.complemento
        ? `${product.observacao} ${product.complemento}`
        : product.observacao || product.complemento || "";

    return {
      index: key,
      idItem: product.idItem || null,
      prodIdEstoque: product.idestoque,
      prodCodigoBarrasEstoque: product.codigobarras_estoque,
      prodLocalEstoque: taxation.others.prodLocalEstoque,
      prodCodigo: getCodeBarProduct(product, "WizardEmissaoController"),
      prodDifal: productCheckIcmsDifal,
      prodProdutoId: product.idproduto,
      prodDescricao: getDescriptionProduct(product, "WizardEmissaoController"),
      prodAdicional: additionalInfo,
      prodNcm: product.ncm || "",
      prodCfop: product?.cfop || headerCfop || "",
      prodCfopItemList: taxation.others.prodCfopItemList,
      prodUn: product.unidade || "",
      prodUnSales: product.unidade_venda || "",
      prodQuantidade: MaskService.toMask(
        "decimal",
        product.qtde ? parseFloat(product.qtde).toFixed(4) : "0,0000",
        4
      ),
      prodValorUnitario: MaskService.toMask(
        "decimal",
        product.precounitario
          ? (
              parseFloat(product.precounitario) *
              parseFloat(product.diporc ? product.diporc / 100 + 1 : 1)
            ).toFixed(5)
          : "0,00000",
        5
      ),
      prodValorTotal: MaskService.toMask(
        "decimal",
        parseFloat(product.vlr_total).toFixed(2)
      ),
      prodCest: product.cest || "",

      /* Outros */
      prodGtin: product.gtin || "",
      prodGtinTrib: product.gtin_tributavel || "",
      prodTipi: "",
      prodUnEntrega: product.unidade_entrega || "",
      prodUnTrib: product.unidade_tributavel || "",
      prodFrete: MaskService.toMask(
        "decimal",
        product.frete ? parseFloat(product.frete).toFixed(2) : "0,00"
      ),
      prodQuantTrib: MaskService.toMask(
        "decimal",
        product.qtde
          ? (
              parseFloat(product.qtde) *
              parseFloat(product.fator_conversao_tributavel || 1.0)
            ).toFixed(4)
          : "0,0000",
        4
      ),
      prodTaxConvertFactor: product.fator_conversao_tributavel || 1.0,
      prodValorTrib: MaskService.toMask(
        "decimal",
        product.valor_tributavel
          ? parseFloat(product.valor_tributavel).toFixed(2)
          : "0,00"
      ),
      prodSeguro: MaskService.toMask(
        "decimal",
        product.seguro ? parseFloat(product.seguro).toFixed(2) : "0,00"
      ),
      prodDesconto: MaskService.toMask(
        "decimal",
        product.desconto ? parseFloat(product.desconto).toFixed(5) : "0,00000",
        5
      ),
      prodDespesas: MaskService.toMask(
        "decimal",
        product.outrasdesp ? parseFloat(product.outrasdesp).toFixed(2) : "0,00"
      ),
      prodUnPeso:
        MaskService.toMask(
          "decimal",
          parseFloat(product.peso || 0).toFixed(3),
          3
        ) || "0,000",
      prodPesoImp: "0,00",
      prodSiscomex: "0,00",

      /* Icms */
      prodOrigem: taxation.taxIcms.prodOrigem,
      prodIcmsSituacao: taxation.taxIcms.prodIcmsSituacao,
      prodIcmsModalidade: taxation.taxIcms.prodIcmsModalidade,
      prodIcmsValorBc: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsValorBc.toFixed(2)
      ),
      prodIcmsAliquota: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsAliquota.toFixed(2)
      ),
      prodIcmsValor: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsValor.toFixed(2)
      ),
      prodIcmsPercentualReductBc: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsPercentualReductBc.toFixed(4),
        4
      ),
      prodIcmsAliqAplicCred: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsAliqAplicCred.toFixed(2)
      ),
      prodIcmsCredAprov: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsCredAprov.toFixed(2)
      ),
      prodIcmsValorDes: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsValorDes.toFixed(2)
      ),
      prodIcmsMotivoDes: taxation.taxIcms?.prodIcmsMotivoDes,
      prodIcmsAliquotaPob: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsAliquotaPob.toFixed(2)
      ),
      prodIcmsBcPob: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsBcPob.toFixed(2)
      ),
      prodIcmsValorPob: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsValorPob.toFixed(2)
      ),
      prodIcmsAliquotaCons: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsAliquotaCons.toFixed(2)
      ),
      prodIcmsPropSubs: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsPropSubs.toFixed(2)
      ),
      prodCheckIcmsFrete: taxation.taxIcms.prodCheckIcmsFrete,
      prodCheckIcmsSeguro: taxation.taxIcms.prodCheckIcmsSeguro,
      prodCheckIcmsOutras: taxation.taxIcms.prodCheckIcmsOutras,
      prodCheckIcmsDesconto: taxation.taxIcms.prodCheckIcmsDesconto,

      /* Tag cBnef*/
      prodIcmsCbenef: cBenef,
      //ICMSUFDest
      prodIcmsAliquotaInterestadual: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsAliquotaInterestadual.toFixed(2)
      ),
      prodIcmsAliquotaInternaDest: MaskService.toMask(
        "decimal",
        taxation.taxIcms.prodIcmsAliquotaInternaDest.toFixed(2)
      ),

      /* Icms ST */
      prodIcmsStModalidade: taxation.taxIcmsSt.prodIcmsStModalidade, // LIST
      prodIcmsStPercentualAdd: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStPercentualAdd.toFixed(2)
      ),
      prodIcmsStPercentualBc: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStPercentualBc.toFixed(2)
      ),
      prodIcmsStValorBc: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStValorBc.toFixed(2)
      ),
      prodIcmsStAliquota: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStAliquota.toFixed(2)
      ),
      prodIcmsStValor: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStValor.toFixed(2)
      ),
      prodIcmsStAliquotaPob: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStAliquotaPob.toFixed(2)
      ),
      prodIcmsStBcPob: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStBcPob.toFixed(2)
      ),
      prodIcmsStValorPob: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStValorPob.toFixed(2)
      ),
      prodIcmsStBcRetido: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStBcRetido.toFixed(2)
      ),
      prodIcmsStValorRetido: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStValorRetido.toFixed(2)
      ),
      prodIcmsStBcFcpRetido: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStBcFcpRetido.toFixed(2)
      ),
      prodIcmsStValorFcpRetido: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStValorFcpRetido.toFixed(2)
      ),
      prodIcmsStAliqFcpRetido: MaskService.toMask(
        "decimal",
        taxation.taxIcmsSt.prodIcmsStAliqFcpRetido.toFixed(2)
      ),

      /* Ipi */
      prodIpiCenq: taxation.taxIpi.prodIpiCenq,
      prodIpiSituacao: taxation.taxIpi.prodIpiSituacao, // LIST
      prodIpiBcValor: MaskService.toMask(
        "decimal",
        taxation.taxIpi.prodIpiBcValor.toFixed(2)
      ),
      prodIpiAliquota: MaskService.toMask(
        "decimal",
        taxation.taxIpi.prodIpiAliquota.toFixed(2)
      ),
      prodIpiValor: MaskService.toMask(
        "decimal",
        taxation.taxIpi.prodIpiValor.toFixed(2)
      ),
      prodCheckIpiFrete: taxation.taxIpi.prodCheckIpiFrete,
      prodCheckIpiSeguro: taxation.taxIpi.prodCheckIpiSeguro,
      prodCheckIpiOutras: taxation.taxIpi.prodCheckIpiOutras,
      prodCheckIpiDesconto: taxation.taxIpi.prodCheckIpiDesconto,

      /* Ipi Devolvido */
      prodIpiDevolvidoAliquota: "0,00",
      prodIpiDevolvidoValor: "0,00",

      /* Pis */
      prodPisSituacao: taxation.taxPis.prodPisSituacao,
      prodPisPercentualAliquota: MaskService.toMask(
        "decimal",
        taxation.taxPis.prodPisPercentualAliquota.toFixed(2)
      ),
      prodPisAliquota: MaskService.toMask(
        "decimal",
        taxation.taxPis.prodPisAliquota.toFixed(2)
      ),
      prodPisValorBc: MaskService.toMask(
        "decimal",
        taxation.taxPis.prodPisBcValor.toFixed(2)
      ),
      prodPisValor: MaskService.toMask(
        "decimal",
        taxation.taxPis.prodPisValor.toFixed(2)
      ),
      prodCheckPisDesconto: taxation.taxPis.prodCheckPisDesconto,
      prodCheckPisFrete: taxation.taxPis.prodCheckPisFrete,
      prodCheckPisOutras: taxation.taxPis.prodCheckPisOutras,
      prodCheckPisSeguro: taxation.taxPis.prodCheckPisSeguro,
      prodCheckPisDescIcms: taxation.taxPis.prodCheckPisDescIcms,

      /* Cofins */
      prodCofinsSituacao: taxation.taxCofins.prodCofinsSituacao, // LIST
      prodCofinsPercentualAliquota: MaskService.toMask(
        "decimal",
        taxation.taxCofins.prodCofinsPercentualAliquota.toFixed(2)
      ),
      prodCofinsAliquota: MaskService.toMask(
        "decimal",
        taxation.taxCofins.prodCofinsAliquota.toFixed(2)
      ),
      prodCofinsValorBc: MaskService.toMask(
        "decimal",
        taxation.taxCofins.prodCofinsBcValor.toFixed(2)
      ),
      prodCofinsValor: MaskService.toMask(
        "decimal",
        taxation.taxCofins.prodCofinsValor.toFixed(2)
      ),
      prodCheckCofinsDesconto: taxation.taxCofins.prodCheckCofinsDesconto,
      prodCheckCofinsFrete: taxation.taxCofins.prodCheckCofinsFrete,
      prodCheckCofinsOutras: taxation.taxCofins.prodCheckCofinsOutras,
      prodCheckCofinsSeguro: taxation.taxCofins.prodCheckCofinsSeguro,
      prodCheckCofinsDescIcms: taxation.taxCofins.prodCheckCofinsDescIcms,

      /* DI */
      prodDadosDi: [],
      prodIIFob: "0,00",
      prodIIFrete: "0,00",
      prodIISeguro: "0,00",
      prodIICif: "0,00",
      prodIIImpostoImportacao: "0,00",
      prodIIDespAdu: "0,00",
      prodIIThc: "0,00",
      prodIIAntidumping: "0,00",
      prodIIAfrmm: "0,00",
      prodIIOutros: "0,00",

      /* B2b */
      prodB2BNumero: "",
      prodB2BItem: "",

      /* Combustível */
      prodFuelCodeAnp: product.cod_anp,
      prodFuelUf: product.estado,
      prodFuelDescAnp: product.desc_anp,
      prodFuelGlpPetroleum: MaskService.changeUStoBR(
        product.perc_glp_derivado_petroleo || ""
      ),
      prodFuelNationalGas: MaskService.changeUStoBR(
        product.perc_gas_natural_nacional || ""
      ),
      prodFuelImportedGas: MaskService.changeUStoBR(
        product.perc_gas_natural_importado || ""
      ),
      prodFuelValueWithoutICMS: MaskService.changeUStoBR(
        product.valor_partida_sem_icms || ""
      ),

      /* Exportacao */
      exportDrawbackNumber: null,
      isIndirectExportation: false,
      exportRegisterNumber: null,
      exportAccessKey: null,
      exportQuantity: null,
    };
  };

  const clearTransp = useCallback(() => {
    setTranspId(null);
    setTransp(null);
    setTranspCnpj("");
    setTranspName("");
    setTranspIe("");
    setTranspRntc("");
    setTranspAddress("");
    setTranspUf("");
    setTranspCity("");
    setTranspCityCode("");
    setTranspBoardcar("");
    setTranspBoardcarUf("");
    setTranspTableSize([]);
    setTranspNumber("");
  }, [
    setTranspId,
    setTransp,
    setTranspCnpj,
    setTranspName,
    setTranspIe,
    setTranspRntc,
    setTranspAddress,
    setTranspUf,
    setTranspCity,
    setTranspCityCode,
    setTranspBoardcar,
    setTranspBoardcarUf,
    setTranspTableSize,
    setTranspNumber,
  ]);

  const handleShippingModality = useCallback(
    (setDisabledInput) => {
      const setShippingData = (own = false) => {
        const arrShipping = [];

        if (own) {
          const shippingUf = listUf.find(
            (state) => state.id.toString() === queryParams.id_estado.toString()
          );

          arrShipping.push({
            id: null,
            razao: queryParams.nomeempresa,
            endereco: `${queryParams.endereco},${queryParams.numero}`,
            cnpj_cpf: queryParams.cnpj_cpf,
            inscricao_estadual: queryParams.inscricao_estadual,
            cidade: queryParams.cidade,
            municipio_codigo: queryParams.municipio_codigo,
            estado: shippingUf,
          });
        } else {
          arrShipping.push({
            id: null,
            razao: senderName,
            endereco: `${senderAddress},${senderNumber}`,
            cnpj_cpf: senderCnpj,
            inscricao_estadual: senderIe,
            cidade: senderCity,
            municipio_codigo: senderCityCode,
            estado: {
              estado: senderUfLabel,
            },
          });
        }

        if (transpId) {
          Swal.fire({
            icon: "question",
            text: "Deseja alterar os dados da Transportadora?",
            showConfirmButton: true,
            showCancelButton: true,
            cancelButtonText: "Não",
            confirmButtonText: "Sim",
          }).then(async (result) => {
            if (result.isConfirmed) {
              handleSelectShippingCompany(arrShipping);
            }
          });
        } else {
          handleSelectShippingCompany(arrShipping);
        }
      };

      setDisabledInput(false);
      if (transpModality?.value === "9") {
        setDisabledInput(true);
        clearTransp();
      }

      if (transpModality?.value === "3") {
        setShippingData(headerTypeNfe?.value === "S");
      }

      if (transpModality?.value === "4") {
        setShippingData(headerTypeNfe?.value !== "S");
      }
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [
      transpModality,
      headerTypeNfe,
      clearTransp,
      queryParams,
      listUf,
      senderAddress,
      senderNumber,
      senderCnpj,
      senderIe,
      senderCity,
      senderCityCode,
      senderUfLabel,
      senderName,
      handleSelectShippingCompany,
    ]
  );

  const handleCreditRate = useCallback((itens = []) => {
    let valueCredit = 0;
    let percentagesIcms = [];
    itens.forEach((element) => {
      if (checkCsosn(element)) {
        valueCredit += MaskService.removeMaskDecimal(element.prodIcmsCredAprov);
        percentagesIcms.push(element.prodIcmsAliqAplicCred);
      }
    });

    return valueCredit
      ? `PERMITE O APROVEITAMENTO DO CRÉDITO DE ICMS NO VALOR DE R$${valueCredit
          .toFixed(2)
          .toString()
          .replace(".", ",")}; CORRESPONDENTE À ALÍQUOTA DE ${
          percentagesIcms[0] //somente pegar o primeiro valor de porcentagem
        }%, NOS TERMOS DO ART. 23 DA LC 123/2006 `
      : "";
  }, []);

  const handleChangeCep = (
    e,
    context,
    settersProp,
    byOtherFunction = false
  ) => {
    const setters = settersProp || optionsSetters[context];

    setters.setCep(MaskService.toMask("cep", e.target.value));

    if (e.target.value.length === 10) {
      document.activeElement.blur();
      handleFindByCepHub(e.target.value, context, settersProp, byOtherFunction);
    }
  };

  const handleFindByCepHub = async (
    cep,
    context,
    settersProp,
    byOtherFunction = false
  ) => {
    try {
      setMainLoading(true);
      const setters = settersProp || optionsSetters[context];

      const response = await findByCEP(cep);
      const responseData = response?.data;

      if (
        response.success &&
        responseData.statusCode === 200 &&
        responseData.data
      ) {
        if (responseData.data.stateCode) {
          setters.setUf(
            listUf.find((opt) => opt.estado === responseData.data.stateCode) ||
              null
          );
        }

        if (responseData.data.logradouro) {
          setters.setAddress(responseData.data.street);
        }

        if (responseData.data.bairro) {
          setters.setDistrict(responseData.data.neighborhood);
        }

        if (responseData.data.complemento) {
          setters.setComplement(responseData.data.additionalInfo);
        }

        if (responseData.data.ibgeCode) {
          setters.setCity(
            listCounty.find(
              (opt) => opt.codigo === responseData.data.ibgeCode
            ) || null
          );
        }

        return;
      }
      if (byOtherFunction) return;

      notify("CEP não encontrado.");
    } catch (error) {
      console.error(error);
    } finally {
      setMainLoading(false);
    }
  };

  const returnBuiltNfeItems = (nfe) => {
    const itens = [];
    if (!nfe.itens) return itens;

    nfe.itens.forEach((row, index) => {
      const nfeItemList = nfeListCfop.find((value) => row.cfop === value.cfop);

      itens.push({
        index: index,
        idItem: row.id || null,
        /* Principal */
        prodCfopItemList: nfeItemList,
        prodIdEstoque: row.idestoque,
        prodCodigoBarrasEstoque: row?.codigobarras_estoque || row?.codigo,
        prodCodigo: row.codigo,
        prodDifal: row.difal_entrega ? 1 : 0,
        prodProdutoId: row.idproduto,
        prodDescricao: row.descricao || "",
        prodNcm: row.ncm,
        prodCfop: row.cfop,
        prodUn: row.unidade,
        prodQuantidade: MaskService.toMask(
          "decimal",
          parseFloat(row.quantidade).toFixed(4),
          4
        ),
        prodValorUnitario: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_unitario).toFixed(5),
          5
        ),
        prodValorTotal: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_total).toFixed(2)
        ),
        prodCest: row.cest,

        /* Outras Informações */
        prodGtin: row.gtin,
        prodGtinTrib: row.gtin_tributavel,
        prodTipi: row.extipi,
        prodUnEntrega: row.unidade_entrega,
        prodUnTrib: row.unidade_tributavel,
        prodFrete: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_frete).toFixed(2)
        ),
        prodQuantTrib: MaskService.toMask(
          "decimal",
          parseFloat(row.quantidade_tributavel).toFixed(4),
          4
        ),
        prodTaxConvertFactor: 1.0,
        prodValorTrib: MaskService.toMask(
          "decimal",
          parseFloat(row.valor_tributavel).toFixed(2)
        ),
        prodSeguro: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_seguro).toFixed(2)
        ),
        prodDesconto: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_desconto).toFixed(5),
          5
        ),
        prodDespesas: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_outras).toFixed(2)
        ),
        prodUnPeso: MaskService.toMask(
          "decimal",
          parseFloat(row.peso_unitario).toFixed(3),
          3
        ),
        prodPesoImp: MaskService.toMask(
          "decimal",
          parseFloat(row.peso_unitario).toFixed(2)
        ),
        prodIIDespAdu: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_desp_adu_ii).toFixed(2)
        ),
        prodAdicional: row.dadosadicionais,

        /* Icms */
        prodOrigem: productIcmsListSource.find(
          (value) => row.origem === value.value
        ),
        prodIcmsSituacao:
          queryParams.crt === "1" || queryParams.crt === "4"
            ? productIcmsListSimpleTaxationSituation.find(
                (value) => row.cst_icms === value.value
              )
            : productIcmsListNormalTaxationSituation.find(
                (value) => row.cst_icms === value.value
              ),
        prodIcmsModalidade: productIcmsListModality.find(
          (value) => row.mod_bc_icms === value.value
        ),
        prodIcmsValorBc: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_icms).toFixed(2)
        ),
        prodIcmsAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms).toFixed(2)
        ),
        prodIcmsValor: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms).toFixed(2)
        ),
        prodIcmsPercentualReductBc: MaskService.toMask(
          "decimal",
          parseFloat(row.p_red_bc_icms).toFixed(4),
          4
        ),
        prodIcmsAliqAplicCred: MaskService.toMask(
          "decimal",
          parseFloat(row.p_cred_icms_sn).toFixed(2)
        ),
        prodIcmsCredAprov: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_cred_icms_sn).toFixed(2)
        ),
        prodIcmsValorDes: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icmsdeson).toFixed(2)
        ),
        prodIcmsMotivoDes: productImcsListReasonExemption.find(
          (value) => row.motdesicms === value.value
        ),
        prodIcmsAliquotaPob: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms_fcp).toFixed(2)
        ),
        prodIcmsBcPob: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_icms_fcp).toFixed(2)
        ),
        prodIcmsValorPob: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms_fcp).toFixed(2)
        ),
        prodIcmsAliquotaCons: MaskService.toMask(
          "decimal",
          parseFloat(row.pst).toFixed(2)
        ),
        prodIcmsPropSubs: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms_substituto).toFixed(2)
        ),
        prodIcmsAliquotaInterestadual: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms_interestadual || 0).toFixed(2)
        ),
        prodIcmsAliquotaInternaDest: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms_interna_destino || 0).toFixed(2)
        ),
        prodCheckIcmsFrete: row.tributacoes?.frete_icms === "0",
        prodCheckIcmsSeguro: row.tributacoes?.seguro_icms === "0",
        prodCheckIcmsOutras: row.tributacoes?.outras_icms === "0",
        prodCheckIcmsDesconto: row.tributacoes?.desconto_icms === "0",

        /* Icms St */
        prodIcmsStModalidade: productIcmsStListModality.find(
          (value) => row.mod_bc_icms_st === value.value
        ),
        prodIcmsStPercentualAdd: MaskService.toMask(
          "decimal",
          parseFloat(row.p_mva_icms_st).toFixed(2)
        ),
        prodIcmsStPercentualBc: MaskService.toMask(
          "decimal",
          parseFloat(row.p_red_bc_icms_st).toFixed(2)
        ),
        prodIcmsStValorBc: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_icms_st).toFixed(2)
        ),
        prodIcmsStAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms_st).toFixed(2)
        ),
        prodIcmsStValor: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms_st).toFixed(2)
        ),
        prodIcmsStAliquotaPob: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms_fcp_st).toFixed(2)
        ),
        prodIcmsStBcPob: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_icms_st).toFixed(2)
        ),
        prodIcmsStValorPob: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms_fcp_st).toFixed(2)
        ),
        prodIcmsStBcRetido: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_icms_st_ret).toFixed(2)
        ),
        prodIcmsStValorRetido: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms_st_ret).toFixed(2)
        ),
        prodIcmsStBcFcpRetido: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_icms_fcp_st_ret).toFixed(2)
        ),
        prodIcmsStValorFcpRetido: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_icms_fcp_st_ret).toFixed(2)
        ),
        prodIcmsStAliqFcpRetido: MaskService.toMask(
          "decimal",
          parseFloat(row.p_icms_fcp_st_ret).toFixed(2)
        ),

        /* Ipi */
        prodIpiSituacao: prodcuctIpiListSituation.find(
          (value) => row.cst_ipi === value.value
        ),
        prodIpiBcValor: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_ipi).toFixed(2)
        ),
        prodIpiAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.p_ipi).toFixed(2)
        ),
        prodIpiValor: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_ipi).toFixed(2)
        ),
        prodIpiCenq: row.cenq,
        prodCheckIpiFrete: row.tributacoes?.frete_ipi === "0",
        prodCheckIpiSeguro: row.tributacoes?.seguro_ipi === "0",
        prodCheckIpiOutras: row.tributacoes?.outras_ipi === "0",
        prodCheckIpiDesconto: row.tributacoes?.desconto_ipi === "0",

        /* Ipi Devolvido */
        prodIpiDevolvidoValor: row.vl_ipi_devol
          ? MaskService.toMask(
              "decimal",
              parseFloat(row.vl_ipi_devol).toFixed(2)
            )
          : "0,00",
        prodIpiDevolvidoAliquota: row.p_ipi_devol
          ? MaskService.toMask(
              "decimal",
              parseFloat(row.p_ipi_devol).toFixed(2)
            )
          : "0,00",

        /* Pis */
        prodPisSituacao: prodcuctPisListSituation.find(
          (value) => row.cst_pis === value.value
        ),
        prodPisPercentualAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.p_pis).toFixed(2)
        ),
        prodPisAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_aliq_pis).toFixed(2)
        ),
        prodPisValorBc: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_pis).toFixed(2)
        ),
        prodPisValor: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_pis).toFixed(2)
        ),
        prodCheckPisFrete: row.tributacoes?.frete_pis === "0",
        prodCheckPisSeguro: row.tributacoes?.seguro_pis === "0",
        prodCheckPisOutras: row.tributacoes?.outras_pis === "0",
        prodCheckPisDesconto: row.tributacoes?.desconto_pis === "0",
        prodCheckPisDescIcms: row.tributacoes?.desc_icms_pis === 0,

        /* Cofins */
        prodCofinsSituacao: productCofinsListSituation.find(
          (value) => row.cst_cofins === value.value
        ),
        prodCofinsPercentualAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.p_cofins).toFixed(2)
        ),
        prodCofinsAliquota: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_aliq_cofins).toFixed(2)
        ),
        prodCofinsValorBc: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_bc_cofins).toFixed(2)
        ),
        prodCofinsValor: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_cofins).toFixed(2)
        ),
        prodCheckCofinsFrete: row.tributacoes?.frete_cofins === "0",
        prodCheckCofinsSeguro: row.tributacoes?.seguro_cofins === "0",
        prodCheckCofinsOutras: row.tributacoes?.outras_cofins === "0",
        prodCheckCofinsDesconto: row.tributacoes?.desconto_cofins === "0",
        prodCheckCofinsDescIcms: row.tributacoes?.desc_icms_cofins === 0,

        prodDadosDi: row.di
          ? [
              {
                idDi: row.di?.id || null,
                diNumeroRegistro: row.di?.numerodi || "",
                diDataRegistro: row.di?.dataregistro || "",
                diUfDes: row.di?.estado || 0,
                diLocalDes: row.di?.cidade || 0,
                diDataDes: row.di?.datadesembaraco || 0,
                diDrawback: row.di?.drawback || 0,
                diSequencia: row.di?.adicoes.num_sequencia || 0,
                diAdd: row.di?.adicoes.num_adicao || 0,
                idAdicao: row.di?.adicoes.id || null,
              },
            ]
          : [],
        prodIIValorUnitario: row.imp_unitario_ii,
        prodIIFob: MaskService.toMask(
          "decimal",
          row.imp_fob ? parseFloat(row.imp_fob).toFixed(2) : "0,00"
        ),
        prodIIFrete: MaskService.toMask(
          "decimal",
          row.imp_frete_ii ? parseFloat(row.imp_frete_ii).toFixed(2) : "0,00"
        ),
        prodIISeguro: MaskService.toMask(
          "decimal",
          row.imp_seguro_ii ? parseFloat(row.imp_seguro_ii).toFixed(2) : "0,00"
        ),

        prodIIThc: MaskService.toMask(
          "decimal",
          row.imp_thc_capatazia
            ? parseFloat(row.imp_thc_capatazia).toFixed(2)
            : "0,00"
        ),
        prodIIValorAduaneiro: row.imp_aduaneiro_ii,
        prodIIOutros: MaskService.toMask(
          "decimal",
          row.imp_outrasdespesas_ii
            ? parseFloat(row.imp_outrasdespesas_ii).toFixed(2)
            : "0,00"
        ),
        prodIIImpostoImportacao: MaskService.toMask(
          "decimal",
          row.vl_ii ? parseFloat(row.vl_ii).toFixed(2) : "0,00"
        ),
        prodIIAfrmm: MaskService.toMask(
          "decimal",
          row.imp_afrmm ? parseFloat(row.imp_afrmm).toFixed(2) : "0,00"
        ),
        prodIICif: MaskService.toMask(
          "decimal",
          row.vl_bc_ii ? parseFloat(row.vl_bc_ii).toFixed(2) : "0,00"
        ),
        prodIIAliq: MaskService.toMask(
          "decimal",
          parseFloat(row.vl_alq_ii || "0.00").toFixed(2)
        ),
        prodIIBcImposto: row.vl_bc_ii,
        prodIIAliquota: row.vl_alq_ii,
        prodIIAliquotaRed: row.vl_alq_red_ii,
        prodIIDespesasAdu: row.imp_aduaneiro_ii,
        prodIIIof: row.vl_iof_ii,
        prodIIValorImposto: row.vl_ii,
        //B2b
        prodB2BNumero: row.b2b_numeropedidocompra,
        prodB2BItem: row.b2b_itempedidocompra,

        /*Tag cBenef*/
        prodIcmsCbenef: row.c_benef,

        /* Combustivel */
        prodFuelCodeAnp: row.cod_anp,
        prodFuelUf: row.uf_combust,
        prodFuelDescAnp: row.desc_anp,
        prodFuelGlpPetroleum: MaskService.changeUStoBR(
          row.perc_glp_derivado_petroleo || "0,00"
        ),
        prodFuelNationalGas: MaskService.changeUStoBR(
          row.perc_gas_natural_nacional || "0,00"
        ),
        prodFuelImportedGas: MaskService.changeUStoBR(
          row.perc_gas_natural_importado || "0,00"
        ),
        prodFuelValueWithoutICMS: MaskService.changeUStoBR(
          row.valor_partida_sem_icms || "0,00"
        ),

        /* Exportacao */
        exportDrawbackNumber:
          row.declaracao_exportacao_item?.nro_drawback || null,
        isIndirectExportation: !!row.declaracao_exportacao_item?.indireta,
        exportRegisterNumber:
          row.declaracao_exportacao_item?.nro_registro || null,
        exportAccessKey: row.declaracao_exportacao_item?.chave || null,
        exportQuantity: row.declaracao_exportacao_item?.qtd
          ? MaskService.toMask(
              "decimal",
              parseFloat(row.declaracao_exportacao_item?.qtd).toFixed(4)
            )
          : "0,0000",
      });
    });

    return itens;
  };

  const checkCsosn = (element) => {
    return (
      element?.prodIcmsSituacao?.value === "101" ||
      element?.prodIcmsSituacao?.value === "201"
    );
  };

  const handleCodeAnp = async (codigo) => {
    if (!codigo) return;
    let codeAnp;
    setLoading(true);

    try {
      codeAnp = await findAnpByCode(codigo);
      setProductFuelDescAnp(codeAnp.data.produto);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  //Função responsavel pela busca atráves do códigos
  const getCodeBarProduct = (product, origin) => {
    return {
      TabEmissaoDadosProduto: () => {
        if (queryParams.codigobarraslocalestoque === "SIM")
          return product.estoques[0].codigobarras || product.id;

        return product.codigo || product.codbarras_codigoalternativo;
      },
      AccordionEmissaoItens: () => {
        if (queryParams.codigobarraslocalestoque === "SIM")
          return product.prodCodigoBarrasEstoque || product.prodProdutoId;

        return product.prodCodigo;
      },
      WizardEmissaoController: () => {
        if (queryParams.codigobarraslocalestoque === "SIM")
          return product.codigobarras_estoque || product.id;

        return `${product.codigo}${
          queryParams.paramutilizatamanho === "SIM" && product.codigotamanho
            ? product.codigotamanho
            : ""
        }${
          queryParams.paramutilizacor === "SIM" && product.codigocor
            ? product.codigocor
            : ""
        }`;
      },
    }[origin]();
  };

  const getDescriptionProduct = (product, origin) => {
    return {
      TabEmissaoDadosProduto: () => {
        let description = product.descricao;

        if (
          queryParams.paramutilizatamanho === "SIM" &&
          product.estoques?.[0].tipotamanho
        )
          description += ` - ${product.estoques[0].tipotamanho.descricao}`;

        if (
          queryParams.paramutilizacor === "SIM" &&
          product.estoques?.[0].tipocor
        )
          description += ` - ${product.estoques[0].tipocor.descricao}`;

        return description.substring(0, 80);
      },
      AccordionEmissaoItens: () => {
        return product.prodDescricao.substring(0, 80);
      },
      WizardEmissaoController: () => {
        let description = product.descricao;

        if (
          queryParams.paramutilizatamanho === "SIM" &&
          product.descricaotamanho
        )
          description += ` - ${product.descricaotamanho}`;

        if (queryParams.paramutilizacor === "SIM" && product.descricaocor)
          description += ` - ${product.descricaocor}`;

        return description.substring(0, 80);
      },
    }[origin]();
  };

  const handleChangeSaleFinanceSwitch = () => {
    Swal.fire({
      icon: "question",
      text: "Ao desabilitar 'Financeiro da Venda'? Os valores de 'Condição de Pagamento' e 'Forma de Pagamento' serão atualizados. Ação irreversível!",
      cancelButtonText: "Cancelar",
      confirmButtonText: "Confirmar",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonColor: "#067ef5",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setSaleFinanceSwitch(false);
        setNfeFinancialIssue("NOTA");

        // Condição de pagamento de acordo com a validação da handleSetNfeData
        const paymentConditionCopy = JSON.parse(
          JSON.stringify(pagtoTableCobranca)
        );
        const filteredPaymentCondition = paymentConditionCopy.filter(
          (payment) =>
            payment.cobrancaSituacaoValue ===
            GlobalVariables.RecieveSituations.fullyLiquidated
        );

        setPagtoTableCobranca(filteredPaymentCondition);

        // Forma de pagamento de acordo com a validação da setNfeByDemand
        const paymentForm = [];
        const totals = calcTotalsNfe();
        paymentForm.push(
          createPaymentItem(
            MaskService.toMask(
              "decimal",
              parseFloat(totals.totalValueNFE).toFixed(2)
            )
          )
        );

        setPagtoTableFormaPagto(paymentForm);

        return true;
      }

      return false;
    });
  };

  const handleGetSeriesOptions = useCallback(
    async ({ production = false, serieNumber = "", model = "" }) => {
      try {
        setGetSeriesLoading(true);

        const environmentOptions =
          process.env.REACT_APP_AMBIENTE !== "MASTER"
            ? {
                isProduction: production ? 1 : 0,
              }
            : {};
        const listSeriesCallback = await getSeries({
          companyId: queryParams.empresa_id,
          ...environmentOptions,
        });

        if (!listSeriesCallback?.success)
          return notify(
            "Não foi possível obter a lista de séries!",
            true,
            "error"
          );

        const listNfeSerie = (listSeriesCallback.data || []).sort(
          (a, b) => a.serieNumber - b.serieNumber
        );

        let defaultSerie = null;

        if (!!serieNumber && !!model) {
          defaultSerie = listNfeSerie.find(
            (serie) =>
              (serie?.serieNumber || "").toString() === serieNumber &&
              serie?.model === model
          );
        } else if (listModels.length === 1) {
          defaultSerie = listNfeSerie.find(
            (serie) => serie?.default && serie?.model === listModels[0].value
          );
        }

        setHeaderSeriesOptions(listNfeSerie || []);
        setSelectedHeaderSeries(defaultSerie || null);
        setHeaderSeries(defaultSerie ? defaultSerie.serieNumber : "");
      } catch (error) {
        console.error(error);
        notify("Não foi possível obter a lista de séries!", true, "error");
      } finally {
        setGetSeriesLoading(false);
      }
    },
    [
      queryParams.empresa_id,
      setHeaderSeries,
      setHeaderSeriesOptions,
      setGetSeriesLoading,
      setSelectedHeaderSeries,
      listModels,
    ]
  );

  const handleOpenCloneNfe = useCallback(
    async (nfeIdProp) => {
      try {
        setCloneLoading(true);

        const callbackNfe = await findNotas(
          queryParams.empresa_cnpj,
          nfeIdProp,
          "itens.di.adicoes,itens.di.estado,itens.declaracaoExportacaoItem,locais,transportes.transportadora.estado,transportesvolumes,cobrancas,contasreceber,contasreceber.recebimentos,vendas.contasreceber.recebimentos,formaspagamentos,nfsRefs,nfeslotes,nfelotenf,dicontrole,autorizadoXml,estabelecimentoRural,estabelecimentoRural.endereco,estabelecimentoRural.endereco.municipio,estabelecimentoRural.endereco.estado,estabelecimentoRural.contatos"
        );

        if (!callbackNfe.success || !callbackNfe.data)
          return notify(
            "Não possivel recuperar os dados da nota fiscal, operação de clone não concluída."
          );

        await handleGetSeriesOptions({
          production: forceProduction,
          serieNumber: callbackNfe?.data?.serie,
          model: callbackNfe?.data?.modelo,
        });

        let callbackDestinatario = null;

        if (
          callbackNfe.data.clifor === GlobalVariables.nfeRecipientType.client
        ) {
          callbackDestinatario = await findCliente({
            empresa_cnpj: queryParams.empresa_cnpj,
            id: callbackNfe.data.idclifor,
            include:
              "estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado",
          });
        } else {
          callbackDestinatario = await findFornecedor(
            queryParams.empresa_cnpj,
            callbackNfe.data.idclifor,
            "estado,estabelecimentosRurais,estabelecimentosRurais.endereco,estabelecimentosRurais.contatos,estabelecimentosRurais.endereco.municipio,estabelecimentosRurais.endereco.estado"
          );
        }

        if (!callbackDestinatario.success || !callbackDestinatario.data)
          return notify(
            "Não possivel recuperar os dados de destinatário, operação de clone não concluída."
          );

        const destinatario = callbackDestinatario.data;

        const ruralEstablishmentNfe =
          callbackNfe?.data?.estabelecimento_rural || null;

        let isRuralProducer = destinatario?.produtor_rural;
        setIsRuralProducerSender(isRuralProducer);
        setSenderRuralEstablishment(
          isRuralProducer ? ruralEstablishmentNfe : null
        );
        setSenderRuralEstablishmentsList(destinatario?.estabelecimentos_rurais);

        const nfe = callbackNfe.data;
        const enderecoCobranca = {};
        const enderecoEntrega = {};
        let itens = [];
        const cobranca = [];
        const formapagamento = [];
        const transportadora = {};
        const volumes = [];
        const vendas = [];
        const nfsRefs = [];

        nfe.nfs_refs.forEach((nfRef, key) => {
          nfsRefs.push({
            index: key,
            docChaveAcesso: nfRef.refnfe,
            docModeloLabel: "NFe",
            docModeloValue: nfRef.modelo,
            refDocSerie: nfRef.numero_serie,
            refDocNumber: nfRef.numero_nfe,
            refDocIssueDate: nfRef.data_emissao,
          });
        });

        if (nfe.indintermed !== null) {
          setHeaderIndicatorIntermed(
            nfeListIntermed.find(
              (intermedType) => parseInt(intermedType.value) === nfe.indintermed
            )
          );
        }

        // Bloco para recuperar a informação do switch de financeiro da venda
        setSaleFinanceSwitch(false);
        setNfeFinancialIssue("NOTA");
        //

        setHeaderIntermedCnpj(nfe.intermed_cnpj);
        setHeaderIdentifierIntermed(nfe.intermed_identificador);

        setDiControle(nfe.dicontrole || []);
        setNfeLotes([]);
        setNfeValidXml("");

        nfe.locais.forEach((row) => {
          const city = listCounty.find(
            (county) => county.codigo === row.codigomunicipio
          );
          if (row.tipo === GlobalVariables.nfeSenderType.delivery) {
            enderecoEntrega["senderDeliveryAddress"] = row.endlogradouro;
            enderecoEntrega["senderDeliveryNumber"] = row.endnumero;
            enderecoEntrega["senderDeliveryDistrict"] = row.endbairro;
            enderecoEntrega["senderDeliveryCep"] = row.cep;
            enderecoEntrega["senderDeliveryComplement"] = row.endcomplemento;
            enderecoEntrega["senderDeliveryCodeCity"] = row.codigomunicipio;
            enderecoEntrega["senderDeliveryCity"] = city;
            enderecoEntrega["senderDeliveryUf"] = listUf.find(
              (uf) =>
                uf.codibge.toString() === (city?.estado_codigo || "").toString()
            );
          } else {
            enderecoCobranca["senderBillingAddress"] = row.endlogradouro;
            enderecoCobranca["senderBillingNumber"] = row.endnumero;
            enderecoCobranca["senderBillingDistrict"] = row.endbairro;
            enderecoCobranca["senderBillingCep"] = row.cep;
            enderecoCobranca["senderBillingComplement"] = row.endcomplemento;
            enderecoCobranca["senderBillingCity"] = city;
            enderecoCobranca["senderBillingUf"] = listUf.find(
              (uf) =>
                uf.codibge.toString() === (city?.estado_codigo || "").toString()
            );
          }
        });

        nfe.transportes.forEach((row) => {
          const arrAddressTransp = (row.endereco || "").split(",");

          transportadora["transp"] = row.transportadora;
          transportadora["transpAddress"] =
            arrAddressTransp[0] || row.novoendereco || "";
          transportadora["transpNumber"] =
            arrAddressTransp[1] || row.numero || "";
          transportadora["transpName"] = row.nome;
          transportadora["transpCnpj"] = row.cpfcnpj;
          transportadora["transpIe"] = row.ie;
          transportadora["transpRntc"] = row.rntc;
          transportadora["transpId"] = row.idtransportadora;
          transportadora["transpCityCode"] = row.codigomunicipio;
          transportadora["transpBoardcar"] = row.placaveiculo;
          transportadora["transpBoardcarUf"] = row.placaveiculouf;
          if (row.transportadora) {
            transportadora["transpUf"] = row.transportadora.estado;
            transportadora["transpCity"] = row.transportadora.cidade;
          } else if (
            nfe.modalidadefrete ===
            GlobalVariables.trasportModalities.proprioRemetente.value
          ) {
            transportadora["transpCity"] = queryParams.cidade;
            transportadora["transpUf"] = listUf.find(
              (element) => element.id === queryParams.id_estado
            );
          } else if (
            nfe.modalidadefrete ===
            GlobalVariables.trasportModalities.proprioDestinatario.value
          ) {
            transportadora["transpUf"] = destinatario.estado;
            transportadora["transpCity"] = destinatario.cidade;
          }
        });

        nfe.transportesvolumes.forEach((row, index) => {
          volumes.push({
            index: index,
            volQuantidade: parseInt(row.quantidade || 0),
            volEsp: row.especie,
            volMarca: row.marca,
            volNumeracao: row.numeracao,
            volPesoLiq: MaskService.toMask(
              "decimal",
              row.pesoliquido
                ? parseFloat(row.pesoliquido).toFixed(3)
                : "0,000",
              3
            ),
            volPesoBruto: MaskService.toMask(
              "decimal",
              row.pesobruto ? parseFloat(row.pesobruto).toFixed(3) : "0,000",
              3
            ),
          });
        });

        nfe.formaspagamentos.forEach((row, index) => {
          const pagtoForma = nfeListPaymentMethod.find(
            (value) => row.codigo === value.value
          );

          const pagtoIndicador = nfeListPaymentIndicator.find(
            (value) => row.indpag === value.value
          );

          const pagtoInt = nfeListPaymentTypeIntegration.find(
            (value) => row.tpintegra === value.value
          );

          const pagtoBandeira = nfeListBandeiras.find(
            (value) => row.bandeira_cartao === value.id.toString()
          );

          formapagamento.push({
            index: index,
            pagtoFormaLabel: pagtoForma ? pagtoForma.label : "",
            pagtoFormaValue: pagtoForma ? pagtoForma.value : "",
            pagtoValor: MaskService.toMask(
              "decimal",
              parseFloat(row.valor).toFixed(2)
            ),
            pagtoIndicadorLabel: pagtoIndicador ? pagtoIndicador.label : "",
            pagtoIndicadorValue: pagtoIndicador ? pagtoIndicador.value : "",
            pagtoCnpjCred: row.cnpj_credenciadora_cartao,
            pagtoIntLabel: pagtoInt ? pagtoInt.label : "",
            pagtoIntValue: pagtoInt ? pagtoInt.value : "",
            pagtoTroco: MaskService.toMask(
              "decimal",
              parseFloat(row.vl_troco).toFixed(2)
            ),
            pagtoCodigoCartao: row.codigo_autorizacao_cartao,
            pagtoBandeiraLabel: pagtoBandeira?.sn_descricao || "",
            pagtoBandeiraValue: pagtoBandeira?.id || "",
          });
        });

        nfe.vendas.forEach((element) => {
          if (element.contasreceber.length)
            nfe.contasreceber.unshift(element.contasreceber[0]);
        });

        let dueDate = formatDate({
          date: new Date(),
          separator: "-",
          format: "yyyy-mm-dd",
        });
        let dueDateLabel = dueDate.split("-").reverse().join("/");

        nfe?.cobrancas?.forEach((row, index) => {
          let auxNro = (index + 1).toString();

          cobranca.push({
            index: index,
            cobrancaNro: auxNro.padStart(3, "0"),
            cobrancaValor: MaskService.toMask(
              "decimal",
              parseFloat(row.valor || 0).toFixed(2)
            ),
            cobrancaDtVenctoValue: dueDate,
            cobrancaDtVencto: dueDateLabel,
            cobrancaValorPago: "0,00",
            cobrancaSituacao: situations["00"],
            cobrancaSituacaoValue: GlobalVariables.RecieveSituations.inWallet,
            cobrancaDestacaDanfe: true,
            id: null,
            itemCr: null,
          });
        });

        const itensAtualizados = await Promise.all(
          nfe.itens.map(async (row) => {
            const product = await findProdutosAlternativeFormatted({
              empresa_cnpj: queryParams.empresa_cnpj,
              where: {
                active: "SIM",
                codeBar: row.codigo,
              },
            });

            const callbackTrib = await findTributacoes(
              queryParams.empresa_cnpj,
              {
                ncm: row.ncm,
                cfop: row.cfop,
              }
            );
            const tributacoes = callbackTrib.data[0];

            let idproduto = product.data[0]?.id;
            return { ...row, idproduto, tributacoes };
          })
        );

        nfe.itens = itensAtualizados;

        itens = returnBuiltNfeItems(nfe);

        // //  REMOVE IDS DOS ITENS
        itens.forEach((item) => {
          item.idItem = null;
          return item;
        });

        const nfeData = {
          notafiscal: {
            /* Auxiliares */
            nfeId: null,
            headerIssueType: nfe.tipoemissao,
            nfeStatus: "D",
            nfeMontageSubtype: nfe.tipo_montagem,
            saveBlocked: false,
            isClone: true,

            /* Cabeçalho */
            headerIssueTime: null,
            headerTime: null,
            headerDateJL: formatDate({
              date: new Date(),
              separator: "-",
              format: "yyyy-mm-dd",
            }),
            headerNfe: "",
            headerSeries: nfe.serie,
            headerIssueDate: null,
            headerAccessKey: "",
            headerTypeNfe: nfeListTypeNf.find(
              (value) => nfe.tipo === value.value
            ),
            headerCfop: nfe.cfop || "",
            headerOperationNature: nfe.naturezaoperacao || "",
            headerPresentOperation: nfeListPresentOperations.find(
              (value) => nfe.indpres === value.value
            ),
            headerFinalCostumer: nfeListYesOrNo.find(
              (value) => nfe.indfinal === value.value
            ),
            headerOperation: nfeListOperations.find(
              (value) => nfe.iddest === value.value
            ),
            headerFinnally: nfeListFinnally.find(
              (value) => nfe.finalidade === value.value
            ),
            headerIeTax: nfe.iest || "",
            headerPurchaseOrder: nfe.b2b_pedidocompra || "",
            headerPurchaseContract: nfe.b2b_contratocompra || "",
            headerPurchasePublic: nfe.b2b_notaempenho || "",

            /*Modalidade da Transportadora */
            transpModality: nfeListModalities.find(
              (value) => nfe.modalidadefrete === value.value
            ),
            exportShipmentLocation: nfe.xlocexporta,
            exportDispatchLocation: nfe.xlocdespacho,
            ufExport: (nfe?.codigoufsaidapais || "").trim().length
              ? Estados.find((value) => value.estado === nfe.codigoufsaidapais)
              : {},
          },

          dadosDi: nfe?.itens[0]?.di
            ? {
                diNumeroRegistro: nfe?.itens[0]?.di?.numerodi || "",
                diDataRegistro: (nfe?.itens[0]?.di?.dataregistro || "").slice(
                  0,
                  10
                ),
                diDrawback: nfe?.itens[0]?.di?.drawback || "",
                diLocalDes: nfe?.itens[0]?.di?.cidade || "",
                diUfDes: nfe?.itens[0]?.di?.id_estado
                  ? listUf.find(
                      (uf) => uf.id === nfe?.itens[0]?.di?.id_estado.toString()
                    )
                  : null,
                diDataDes: (nfe?.itens[0]?.di?.datadesembaraco || "").slice(
                  0,
                  10
                ),
                diImpWayOf: nfe.imp_via_tranporte
                  ? listViaTransporte.find(
                      (way) => way.value === Number(nfe.imp_via_tranporte)
                    )
                  : null,
                diIntermediaryType: nfe.imp_intermediacao
                  ? diIntermediaryTypeList.find(
                      (way) => way.value === Number(nfe.imp_intermediacao)
                    )
                  : null,
                diAcquirerUf: nfe.imp_idestado
                  ? listUf.find((uf) => uf.id === nfe.imp_idestado.toString())
                  : null,
                diAcquirerDocument: nfe.imp_cnpj_adquirente || "",
              }
            : {},

          observacoes:
            {
              obsText: nfe.dadosadicionais,
              obsTextCFOP: nfe.dadosadicionais_cfop,
              obsTextCreditRate: nfe.dadosadicionais_creditrate,
              obsTextComplemento: nfe.dadosadicionais_complemento,
            } || "",

          /* Cliente ou Fornecedor */
          destinatario: {
            sender: destinatario,
            senderId: nfe.idclifor,
            senderClifor: nfe.clifor,
            senderIe: nfe.ie,
            senderIndicationIe:
              senderListIndicationIe.find(
                (indication) => indication.codigo === nfe.indiedest
              ) || null,
            senderCityCode: nfe.codigomunicipio,
            senderCountryCode: nfe.codigopais,
            senderName: nfe.nome,
            senderCnpj: nfe.cpfcnpj,
            senderAddres: nfe.endlogradouro || "",
            senderNumber: nfe.endnumero || "",
            senderDistrict: nfe.endbairro,
            senderCity: destinatario.cidade,
            senderUfLabel: destinatario?.estado?.estado,
            senderCep: nfe.cep,
            senderPhone: nfe.telefone,
            senderMail: nfe.email,
            senderUf: destinatario.id_estado,
          },

          /* Totalizadores dos Cálculos */
          totalizadores: {
            totalNfe: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_nf).toFixed(2)
            ),
            totalValueIcms: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms).toFixed(2)
            ),
            totalBaseIcms: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_bc_icms).toFixed(2)
            ),
            totalIcmsFcp: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms_fcp).toFixed(2)
            ),
            totalIcmsDes: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icmsdeson).toFixed(2)
            ),
            totalValueSt: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms_st).toFixed(2)
            ),
            totalBaseSt: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_bc_icms_st).toFixed(2)
            ),
            totalStFcp: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_icms_fcp_st).toFixed(2)
            ),
            totalValueIpi: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_ipi).toFixed(2)
            ),
            totalValuePis: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_pis).toFixed(2)
            ),
            totalValueCofins: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_cofins).toFixed(2)
            ),
            totalFreight: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_frete).toFixed(2)
            ),
            totalSafe: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_seguro).toFixed(2)
            ),
            totalOthers: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_outras).toFixed(2)
            ),
            totalDiscount: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_desconto).toFixed(2)
            ),
            totalProductValue: MaskService.toMask(
              "decimal",
              parseFloat(nfe.vl_produtos).toFixed(2)
            ),
          },

          itens: itens,
          enderecoCobranca: enderecoCobranca,
          enderecoEntrega: enderecoEntrega,
          cobranca: cobranca,
          formapagamento: formapagamento,
          transportadora: transportadora,
          volumes: volumes,
          vendas: vendas,
          nfsRefs: nfsRefs,
        };

        handleSetNfeData(nfeData);
        setNfCloneId(nfeIdProp);
      } catch (error) {
        console.error("Clone Nfe Error: ", error);
      } finally {
        setCloneLoading(false);
      }
    },
    [
      diIntermediaryTypeList,
      handleSetNfeData,
      listCounty,
      listUf,
      listViaTransporte,
      nfeListBandeiras,
      nfeListFinnally,
      nfeListIntermed,
      nfeListModalities,
      nfeListOperations,
      nfeListPaymentIndicator,
      nfeListPaymentMethod,
      nfeListPaymentTypeIntegration,
      nfeListPresentOperations,
      nfeListTypeNf,
      nfeListYesOrNo,
      queryParams?.cidade,
      queryParams?.empresa_cnpj,
      queryParams?.id_estado,
      returnBuiltNfeItems,
      senderListIndicationIe,
      setDiControle,
      setHeaderIdentifierIntermed,
      setHeaderIndicatorIntermed,
      setHeaderIntermedCnpj,
      setCloneLoading,
      setNfeFinancialIssue,
      setNfeLotes,
      setNfeValidXml,
      setSaleFinanceSwitch,
      setNfCloneId,
      situations,
      handleGetSeriesOptions,
      forceProduction,
      setIsRuralProducerSender,
      setSenderRuralEstablishment,
      setSenderRuralEstablishmentsList,
    ]
  );

  const handleOpenSalesOrder = useCallback(
    async ({ saleId, clientDocument, saveButtonRef }) => {
      try {
        setSalesOrderLoading(true);

        const saleOrderResponse = await findVendas({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: saleId,
          per_page: 9999,
          include:
            "vendasitens,vendasitens.estoque,vendasitens.estoque.produto,contasreceber,contasreceber.recebimentos,formaspagtos,vendasformaspagtos,vendasformaspagtos.tipopagtos,vendasformaspagtos.formapagto",
        });

        if (!saleOrderResponse.success)
          return notify(
            saleOrderResponse.message || "Erro ao buscar pedido de venda."
          );

        const saleOrder = saleOrderResponse?.data || null;

        if (!saleOrder) return notify("Pedido de venda não encontrado.");

        let tipoDocumento = `${GlobalVariables.taxation.documentType.all},${GlobalVariables.taxation.documentType.invoice},${GlobalVariables.taxation.documentType.taxCoupon}`;
        let tipoDestinatario = `${GlobalVariables.taxation.recipientType.all}`;

        const productsResponse = await itensNfAutoMontagem(
          queryParams.empresa_cnpj,
          queryParams.id,
          {
            ids: [saleId],
            orderBy: "vendasitens_id",
            tipoDocumento,
            tipoDestinatario,
          },
          "empresa,tributacaost"
        );

        if (!productsResponse?.success)
          return notify("Falha ao buscar produtos");

        if (!productsResponse?.data?.length)
          return notify("Pedido de venda não possui itens.");

        const montageSelectedItemTaxationcopy = {
          ...montageSelectedItemTaxation,
        };

        let notifyTributacao = false;

        const itensResponse = productsResponse?.data?.filter((product) => {
          return product.travarcf !== "1" && product.travarnf !== "1";
        });

        itensResponse.forEach((product) => {
          if (!montageSelectedItemTaxationcopy[product.id]) {
            montageSelectedItemTaxationcopy[product.id] = {};
          }

          product.tributacoes = (product?.tributacoes || []).filter(
            taxationByCompany
          );

          const priorityMap = new Map([
            [GlobalVariables.taxation.documentType.taxCoupon, 1],
            [GlobalVariables.taxation.documentType.all, 2],
            [GlobalVariables.taxation.documentType.invoice, 3],
          ]);

          product.tributacoes.sort((a, b) => {
            const aPriority = priorityMap.get(a.tipo_documento) ?? Infinity;
            const bPriority = priorityMap.get(b.tipo_documento) ?? Infinity;
            return aPriority - bPriority;
          });

          montageSelectedItemTaxationcopy[product.id][product.precounitario] =
            (product?.tributacoes || [])[0] || null;

          if (!product?.tributacoes?.length) {
            notifyTributacao = true;
          }
        });

        if (notifyTributacao) {
          notify(
            "Venda(s) possui produto(s) sem tributação cadastrada.",
            true,
            "warning"
          );
        }

        var unitedProducts = {};
        itensResponse.forEach((product) => {
          let key = `${product.id}|${product.precounitario}|${product.desconto}|${product.complemento}`;

          if (!unitedProducts[key]) {
            let vlrTotalBruto =
              parseFloat(product.qtde) *
              (parseFloat(product.precounitario) *
                parseFloat(product.diporc ? product.diporc / 100 + 1 : 1));
            unitedProducts[key] = {
              ...product,
              key,
              vlr_total: vlrTotalBruto,
              vlr_total_liquido: vlrTotalBruto - parseFloat(product.desconto),
              notSelectable: product.travarnf === "1",
              backgroundColor: product.travarnf === "1" ? "#e2e3e5" : "#fefefe",
            };
          } else {
            let newQuantity =
              parseFloat(unitedProducts[key].qtde) + parseFloat(product.qtde);
            let newDiscount =
              parseFloat(unitedProducts[key].desconto) +
              parseFloat(product.desconto);

            let vlrTotalBruto =
              parseFloat(unitedProducts[key].precounitario) *
              parseFloat(
                unitedProducts[key].diporc
                  ? unitedProducts[key].diporc / 100 + 1
                  : 1
              );

            unitedProducts[key] = {
              ...unitedProducts[key],
              key,
              qtde: newQuantity,
              vlr_total: newQuantity * vlrTotalBruto,
              desconto: newDiscount,
              vlr_total_liquido: newQuantity * vlrTotalBruto - newDiscount,
              notSelectable: product.travarnf === "1",
              backgroundColor: product.travarnf === "1" ? "#e2e3e5" : "#fefefe",
            };
          }
        });

        setMontageSelectedItemTaxation(montageSelectedItemTaxationcopy);

        const saleOrderItems = Object.values(unitedProducts);

        const itens = [];
        const cobranca = [];
        const volumes = [];
        const vendas = [];
        let transportadora = null;
        const formapagamento = [];
        const finalidadeNota = [];

        const destinatario = {
          senderClifor: "C",
          senderCnpj: clientDocument || "",
        };

        let idsCrs = [];
        let cobrancaIndex = 0;
        let pagtoIndex = 0;
        let totalDemands = 0;
        let obsVenda = "";
        let tiposFrete = [];
        let modalidadeTransporte =
          GlobalVariables.trasportModalities.semOcorrencia;
        let enderecoEntrega = [];

        vendas.push(saleOrder.id);

        obsVenda = saleOrder.obsnfe || "";

        let cashPayment = true;

        saleOrder.contasreceber?.forEach((cr, index) => {
          idsCrs.push(cr.id);

          const recebimentos = cr.recebimentos;

          let valorPago = 0;
          if (recebimentos.length) {
            const payment = recebimentos.find(
              (recebimento) => cr.id === recebimento.pivot.idcontasreceber
            );
            valorPago = payment ? payment.pivot.valor : 0;
          }

          if (cashPayment && moment(cr.datavencto).isAfter(moment(), "day")) {
            cashPayment = false;
          }

          cobranca.push(
            createChargeItem(
              cobrancaIndex,
              "-",
              MaskService.toMask(
                "decimal",
                parseFloat(cr.valordoctooriginal).toFixed(2)
              ),
              cr.datavencto,
              cr.datavencto.split("-").reverse().join("/"),
              MaskService.toMask("decimal", parseFloat(valorPago).toFixed(2)),
              situations[cr.situacaodocto],
              cr.situacaodocto,
              false,
              cr.id,
              cr
            )
          );

          cobrancaIndex++;
        });

        if (saleOrder.vendasformaspagtos.length) {
          saleOrder.vendasformaspagtos.forEach((form) => {
            const foundIndex = formapagamento.findIndex(
              (e) => e.pagtoFormaValue === form.tipopagtos?.codigo_nfce
            );

            /* Atualiza o Item e vai agrupando */
            if (typeof foundIndex === "number" && foundIndex !== -1) {
              let attItem = formapagamento[foundIndex];

              const value =
                MaskService.removeMaskDecimal(attItem.pagtoValor || "0") +
                parseFloat(form.valor || "0");
              attItem.pagtoValor = MaskService.toMask(
                "decimal",
                parseFloat(value).toFixed(2)
              );
              formapagamento[foundIndex] = attItem;
            } else {
              /* Cria um novo item */
              if (form.tipopagtos) {
                const pagtoItem = nfeListPaymentMethod.find(
                  (item) => item.value === form.tipopagtos.codigo_nfce
                );

                formapagamento.push(
                  createPaymentItem(
                    MaskService.toMask(
                      "decimal",
                      parseFloat(form.valor || "0").toFixed(2)
                    ),
                    pagtoIndex,
                    pagtoItem ? pagtoItem.label : "Outros",
                    pagtoItem ? pagtoItem.value : "99",
                    form.tipopagtos.codigo_nfce === "03" || !cashPayment
                      ? "Pagamento à Prazo"
                      : "Pagamento à Vista",
                    form?.tipopagtos?.codigo_nfce === "03" || !cashPayment
                      ? "1"
                      : "0",
                    "0,00",
                    "",
                    "",
                    additionalPaymentsInfo.includes(pagtoItem?.value)
                      ? nfeListPaymentTypeIntegration[1].label
                      : null,
                    additionalPaymentsInfo.includes(pagtoItem?.value)
                      ? nfeListPaymentTypeIntegration[1].value
                      : null
                  )
                );
              } else {
                formapagamento.push(
                  createPaymentItem(
                    MaskService.toMask(
                      "decimal",
                      parseFloat(form.valor || "0").toFixed(2)
                    ),
                    pagtoIndex
                  )
                );
              }
            }

            pagtoIndex++;
            totalDemands += parseFloat(form?.valor || 0);
          });
        }

        if (
          saleOrder.tipofrete &&
          saleOrder.tipofrete.trim() &&
          !tiposFrete.includes(saleOrder?.tipofrete?.trim())
        ) {
          tiposFrete.push(saleOrder.tipofrete.trim());
        }

        if (tiposFrete.length === 1) {
          modalidadeTransporte = nfeListModalities.find(
            (modality) => modality.value === tiposFrete[0]
          );
        }

        /* Guardando Ids Do Contas Para Posterior Atualização */
        setIdsCrsMontage(idsCrs);

        const newTaxation = [...taxations];

        saleOrderItems.forEach((saleItem, key) => {
          let itemTaxation =
            montageSelectedItemTaxationcopy[saleItem.id]?.[
              saleItem.precounitario
            ];

          if (itemTaxation) newTaxation.push(itemTaxation);

          if (!itemTaxation) itemTaxation = {};

          let cfopToItem = "";
          if (itemTaxation.cfop) {
            cfopToItem = itemTaxation.cfop;
            saleItem.cfop = itemTaxation.cfop;
          } else {
            cfopToItem = queryParams.cfopsaidapadrao;
          }

          const cfopItemList = nfeListCfop.find(
            (value) => cfopToItem === value.cfop
          );

          const stockLocationItemList = nfeListStockLocation.find(
            (value) => saleItem.idlocalestoque === value.id
          );

          const formattedDiscountRow = {
            ...saleItem,
            desconto: MaskService.toMask(
              "decimal",
              saleItem.desconto
                ? parseFloat(saleItem.desconto).toFixed(5)
                : "0.00000",
              5
            ),
          };

          let itemTributacaoSt = itemTaxation.tributacaost?.filter(
            (tri) => tri.ufdestino === saleItem.estado
          );

          if (itemTributacaoSt) {
            itemTaxation.tributacaost = [...itemTributacaoSt];
          }

          /* Get das tributações tratadas*/
          const geralTaxation = {
            taxIcms: calcsIcmsTaxations(itemTaxation, formattedDiscountRow),
            taxIcmsSt: calcsIcmsStTaxations(itemTaxation, formattedDiscountRow),
            taxIpi: calcsIpiTaxations(itemTaxation, formattedDiscountRow),
            taxPis: calcsPisTaxations(itemTaxation, formattedDiscountRow),
            taxCofins: calcsCofinsTaxations(itemTaxation, formattedDiscountRow),
            others: {
              prodCfopItemList: cfopItemList,
              prodLocalEstoque: stockLocationItemList,
            },
          };
          itens.push(createProductItem(key, geralTaxation, saleItem));
        });

        for (const row of itens) {
          const callbackVerificationDifal = await handleVerificationDifal({
            ncm: row.prodNcm,
            cfop: row.prodCfop,
            ufDestino: row.prodFuelUf,
            difalChecked: row.prodDifal,
          });
          itens.prodDifal = [...callbackVerificationDifal.difalUfDestino];
        }

        const totals = calcTotalsNfe(itens);

        if (totals.totalValueNFE && totals.totalValueNFE > totalDemands) {
          if (
            parseFloat(
              parseFloat(totals.totalValueNFE - totalDemands).toFixed(2)
            ) !== 0
          ) {
            formapagamento.push(
              createPaymentItem(
                MaskService.toMask(
                  "decimal",
                  parseFloat(totals.totalValueNFE - totalDemands).toFixed(2)
                )
              )
            );
          }
        } else if (
          totals.totalValueNFE &&
          totals.totalValueNFE < totalDemands
        ) {
          const totalToDistrib = totals.totalValueNFE;
          const rateioFactor = totalToDistrib / formapagamento.length;
          let sumRateio = 0;

          formapagamento.forEach((pagto) => {
            let valor = parseFloat((rateioFactor || 0).toFixed(2));

            if (sumRateio + valor > totalToDistrib) {
              valor = parseFloat((totalToDistrib - sumRateio).toFixed(2));
            }

            pagto.pagtoValor = MaskService.toMask("decimal", valor.toFixed(2));

            sumRateio += valor;
          });
        }

        const observacoes = {
          obsTextComplemento: obsVenda,
        };
        const body = {
          itens: itens,
          destinatario: destinatario,
          cobranca: cobranca,
          formapagamento: formapagamento,
          volumes: volumes,
          vendas: vendas,
          transportadora: transportadora,
          observacoes: observacoes,
          transpModality: modalidadeTransporte,
          enderecoEntrega: enderecoEntrega,
          finalidadeNota: finalidadeNota,
        };

        handleSetNfeData(body);

        let copyListModels = [...defaultListModels];

        let defaultSerie = null;

        defaultSerie = headerSeriesOptions.find(
          (serie) => serie?.default && serie?.model === "65"
        );

        setHeaderModel(
          copyListModels.find((model) => model.value === "65") || null
        );

        setSelectedHeaderSeries(defaultSerie || null);
        setHeaderSeries(defaultSerie ? defaultSerie.serieNumber : "");
        setSaleFinanceSwitch(true);
        setNfeFinancialIssue("VENDA");
        setNfeMontageSubtype("V");
        setNfeMontageType("A");
        setTempQueryParams({});

        if (saveButtonRef) {
          const y =
            saveButtonRef.current.getBoundingClientRect().top +
            window.pageYOffset;
          window.scrollTo({ top: y - 100, behavior: "smooth" });

          saveButtonRef.current.classList.add("pulse");
          setTimeout(() => {
            saveButtonRef.current.classList.remove("pulse");
          }, 5000);
        }
      } catch (error) {
        console.error("Error on open sales order", error);
        notify("Erro ao abrir pedido de venda", true, "error");
      } finally {
        setSalesOrderLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      defaultListModels,
      queryParams?.empresa_cnpj,
      queryParams?.id,
      setHeaderModel,
      setSalesOrderLoading,
      setSenderCnpj,
      nfeListCfop,
      nfeListStockLocation,
      queryParams?.cfopsaidapadrao,
      headerSeriesOptions,
      listUf,
      listCounty,
    ]
  );

  return {
    handleSetNfeData,
    handleTransmitNfe,
    handleSelectClient,
    handleCheckCobranca,
    handleSelectProduct,
    handleSelectShippingCompany,
    handleQuantityProduct,
    handleSetQuantityTrib,
    handleAddItemDi,
    handleAddProduct,
    handleAddCharge,
    handleAddPayment,
    handleAddAccesKey,
    handleAddSizes,
    handleSaveNota,
    handleTypeNfe,
    handleCalcSizes,
    handleSelectProvider,
    handleSetTaxation,
    handleSelectDeliveryAddress,
    handleCfop,
    handleConfirmActionItem,
    handleEditItemProduct,
    handleCalcItensTable,
    handleCalcChargeTable,
    handleEditCharge,
    handleEditPayment,
    handleEditSize,
    handleEditAccessKey,
    handleSelectNcm,
    handleCalcPaymentTable,
    handleNcm,
    handleVerificationDifal,
    handleOpenNfe,
    handleDetachDanfe,
    handleSearchProductByCode,
    handleSelectProductBySelect,
    handleDialogShippingCompany,
    handleSearchSelectShippingCompany,
    handleTotalsRecalculation,
    handleShippingModality,
    createPaymentItem,
    createProductItem,
    createChargeItem,
    clearNfe,
    setEnableEndereco,
    clearProductItem,
    volError,
    setVolError,
    chargeDueDate,
    setChargeDueDate,
    chargeError,
    setChargeError,
    enableDeliveryEdit,
    setEnableDeliveryEdit,
    enableBillingEdit,
    setEnableBillingEdit,
    enableEndereco,
    diNumber,
    setDiNumber,
    diRegisterDate,
    setDiRegisterDate,
    diClearanceUf,
    setDiClearanceUf,
    diClearancePlace,
    setDiClearancePlace,
    diDateDes,
    setDiDateDes,
    diDrawback,
    setDiDrawback,
    diSequence,
    setDiSequence,
    diAdd,
    setDiAdd,
    chargeMaturities,
    setChargeMaturities,
    paymentError,
    setPaymentError,
    paymentMethod,
    setPaymentMethod,
    paymentIndicator,
    setPaymentIndicator,
    paymentTransshipment,
    setPaymentTransshipment,
    paymentTypeIntegration,
    setPaymentTypeIntegration,
    paymentFlag,
    setPaymentFlag,
    paymentCnpj,
    setPaymentCnpj,
    paymentCodeCard,
    setPaymentCodeCard,
    docError,
    setDocError,
    docAccessKey,
    setDocAccessKey,
    refDocSerie,
    setRefDocSerie,
    refDocNumber,
    setRefDocNumber,
    refDocIssueDate,
    setRefDocIssueDate,
    docFreightModality,
    getDescriptionProduct,
    setDocFreightModality,
    volQuantity,
    setVolQuantity,
    volEsp,
    setVolEsp,
    volBrand,
    setVolBrand,
    volNumber,
    setVolNumber,
    volNetWeight,
    setVolNetWeight,
    volGrossWeight,
    setVolGrossWeight,
    handleFinallyNfe,
    clearTransp,
    searchTaxation,
    createProductDi,
    handleCreditRate,
    taxationByCompany,
    taxationIsNotCf,
    checkCsosn,
    handleChangeCep,
    filterByState,
    handleCodeAnp,
    paymentOperator,
    setPaymentOperator,
    handlePaymentOperatorByFlag,
    refreshOperatorCnpj,
    getCodeBarProduct,
    setRefreshOperatorCnpj,
    handleChangeSaleFinanceSwitch,
    autDocumentType,
    setAutDocumentType,
    autDocumentNumber,
    setAutDocumentNumber,
    handleEditXmlAuthorized,
    handleAddXmlAuthorized,
    modalXmlAuthorizedError,
    setModalXmlAuthorizedError,
    handleOpenCloneNfe,
    handleSenderRuralEstablishmentSelection,
    handleGetSeriesOptions,
    returnBuiltNfeItems,
    clearClient,
    handleOpenSalesOrder,
  };
}
